import { Injectable, ɵɵdefineInjectable, ɵɵinject, NgModule } from '@angular/core';
import { HttpParams, HttpHeaders, HttpRequest, HttpResponse, HttpClient, HttpClientModule } from '@angular/common/http';
import { filter, map } from 'rxjs/operators';

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/list-analysis-datasets-include-flags.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
import * as ɵngcc0 from '@angular/core';
var ListAnalysisDatasetsIncludeFlags;
(function (ListAnalysisDatasetsIncludeFlags) {
    ListAnalysisDatasetsIncludeFlags.TOTAL_ITEM_COUNT = 'TotalItemCount';
    ListAnalysisDatasetsIncludeFlags.INPUT_SAMPLES = 'InputSamples';
    /**
     * @return {?}
     */
    function values() {
        return [
            ListAnalysisDatasetsIncludeFlags.TOTAL_ITEM_COUNT,
            ListAnalysisDatasetsIncludeFlags.INPUT_SAMPLES
        ];
    }
    ListAnalysisDatasetsIncludeFlags.values = values;
})(ListAnalysisDatasetsIncludeFlags || (ListAnalysisDatasetsIncludeFlags = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/analysis-dataset-sort-fields.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var AnalysisDatasetSortFields;
(function (AnalysisDatasetSortFields) {
    AnalysisDatasetSortFields.TIME_CREATED = 'TimeCreated';
    AnalysisDatasetSortFields.DEFAULT = 'Default';
    /**
     * @return {?}
     */
    function values() {
        return [
            AnalysisDatasetSortFields.TIME_CREATED,
            AnalysisDatasetSortFields.DEFAULT
        ];
    }
    AnalysisDatasetSortFields.values = values;
})(AnalysisDatasetSortFields || (AnalysisDatasetSortFields = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/sort-direction.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var SortDirection;
(function (SortDirection) {
    SortDirection.ASC = 'Asc';
    SortDirection.DESC = 'Desc';
    SortDirection.ASCENDING = 'Ascending';
    SortDirection.DESCENDING = 'Descending';
    /**
     * @return {?}
     */
    function values() {
        return [
            SortDirection.ASC,
            SortDirection.DESC,
            SortDirection.ASCENDING,
            SortDirection.DESCENDING
        ];
    }
    SortDirection.values = values;
})(SortDirection || (SortDirection = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/get-analysis-definition-include-flags.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var GetAnalysisDefinitionIncludeFlags;
(function (GetAnalysisDefinitionIncludeFlags) {
    GetAnalysisDefinitionIncludeFlags.COMPATIBLE_LIBRARY_PREP_KITS = 'CompatibleLibraryPrepKits';
    GetAnalysisDefinitionIncludeFlags.ANALYSIS_VERSIONS = 'AnalysisVersions';
    /**
     * @return {?}
     */
    function values() {
        return [
            GetAnalysisDefinitionIncludeFlags.COMPATIBLE_LIBRARY_PREP_KITS,
            GetAnalysisDefinitionIncludeFlags.ANALYSIS_VERSIONS
        ];
    }
    GetAnalysisDefinitionIncludeFlags.values = values;
})(GetAnalysisDefinitionIncludeFlags || (GetAnalysisDefinitionIncludeFlags = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/analysis-definition-status.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var AnalysisDefinitionStatus;
(function (AnalysisDefinitionStatus) {
    AnalysisDefinitionStatus.ACTIVE = 'Active';
    AnalysisDefinitionStatus.INACTIVE = 'Inactive';
    /**
     * @return {?}
     */
    function values() {
        return [
            AnalysisDefinitionStatus.ACTIVE,
            AnalysisDefinitionStatus.INACTIVE
        ];
    }
    AnalysisDefinitionStatus.values = values;
})(AnalysisDefinitionStatus || (AnalysisDefinitionStatus = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/illumina-kit-support-mode.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var IlluminaKitSupportMode;
(function (IlluminaKitSupportMode) {
    IlluminaKitSupportMode.ALL = 'All';
    IlluminaKitSupportMode.COMPATIBLE = 'Compatible';
    IlluminaKitSupportMode.NONE = 'None';
    /**
     * @return {?}
     */
    function values() {
        return [
            IlluminaKitSupportMode.ALL,
            IlluminaKitSupportMode.COMPATIBLE,
            IlluminaKitSupportMode.NONE
        ];
    }
    IlluminaKitSupportMode.values = values;
})(IlluminaKitSupportMode || (IlluminaKitSupportMode = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/list-analysis-definitions-include-flags.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var ListAnalysisDefinitionsIncludeFlags;
(function (ListAnalysisDefinitionsIncludeFlags) {
    ListAnalysisDefinitionsIncludeFlags.TOTAL_ITEM_COUNT = 'TotalItemCount';
    ListAnalysisDefinitionsIncludeFlags.ANALYSIS_VERSIONS = 'AnalysisVersions';
    /**
     * @return {?}
     */
    function values() {
        return [
            ListAnalysisDefinitionsIncludeFlags.TOTAL_ITEM_COUNT,
            ListAnalysisDefinitionsIncludeFlags.ANALYSIS_VERSIONS
        ];
    }
    ListAnalysisDefinitionsIncludeFlags.values = values;
})(ListAnalysisDefinitionsIncludeFlags || (ListAnalysisDefinitionsIncludeFlags = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/analysis-definition-sort-fields.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var AnalysisDefinitionSortFields;
(function (AnalysisDefinitionSortFields) {
    AnalysisDefinitionSortFields.NAME = 'Name';
    AnalysisDefinitionSortFields.DISPLAY_NAME = 'DisplayName';
    AnalysisDefinitionSortFields.TIME_CREATED = 'TimeCreated';
    AnalysisDefinitionSortFields.DEFAULT = 'Default';
    /**
     * @return {?}
     */
    function values() {
        return [
            AnalysisDefinitionSortFields.NAME,
            AnalysisDefinitionSortFields.DISPLAY_NAME,
            AnalysisDefinitionSortFields.TIME_CREATED,
            AnalysisDefinitionSortFields.DEFAULT
        ];
    }
    AnalysisDefinitionSortFields.values = values;
})(AnalysisDefinitionSortFields || (AnalysisDefinitionSortFields = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/analysis-version-definition-status.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var AnalysisVersionDefinitionStatus;
(function (AnalysisVersionDefinitionStatus) {
    AnalysisVersionDefinitionStatus.ACTIVE = 'Active';
    AnalysisVersionDefinitionStatus.INACTIVE = 'Inactive';
    /**
     * @return {?}
     */
    function values() {
        return [
            AnalysisVersionDefinitionStatus.ACTIVE,
            AnalysisVersionDefinitionStatus.INACTIVE
        ];
    }
    AnalysisVersionDefinitionStatus.values = values;
})(AnalysisVersionDefinitionStatus || (AnalysisVersionDefinitionStatus = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/analysis-type.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var AnalysisType;
(function (AnalysisType) {
    AnalysisType.LOCAL = 'Local';
    AnalysisType.CLOUD_RUN = 'CloudRun';
    AnalysisType.CLOUD_RUN_SAMPLE = 'CloudRunSample';
    /**
     * @return {?}
     */
    function values() {
        return [
            AnalysisType.LOCAL,
            AnalysisType.CLOUD_RUN,
            AnalysisType.CLOUD_RUN_SAMPLE
        ];
    }
    AnalysisType.values = values;
})(AnalysisType || (AnalysisType = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/list-analysis-version-definitions-include-flags.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var ListAnalysisVersionDefinitionsIncludeFlags;
(function (ListAnalysisVersionDefinitionsIncludeFlags) {
    ListAnalysisVersionDefinitionsIncludeFlags.TOTAL_ITEM_COUNT = 'TotalItemCount';
    /**
     * @return {?}
     */
    function values() {
        return [
            ListAnalysisVersionDefinitionsIncludeFlags.TOTAL_ITEM_COUNT
        ];
    }
    ListAnalysisVersionDefinitionsIncludeFlags.values = values;
})(ListAnalysisVersionDefinitionsIncludeFlags || (ListAnalysisVersionDefinitionsIncludeFlags = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/analysis-version-definition-sort-fields.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var AnalysisVersionDefinitionSortFields;
(function (AnalysisVersionDefinitionSortFields) {
    AnalysisVersionDefinitionSortFields.VERSION = 'Version';
    AnalysisVersionDefinitionSortFields.TIME_CREATED = 'TimeCreated';
    AnalysisVersionDefinitionSortFields.DEFAULT = 'Default';
    /**
     * @return {?}
     */
    function values() {
        return [
            AnalysisVersionDefinitionSortFields.VERSION,
            AnalysisVersionDefinitionSortFields.TIME_CREATED,
            AnalysisVersionDefinitionSortFields.DEFAULT
        ];
    }
    AnalysisVersionDefinitionSortFields.values = values;
})(AnalysisVersionDefinitionSortFields || (AnalysisVersionDefinitionSortFields = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/get-analysis-version-definition-include-flags.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var GetAnalysisVersionDefinitionIncludeFlags;
(function (GetAnalysisVersionDefinitionIncludeFlags) {
    GetAnalysisVersionDefinitionIncludeFlags.COMPATIBLE_LIBRARY_PREP_KITS = 'CompatibleLibraryPrepKits';
    GetAnalysisVersionDefinitionIncludeFlags.COMPATIBLE_GENOMES = 'CompatibleGenomes';
    /**
     * @return {?}
     */
    function values() {
        return [
            GetAnalysisVersionDefinitionIncludeFlags.COMPATIBLE_LIBRARY_PREP_KITS,
            GetAnalysisVersionDefinitionIncludeFlags.COMPATIBLE_GENOMES
        ];
    }
    GetAnalysisVersionDefinitionIncludeFlags.values = values;
})(GetAnalysisVersionDefinitionIncludeFlags || (GetAnalysisVersionDefinitionIncludeFlags = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/render-context.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var RenderContext;
(function (RenderContext) {
    RenderContext.INITIAL = 'Initial';
    RenderContext.FIELD_CHANGED = 'FieldChanged';
    RenderContext.EDITED = 'Edited';
    /**
     * @return {?}
     */
    function values() {
        return [
            RenderContext.INITIAL,
            RenderContext.FIELD_CHANGED,
            RenderContext.EDITED
        ];
    }
    RenderContext.values = values;
})(RenderContext || (RenderContext = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/read-type.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var ReadType;
(function (ReadType) {
    ReadType.SINGLE = 'Single';
    ReadType.PAIRED = 'Paired';
    /**
     * @return {?}
     */
    function values() {
        return [
            ReadType.SINGLE,
            ReadType.PAIRED
        ];
    }
    ReadType.values = values;
})(ReadType || (ReadType = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/list-genomes-include-flags.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var ListGenomesIncludeFlags;
(function (ListGenomesIncludeFlags) {
    ListGenomesIncludeFlags.TOTAL_ITEM_COUNT = 'TotalItemCount';
    /**
     * @return {?}
     */
    function values() {
        return [
            ListGenomesIncludeFlags.TOTAL_ITEM_COUNT
        ];
    }
    ListGenomesIncludeFlags.values = values;
})(ListGenomesIncludeFlags || (ListGenomesIncludeFlags = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/genome-sort-fields.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var GenomeSortFields;
(function (GenomeSortFields) {
    GenomeSortFields.ORDER = 'Order';
    GenomeSortFields.DISPLAY_NAME = 'DisplayName';
    GenomeSortFields.NAME = 'Name';
    GenomeSortFields.BUILD = 'Build';
    GenomeSortFields.TIME_CREATED = 'TimeCreated';
    GenomeSortFields.DEFAULT = 'Default';
    /**
     * @return {?}
     */
    function values() {
        return [
            GenomeSortFields.ORDER,
            GenomeSortFields.DISPLAY_NAME,
            GenomeSortFields.NAME,
            GenomeSortFields.BUILD,
            GenomeSortFields.TIME_CREATED,
            GenomeSortFields.DEFAULT
        ];
    }
    GenomeSortFields.values = values;
})(GenomeSortFields || (GenomeSortFields = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/genome-status.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var GenomeStatus;
(function (GenomeStatus) {
    GenomeStatus.ACTIVE = 'Active';
    GenomeStatus.INACTIVE = 'Inactive';
    /**
     * @return {?}
     */
    function values() {
        return [
            GenomeStatus.ACTIVE,
            GenomeStatus.INACTIVE
        ];
    }
    GenomeStatus.values = values;
})(GenomeStatus || (GenomeStatus = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/genome-format.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var GenomeFormat;
(function (GenomeFormat) {
    GenomeFormat.DRAGEN = 'Dragen';
    GenomeFormat.FASTA = 'Fasta';
    /**
     * @return {?}
     */
    function values() {
        return [
            GenomeFormat.DRAGEN,
            GenomeFormat.FASTA
        ];
    }
    GenomeFormat.values = values;
})(GenomeFormat || (GenomeFormat = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/list-index-adapter-kits-include-flags.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var ListIndexAdapterKitsIncludeFlags;
(function (ListIndexAdapterKitsIncludeFlags) {
    ListIndexAdapterKitsIncludeFlags.TOTAL_ITEM_COUNT = 'TotalItemCount';
    /**
     * @return {?}
     */
    function values() {
        return [
            ListIndexAdapterKitsIncludeFlags.TOTAL_ITEM_COUNT
        ];
    }
    ListIndexAdapterKitsIncludeFlags.values = values;
})(ListIndexAdapterKitsIncludeFlags || (ListIndexAdapterKitsIncludeFlags = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/index-adapter-kit-sort-field.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var IndexAdapterKitSortField;
(function (IndexAdapterKitSortField) {
    IndexAdapterKitSortField.NAME = 'Name';
    IndexAdapterKitSortField.DISPLAY_NAME = 'DisplayName';
    IndexAdapterKitSortField.TIME_CREATED = 'TimeCreated';
    IndexAdapterKitSortField.DEFAULT = 'Default';
    /**
     * @return {?}
     */
    function values() {
        return [
            IndexAdapterKitSortField.NAME,
            IndexAdapterKitSortField.DISPLAY_NAME,
            IndexAdapterKitSortField.TIME_CREATED,
            IndexAdapterKitSortField.DEFAULT
        ];
    }
    IndexAdapterKitSortField.values = values;
})(IndexAdapterKitSortField || (IndexAdapterKitSortField = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/index-strategy.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var IndexStrategy;
(function (IndexStrategy) {
    IndexStrategy.NO_INDEX = 'NoIndex';
    IndexStrategy.SINGLE = 'Single';
    IndexStrategy.DUAL = 'Dual';
    /**
     * @return {?}
     */
    function values() {
        return [
            IndexStrategy.NO_INDEX,
            IndexStrategy.SINGLE,
            IndexStrategy.DUAL
        ];
    }
    IndexStrategy.values = values;
})(IndexStrategy || (IndexStrategy = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/kit-definition-format.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var KitDefinitionFormat;
(function (KitDefinitionFormat) {
    KitDefinitionFormat.YAML = 'Yaml';
    KitDefinitionFormat.TSV = 'Tsv';
    /**
     * @return {?}
     */
    function values() {
        return [
            KitDefinitionFormat.YAML,
            KitDefinitionFormat.TSV
        ];
    }
    KitDefinitionFormat.values = values;
})(KitDefinitionFormat || (KitDefinitionFormat = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/get-index-adapter-kit-include-flags.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var GetIndexAdapterKitIncludeFlags;
(function (GetIndexAdapterKitIncludeFlags) {
    GetIndexAdapterKitIncludeFlags.COMPATIBLE_LIBRARY_PREP_KITS = 'CompatibleLibraryPrepKits';
    GetIndexAdapterKitIncludeFlags.CAN_UPDATE = 'CanUpdate';
    /**
     * @return {?}
     */
    function values() {
        return [
            GetIndexAdapterKitIncludeFlags.COMPATIBLE_LIBRARY_PREP_KITS,
            GetIndexAdapterKitIncludeFlags.CAN_UPDATE
        ];
    }
    GetIndexAdapterKitIncludeFlags.values = values;
})(GetIndexAdapterKitIncludeFlags || (GetIndexAdapterKitIncludeFlags = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/library-status.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var LibraryStatus;
(function (LibraryStatus) {
    LibraryStatus.ACTIVE = 'Active';
    LibraryStatus.FAILED = 'Failed';
    LibraryStatus.CANCELED = 'Canceled';
    LibraryStatus.CONSUMED = 'Consumed';
    /**
     * @return {?}
     */
    function values() {
        return [
            LibraryStatus.ACTIVE,
            LibraryStatus.FAILED,
            LibraryStatus.CANCELED,
            LibraryStatus.CONSUMED
        ];
    }
    LibraryStatus.values = values;
})(LibraryStatus || (LibraryStatus = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/list-libraries-include-flags.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var ListLibrariesIncludeFlags;
(function (ListLibrariesIncludeFlags) {
    ListLibrariesIncludeFlags.TOTAL_ITEM_COUNT = 'TotalItemCount';
    /**
     * @return {?}
     */
    function values() {
        return [
            ListLibrariesIncludeFlags.TOTAL_ITEM_COUNT
        ];
    }
    ListLibrariesIncludeFlags.values = values;
})(ListLibrariesIncludeFlags || (ListLibrariesIncludeFlags = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/library-sort-fields.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var LibrarySortFields;
(function (LibrarySortFields) {
    LibrarySortFields.NAME = 'Name';
    LibrarySortFields.TIME_CREATED = 'TimeCreated';
    LibrarySortFields.DEFAULT = 'Default';
    /**
     * @return {?}
     */
    function values() {
        return [
            LibrarySortFields.NAME,
            LibrarySortFields.TIME_CREATED,
            LibrarySortFields.DEFAULT
        ];
    }
    LibrarySortFields.values = values;
})(LibrarySortFields || (LibrarySortFields = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/library-pool-status.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var LibraryPoolStatus;
(function (LibraryPoolStatus) {
    LibraryPoolStatus.ACTIVE = 'Active';
    LibraryPoolStatus.FAILED = 'Failed';
    LibraryPoolStatus.CANCELED = 'Canceled';
    LibraryPoolStatus.CONSUMED = 'Consumed';
    LibraryPoolStatus.QC_FAILED = 'QcFailed';
    /**
     * @return {?}
     */
    function values() {
        return [
            LibraryPoolStatus.ACTIVE,
            LibraryPoolStatus.FAILED,
            LibraryPoolStatus.CANCELED,
            LibraryPoolStatus.CONSUMED,
            LibraryPoolStatus.QC_FAILED
        ];
    }
    LibraryPoolStatus.values = values;
})(LibraryPoolStatus || (LibraryPoolStatus = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/list-library-pools-include-flags.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var ListLibraryPoolsIncludeFlags;
(function (ListLibraryPoolsIncludeFlags) {
    ListLibraryPoolsIncludeFlags.TOTAL_ITEM_COUNT = 'TotalItemCount';
    /**
     * @return {?}
     */
    function values() {
        return [
            ListLibraryPoolsIncludeFlags.TOTAL_ITEM_COUNT
        ];
    }
    ListLibraryPoolsIncludeFlags.values = values;
})(ListLibraryPoolsIncludeFlags || (ListLibraryPoolsIncludeFlags = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/library-pool-sort-fields.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var LibraryPoolSortFields;
(function (LibraryPoolSortFields) {
    LibraryPoolSortFields.NAME = 'Name';
    LibraryPoolSortFields.GROUP = 'Group';
    LibraryPoolSortFields.TIME_CREATED = 'TimeCreated';
    LibraryPoolSortFields.DEFAULT = 'Default';
    /**
     * @return {?}
     */
    function values() {
        return [
            LibraryPoolSortFields.NAME,
            LibraryPoolSortFields.GROUP,
            LibraryPoolSortFields.TIME_CREATED,
            LibraryPoolSortFields.DEFAULT
        ];
    }
    LibraryPoolSortFields.values = values;
})(LibraryPoolSortFields || (LibraryPoolSortFields = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/list-library-prep-kits-include-flags.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var ListLibraryPrepKitsIncludeFlags;
(function (ListLibraryPrepKitsIncludeFlags) {
    ListLibraryPrepKitsIncludeFlags.TOTAL_ITEM_COUNT = 'TotalItemCount';
    ListLibraryPrepKitsIncludeFlags.APPLICATION_SPECIFIC_KITS = 'ApplicationSpecificKits';
    /**
     * @return {?}
     */
    function values() {
        return [
            ListLibraryPrepKitsIncludeFlags.TOTAL_ITEM_COUNT,
            ListLibraryPrepKitsIncludeFlags.APPLICATION_SPECIFIC_KITS
        ];
    }
    ListLibraryPrepKitsIncludeFlags.values = values;
})(ListLibraryPrepKitsIncludeFlags || (ListLibraryPrepKitsIncludeFlags = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/library-prep-kit-sort-fields.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var LibraryPrepKitSortFields;
(function (LibraryPrepKitSortFields) {
    LibraryPrepKitSortFields.NAME = 'Name';
    LibraryPrepKitSortFields.DISPLAY_NAME = 'DisplayName';
    LibraryPrepKitSortFields.TIME_CREATED = 'TimeCreated';
    LibraryPrepKitSortFields.DEFAULT = 'Default';
    /**
     * @return {?}
     */
    function values() {
        return [
            LibraryPrepKitSortFields.NAME,
            LibraryPrepKitSortFields.DISPLAY_NAME,
            LibraryPrepKitSortFields.TIME_CREATED,
            LibraryPrepKitSortFields.DEFAULT
        ];
    }
    LibraryPrepKitSortFields.values = values;
})(LibraryPrepKitSortFields || (LibraryPrepKitSortFields = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/get-library-prep-kit-include-flags.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var GetLibraryPrepKitIncludeFlags;
(function (GetLibraryPrepKitIncludeFlags) {
    GetLibraryPrepKitIncludeFlags.CAN_UPDATE = 'CanUpdate';
    /**
     * @return {?}
     */
    function values() {
        return [
            GetLibraryPrepKitIncludeFlags.CAN_UPDATE
        ];
    }
    GetLibraryPrepKitIncludeFlags.values = values;
})(GetLibraryPrepKitIncludeFlags || (GetLibraryPrepKitIncludeFlags = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/sample-status.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var SampleStatus;
(function (SampleStatus) {
    SampleStatus.NEW = 'New';
    SampleStatus.ACTIVE = 'Active';
    SampleStatus.DONE = 'Done';
    SampleStatus.CANCELED = 'Canceled';
    SampleStatus.QC_FAILED = 'QcFailed';
    /**
     * @return {?}
     */
    function values() {
        return [
            SampleStatus.NEW,
            SampleStatus.ACTIVE,
            SampleStatus.DONE,
            SampleStatus.CANCELED,
            SampleStatus.QC_FAILED
        ];
    }
    SampleStatus.values = values;
})(SampleStatus || (SampleStatus = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/list-samples-include-flags.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var ListSamplesIncludeFlags;
(function (ListSamplesIncludeFlags) {
    ListSamplesIncludeFlags.TOTAL_ITEM_COUNT = 'TotalItemCount';
    /**
     * @return {?}
     */
    function values() {
        return [
            ListSamplesIncludeFlags.TOTAL_ITEM_COUNT
        ];
    }
    ListSamplesIncludeFlags.values = values;
})(ListSamplesIncludeFlags || (ListSamplesIncludeFlags = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/sample-sort-fields.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var SampleSortFields;
(function (SampleSortFields) {
    SampleSortFields.NAME = 'Name';
    SampleSortFields.TIME_CREATED = 'TimeCreated';
    SampleSortFields.DEFAULT = 'Default';
    /**
     * @return {?}
     */
    function values() {
        return [
            SampleSortFields.NAME,
            SampleSortFields.TIME_CREATED,
            SampleSortFields.DEFAULT
        ];
    }
    SampleSortFields.values = values;
})(SampleSortFields || (SampleSortFields = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/list-sample-associated-analysis-datasets-include-flags.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var ListSampleAssociatedAnalysisDatasetsIncludeFlags;
(function (ListSampleAssociatedAnalysisDatasetsIncludeFlags) {
    ListSampleAssociatedAnalysisDatasetsIncludeFlags.TOTAL_ITEM_COUNT = 'TotalItemCount';
    ListSampleAssociatedAnalysisDatasetsIncludeFlags.FILE_DETAILS = 'FileDetails';
    /**
     * @return {?}
     */
    function values() {
        return [
            ListSampleAssociatedAnalysisDatasetsIncludeFlags.TOTAL_ITEM_COUNT,
            ListSampleAssociatedAnalysisDatasetsIncludeFlags.FILE_DETAILS
        ];
    }
    ListSampleAssociatedAnalysisDatasetsIncludeFlags.values = values;
})(ListSampleAssociatedAnalysisDatasetsIncludeFlags || (ListSampleAssociatedAnalysisDatasetsIncludeFlags = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/generate-sample-sheet-include-flags.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var GenerateSampleSheetIncludeFlags;
(function (GenerateSampleSheetIncludeFlags) {
    GenerateSampleSheetIncludeFlags.INCLUDE_FILE_REFERENCES = 'IncludeFileReferences';
    /**
     * @return {?}
     */
    function values() {
        return [
            GenerateSampleSheetIncludeFlags.INCLUDE_FILE_REFERENCES
        ];
    }
    GenerateSampleSheetIncludeFlags.values = values;
})(GenerateSampleSheetIncludeFlags || (GenerateSampleSheetIncludeFlags = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/parse-sample-sheet-include-flags.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var ParseSampleSheetIncludeFlags;
(function (ParseSampleSheetIncludeFlags) {
    ParseSampleSheetIncludeFlags.PREP_KIT_INFO = 'PrepKitInfo';
    /**
     * @return {?}
     */
    function values() {
        return [
            ParseSampleSheetIncludeFlags.PREP_KIT_INFO
        ];
    }
    ParseSampleSheetIncludeFlags.values = values;
})(ParseSampleSheetIncludeFlags || (ParseSampleSheetIncludeFlags = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/list-sequencing-run-analysis-configuration-flags.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var ListSequencingRunAnalysisConfigurationFlags;
(function (ListSequencingRunAnalysisConfigurationFlags) {
    ListSequencingRunAnalysisConfigurationFlags.TOTAL_ITEM_COUNT = 'TotalItemCount';
    /**
     * @return {?}
     */
    function values() {
        return [
            ListSequencingRunAnalysisConfigurationFlags.TOTAL_ITEM_COUNT
        ];
    }
    ListSequencingRunAnalysisConfigurationFlags.values = values;
})(ListSequencingRunAnalysisConfigurationFlags || (ListSequencingRunAnalysisConfigurationFlags = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/sequencing-run-analysis-configuration-sort-fields.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var SequencingRunAnalysisConfigurationSortFields;
(function (SequencingRunAnalysisConfigurationSortFields) {
    SequencingRunAnalysisConfigurationSortFields.NAME = 'Name';
    SequencingRunAnalysisConfigurationSortFields.TIME_CREATED = 'TimeCreated';
    SequencingRunAnalysisConfigurationSortFields.DEFAULT = 'Default';
    /**
     * @return {?}
     */
    function values() {
        return [
            SequencingRunAnalysisConfigurationSortFields.NAME,
            SequencingRunAnalysisConfigurationSortFields.TIME_CREATED,
            SequencingRunAnalysisConfigurationSortFields.DEFAULT
        ];
    }
    SequencingRunAnalysisConfigurationSortFields.values = values;
})(SequencingRunAnalysisConfigurationSortFields || (SequencingRunAnalysisConfigurationSortFields = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/get-sequencing-run-contents-include-flags.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var GetSequencingRunContentsIncludeFlags;
(function (GetSequencingRunContentsIncludeFlags) {
    GetSequencingRunContentsIncludeFlags.REFERENCED_RESOURCE_MODELS = 'ReferencedResourceModels';
    /**
     * @return {?}
     */
    function values() {
        return [
            GetSequencingRunContentsIncludeFlags.REFERENCED_RESOURCE_MODELS
        ];
    }
    GetSequencingRunContentsIncludeFlags.values = values;
})(GetSequencingRunContentsIncludeFlags || (GetSequencingRunContentsIncludeFlags = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/run-origin.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var RunOrigin;
(function (RunOrigin) {
    RunOrigin.INSTRUMENT = 'Instrument';
    RunOrigin.INSTRUMENT_POST_RUN_UPLOAD = 'InstrumentPostRunUpload';
    RunOrigin.SIMULATOR = 'Simulator';
    /**
     * @return {?}
     */
    function values() {
        return [
            RunOrigin.INSTRUMENT,
            RunOrigin.INSTRUMENT_POST_RUN_UPLOAD,
            RunOrigin.SIMULATOR
        ];
    }
    RunOrigin.values = values;
})(RunOrigin || (RunOrigin = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/aggregate-run-status.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var AggregateRunStatus;
(function (AggregateRunStatus) {
    AggregateRunStatus.ABORTED = 'Aborted';
    AggregateRunStatus.COMPLETE = 'Complete';
    AggregateRunStatus.DELETED = 'Deleted';
    AggregateRunStatus.FAILED = 'Failed';
    AggregateRunStatus.FAILED_UPLOAD = 'FailedUpload';
    AggregateRunStatus.NEEDS_ATTENTION = 'NeedsAttention';
    AggregateRunStatus.PENDING_CLOUD_ANALYSIS = 'PendingCloudAnalysis';
    AggregateRunStatus.PLANNED = 'Planned';
    AggregateRunStatus.READY_FOR_SEQUENCING = 'ReadyForSequencing';
    AggregateRunStatus.REHYBING = 'Rehybing';
    AggregateRunStatus.RUNNING = 'Running';
    AggregateRunStatus.RUNNING_CLOUD_ANALYSIS = 'RunningCloudAnalysis';
    AggregateRunStatus.RUNNING_INSTRUMENT_ANALYSIS = 'RunningInstrumentAnalysis';
    AggregateRunStatus.TIMED_OUT = 'TimedOut';
    AggregateRunStatus.UNKNOWN = 'Unknown';
    AggregateRunStatus.UPLOADING = 'Uploading';
    AggregateRunStatus.INSTRUMENT_ANALYSIS_COMPLETED = 'InstrumentAnalysisCompleted';
    AggregateRunStatus.INSTRUMENT_COMPLETED = 'InstrumentCompleted';
    AggregateRunStatus.UPLOAD_COMPLETED = 'UploadCompleted';
    AggregateRunStatus.INSTRUMENT_RUN_COMPLETED = 'InstrumentRunCompleted';
    /**
     * @return {?}
     */
    function values() {
        return [
            AggregateRunStatus.ABORTED,
            AggregateRunStatus.COMPLETE,
            AggregateRunStatus.DELETED,
            AggregateRunStatus.FAILED,
            AggregateRunStatus.FAILED_UPLOAD,
            AggregateRunStatus.NEEDS_ATTENTION,
            AggregateRunStatus.PENDING_CLOUD_ANALYSIS,
            AggregateRunStatus.PLANNED,
            AggregateRunStatus.READY_FOR_SEQUENCING,
            AggregateRunStatus.REHYBING,
            AggregateRunStatus.RUNNING,
            AggregateRunStatus.RUNNING_CLOUD_ANALYSIS,
            AggregateRunStatus.RUNNING_INSTRUMENT_ANALYSIS,
            AggregateRunStatus.TIMED_OUT,
            AggregateRunStatus.UNKNOWN,
            AggregateRunStatus.UPLOADING,
            AggregateRunStatus.INSTRUMENT_ANALYSIS_COMPLETED,
            AggregateRunStatus.INSTRUMENT_COMPLETED,
            AggregateRunStatus.UPLOAD_COMPLETED,
            AggregateRunStatus.INSTRUMENT_RUN_COMPLETED
        ];
    }
    AggregateRunStatus.values = values;
})(AggregateRunStatus || (AggregateRunStatus = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/list-sequencing-runs-include-flags.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var ListSequencingRunsIncludeFlags;
(function (ListSequencingRunsIncludeFlags) {
    ListSequencingRunsIncludeFlags.TOTAL_ITEM_COUNT = 'TotalItemCount';
    ListSequencingRunsIncludeFlags.RUN_SEQUENCING_STATS = 'RunSequencingStats';
    ListSequencingRunsIncludeFlags.ANALYSIS_RUNS = 'AnalysisRuns';
    ListSequencingRunsIncludeFlags.DRAFT = 'Draft';
    /**
     * @return {?}
     */
    function values() {
        return [
            ListSequencingRunsIncludeFlags.TOTAL_ITEM_COUNT,
            ListSequencingRunsIncludeFlags.RUN_SEQUENCING_STATS,
            ListSequencingRunsIncludeFlags.ANALYSIS_RUNS,
            ListSequencingRunsIncludeFlags.DRAFT
        ];
    }
    ListSequencingRunsIncludeFlags.values = values;
})(ListSequencingRunsIncludeFlags || (ListSequencingRunsIncludeFlags = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/sequencing-run-sort-fields.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var SequencingRunSortFields;
(function (SequencingRunSortFields) {
    SequencingRunSortFields.ID = 'Id';
    SequencingRunSortFields.TIME_CREATED = 'TimeCreated';
    SequencingRunSortFields.TIME_MODIFIED = 'TimeModified';
    SequencingRunSortFields.RUN_NAME = 'RunName';
    SequencingRunSortFields.AGGREGATE_RUN_STATUS = 'AggregateRunStatus';
    SequencingRunSortFields.DEFAULT = 'Default';
    /**
     * @return {?}
     */
    function values() {
        return [
            SequencingRunSortFields.ID,
            SequencingRunSortFields.TIME_CREATED,
            SequencingRunSortFields.TIME_MODIFIED,
            SequencingRunSortFields.RUN_NAME,
            SequencingRunSortFields.AGGREGATE_RUN_STATUS,
            SequencingRunSortFields.DEFAULT
        ];
    }
    SequencingRunSortFields.values = values;
})(SequencingRunSortFields || (SequencingRunSortFields = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/run-stage-progress.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var RunStageProgress;
(function (RunStageProgress) {
    RunStageProgress.STARTED = 'Started';
    RunStageProgress.COMPLETED = 'Completed';
    RunStageProgress.FAILED = 'Failed';
    /**
     * @return {?}
     */
    function values() {
        return [
            RunStageProgress.STARTED,
            RunStageProgress.COMPLETED,
            RunStageProgress.FAILED
        ];
    }
    RunStageProgress.values = values;
})(RunStageProgress || (RunStageProgress = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/run-mode.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var RunMode;
(function (RunMode) {
    RunMode.INSTRUMENT_METRICS = 'InstrumentMetrics';
    RunMode.INSTRUMENT_AND_RUN_METRICS = 'InstrumentAndRunMetrics';
    RunMode.INSTRUMENT_AND_RUN_METRICS_AND_RUN_OUTPUT = 'InstrumentAndRunMetricsAndRunOutput';
    /**
     * @return {?}
     */
    function values() {
        return [
            RunMode.INSTRUMENT_METRICS,
            RunMode.INSTRUMENT_AND_RUN_METRICS,
            RunMode.INSTRUMENT_AND_RUN_METRICS_AND_RUN_OUTPUT
        ];
    }
    RunMode.values = values;
})(RunMode || (RunMode = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: api/base-service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Custom parameter codec to correctly handle the plus sign in parameter
 * values. See https://github.com/angular/angular/issues/18261
 */
class ParameterCodec {
    /**
     * @param {?} key
     * @return {?}
     */
    encodeKey(key) {
        return encodeURIComponent(key);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    encodeValue(value) {
        return encodeURIComponent(value);
    }
    /**
     * @param {?} key
     * @return {?}
     */
    decodeKey(key) {
        return decodeURIComponent(key);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    decodeValue(value) {
        return decodeURIComponent(value);
    }
}
/** @type {?} */
const PARAMETER_CODEC = new ParameterCodec();
/**
 * Base class for API services
 */
class BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        this.config = config;
        this.http = http;
        this._rootUrl = '';
    }
    /**
     * Returns the root url for API operations. If not set directly in this
     * service, will fallback to ApiConfiguration.rootUrl.
     * @return {?}
     */
    get rootUrl() {
        return this._rootUrl || this.config.rootUrl;
    }
    /**
     * Sets the root URL for API operations in this service.
     * @param {?} rootUrl
     * @return {?}
     */
    set rootUrl(rootUrl) {
        this._rootUrl = rootUrl;
    }
    /**
     * Creates a new `HttpParams` with the correct codec
     * @protected
     * @return {?}
     */
    newParams() {
        return new HttpParams({
            encoder: PARAMETER_CODEC
        });
    }
}
if (false) {
    /**
     * @type {?}
     * @private
     */
    BaseService.prototype._rootUrl;
    /**
     * @type {?}
     * @protected
     */
    BaseService.prototype.config;
    /**
     * @type {?}
     * @protected
     */
    BaseService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: api/gss-api-configuration.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Global configuration for GssApi services
 */
class GssApiConfiguration {
    constructor() {
        this.rootUrl = 'https://integration.stratus.illumina.com';
    }
}
GssApiConfiguration.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: GssApiConfiguration, factory: function GssApiConfiguration_Factory(t) { return new (t || GssApiConfiguration)(); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(GssApiConfiguration, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, { constructor: [], rootUrl: [] });
/** @nocollapse */ GssApiConfiguration.ngInjectableDef = ɵɵdefineInjectable({ factory: function GssApiConfiguration_Factory() { return new GssApiConfiguration(); }, token: GssApiConfiguration, providedIn: "root" });
if (false) {
    /** @type {?} */
    GssApiConfiguration.prototype.rootUrl;
}
/**
 * @record
 */
function GssApiConfigurationInterface() { }
if (false) {
    /** @type {?|undefined} */
    GssApiConfigurationInterface.prototype.rootUrl;
}

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/analysis-configuration-templates.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AnalysisConfigurationTemplatesService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * Create an analysis configuration template, and return information about that analysis configuration template.
     * @param {?=} body undefined
     * @return {?} Analysis configuration template created successfully.
     */
    createAnalysisConfigurationTemplateResponse(body) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/analysisConfigurationTemplates`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Create an analysis configuration template, and return information about that analysis configuration template.
     * @param {?=} body undefined
     * @return {?} Analysis configuration template created successfully.
     */
    createAnalysisConfigurationTemplate(body) {
        return this.createAnalysisConfigurationTemplateResponse(body).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get a list of analysis configuration templates accessible by the current request token.
     * @param {?} params The `AnalysisConfigurationTemplatesService.ListAnalysisConfigurationTemplatesParams` containing the following parameters:
     *
     * - `tenantIds`: Optional parameter to limit the response to be with in provided tenant ids
     *   Comma separated to support multiple tenant ids
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `name`: Filter by Name of the analysis configuration template
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * - `analysisVersionDefinitionId`: Filter By Analysis Version Definition Id(s)
     *   This query parameter name is in singular form for backwards compatibility (previously accepting a string for a single AVD ID)
     *
     * @return {?} AnalysisConfigurationTemplates returned successfully.
     */
    listAnalysisConfigurationTemplatesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        (params.tenantIds || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('tenantIds', val.toString()); }));
        if (params.sort != null)
            __params = __params.set('sort', params.sort.toString());
        if (params.pageToken != null)
            __params = __params.set('pageToken', params.pageToken.toString());
        if (params.pageSize != null)
            __params = __params.set('pageSize', params.pageSize.toString());
        if (params.name != null)
            __params = __params.set('name', params.name.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        (params.analysisVersionDefinitionId || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('analysisVersionDefinitionId', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/analysisConfigurationTemplates`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get a list of analysis configuration templates accessible by the current request token.
     * @param {?} params The `AnalysisConfigurationTemplatesService.ListAnalysisConfigurationTemplatesParams` containing the following parameters:
     *
     * - `tenantIds`: Optional parameter to limit the response to be with in provided tenant ids
     *   Comma separated to support multiple tenant ids
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `name`: Filter by Name of the analysis configuration template
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * - `analysisVersionDefinitionId`: Filter By Analysis Version Definition Id(s)
     *   This query parameter name is in singular form for backwards compatibility (previously accepting a string for a single AVD ID)
     *
     * @return {?} AnalysisConfigurationTemplates returned successfully.
     */
    listAnalysisConfigurationTemplates(params) {
        return this.listAnalysisConfigurationTemplatesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Update analysis configuration template, and return information about that analysis configuration template.
     * @param {?} params The `AnalysisConfigurationTemplatesService.UpdateAnalysisConfigurationTemplateParams` containing the following parameters:
     *
     * - `analysisConfigurationTemplateId`:
     *
     * - `body`:
     *
     * @return {?} Analysis configuration template is updated successfully.
     */
    updateAnalysisConfigurationTemplateResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v1/sequencing/analysisConfigurationTemplates/${params.analysisConfigurationTemplateId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Update analysis configuration template, and return information about that analysis configuration template.
     * @param {?} params The `AnalysisConfigurationTemplatesService.UpdateAnalysisConfigurationTemplateParams` containing the following parameters:
     *
     * - `analysisConfigurationTemplateId`:
     *
     * - `body`:
     *
     * @return {?} Analysis configuration template is updated successfully.
     */
    updateAnalysisConfigurationTemplate(params) {
        return this.updateAnalysisConfigurationTemplateResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given analysis configuration template ID, get the analysis configuration template details.
     * @param {?} analysisConfigurationTemplateId ID of the analysis configuration template
     * @return {?} Analysis configuration template returned successfully.
     */
    getAnalysisConfigurationTemplateResponse(analysisConfigurationTemplateId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/analysisConfigurationTemplates/${analysisConfigurationTemplateId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given analysis configuration template ID, get the analysis configuration template details.
     * @param {?} analysisConfigurationTemplateId ID of the analysis configuration template
     * @return {?} Analysis configuration template returned successfully.
     */
    getAnalysisConfigurationTemplate(analysisConfigurationTemplateId) {
        return this.getAnalysisConfigurationTemplateResponse(analysisConfigurationTemplateId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Delete an analysis configuration template for the given ID
     * @param {?} analysisConfigurationTemplateId undefined
     * @return {?}
     */
    deleteAnalysisConfigurationTemplateResponse(analysisConfigurationTemplateId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/v1/sequencing/analysisConfigurationTemplates/${analysisConfigurationTemplateId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Delete an analysis configuration template for the given ID
     * @param {?} analysisConfigurationTemplateId undefined
     * @return {?}
     */
    deleteAnalysisConfigurationTemplate(analysisConfigurationTemplateId) {
        return this.deleteAnalysisConfigurationTemplateResponse(analysisConfigurationTemplateId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
AnalysisConfigurationTemplatesService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: AnalysisConfigurationTemplatesService, factory: function AnalysisConfigurationTemplatesService_Factory(t) { return new (t || AnalysisConfigurationTemplatesService)(ɵngcc0.ɵɵinject(GssApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(AnalysisConfigurationTemplatesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GssApiConfiguration }, { type: HttpClient }]; }, { constructor: [], createAnalysisConfigurationTemplateResponse: [], createAnalysisConfigurationTemplate: [], listAnalysisConfigurationTemplatesResponse: [], listAnalysisConfigurationTemplates: [], updateAnalysisConfigurationTemplateResponse: [], updateAnalysisConfigurationTemplate: [], getAnalysisConfigurationTemplateResponse: [], getAnalysisConfigurationTemplate: [], deleteAnalysisConfigurationTemplateResponse: [], deleteAnalysisConfigurationTemplate: [] });
AnalysisConfigurationTemplatesService.createAnalysisConfigurationTemplatePath = '/v1/sequencing/analysisConfigurationTemplates';
AnalysisConfigurationTemplatesService.listAnalysisConfigurationTemplatesPath = '/v1/sequencing/analysisConfigurationTemplates';
AnalysisConfigurationTemplatesService.updateAnalysisConfigurationTemplatePath = '/v1/sequencing/analysisConfigurationTemplates/{analysisConfigurationTemplateId}';
AnalysisConfigurationTemplatesService.getAnalysisConfigurationTemplatePath = '/v1/sequencing/analysisConfigurationTemplates/{analysisConfigurationTemplateId}';
AnalysisConfigurationTemplatesService.deleteAnalysisConfigurationTemplatePath = '/v1/sequencing/analysisConfigurationTemplates/{analysisConfigurationTemplateId}';
/** @nocollapse */
AnalysisConfigurationTemplatesService.ctorParameters = () => [
    { type: GssApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ AnalysisConfigurationTemplatesService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AnalysisConfigurationTemplatesService_Factory() { return new AnalysisConfigurationTemplatesService(ɵɵinject(GssApiConfiguration), ɵɵinject(HttpClient)); }, token: AnalysisConfigurationTemplatesService, providedIn: "root" });
if (false) {
    /** @type {?} */
    AnalysisConfigurationTemplatesService.createAnalysisConfigurationTemplatePath;
    /** @type {?} */
    AnalysisConfigurationTemplatesService.listAnalysisConfigurationTemplatesPath;
    /** @type {?} */
    AnalysisConfigurationTemplatesService.updateAnalysisConfigurationTemplatePath;
    /** @type {?} */
    AnalysisConfigurationTemplatesService.getAnalysisConfigurationTemplatePath;
    /** @type {?} */
    AnalysisConfigurationTemplatesService.deleteAnalysisConfigurationTemplatePath;
}
(function (AnalysisConfigurationTemplatesService) {
    /**
     * Parameters for listAnalysisConfigurationTemplates
     * @record
     */
    function ListAnalysisConfigurationTemplatesParams() { }
    AnalysisConfigurationTemplatesService.ListAnalysisConfigurationTemplatesParams = ListAnalysisConfigurationTemplatesParams;
    if (false) {
        /**
         * Optional parameter to limit the response to be with in provided tenant ids
         * Comma separated to support multiple tenant ids
         * @type {?|undefined}
         */
        ListAnalysisConfigurationTemplatesParams.prototype.tenantIds;
        /**
         * Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
         * @type {?|undefined}
         */
        ListAnalysisConfigurationTemplatesParams.prototype.sort;
        /**
         * Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListAnalysisConfigurationTemplatesParams.prototype.pageToken;
        /**
         * Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListAnalysisConfigurationTemplatesParams.prototype.pageSize;
        /**
         * Filter by Name of the analysis configuration template
         * @type {?|undefined}
         */
        ListAnalysisConfigurationTemplatesParams.prototype.name;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        ListAnalysisConfigurationTemplatesParams.prototype.include;
        /**
         * Filter By Analysis Version Definition Id(s)
         * This query parameter name is in singular form for backwards compatibility (previously accepting a string for a single AVD ID)
         * @type {?|undefined}
         */
        ListAnalysisConfigurationTemplatesParams.prototype.analysisVersionDefinitionId;
    }
    /**
     * Parameters for updateAnalysisConfigurationTemplate
     * @record
     */
    function UpdateAnalysisConfigurationTemplateParams() { }
    AnalysisConfigurationTemplatesService.UpdateAnalysisConfigurationTemplateParams = UpdateAnalysisConfigurationTemplateParams;
    if (false) {
        /** @type {?} */
        UpdateAnalysisConfigurationTemplateParams.prototype.analysisConfigurationTemplateId;
        /** @type {?|undefined} */
        UpdateAnalysisConfigurationTemplateParams.prototype.body;
    }
})(AnalysisConfigurationTemplatesService || (AnalysisConfigurationTemplatesService = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/analysis-datasets.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AnalysisDatasetsService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * Return a list of associated analysis datasets.
     * @param {?} params The `AnalysisDatasetsService.ListAnalysisDatasetsParams` containing the following parameters:
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * - `analysisRunId`: Optional parameter. Set to filter the analysis datasets list and only include analysis datasets associated with the provided analysis runs.
     *
     * @return {?} Analysis datasets returned successfully.
     */
    listAnalysisDatasetsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sort != null)
            __params = __params.set('sort', params.sort.toString());
        if (params.pageToken != null)
            __params = __params.set('pageToken', params.pageToken.toString());
        if (params.pageSize != null)
            __params = __params.set('pageSize', params.pageSize.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        (params.analysisRunId || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('analysisRunId', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/analysisDatasets`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Return a list of associated analysis datasets.
     * @param {?} params The `AnalysisDatasetsService.ListAnalysisDatasetsParams` containing the following parameters:
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * - `analysisRunId`: Optional parameter. Set to filter the analysis datasets list and only include analysis datasets associated with the provided analysis runs.
     *
     * @return {?} Analysis datasets returned successfully.
     */
    listAnalysisDatasets(params) {
        return this.listAnalysisDatasetsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
AnalysisDatasetsService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: AnalysisDatasetsService, factory: function AnalysisDatasetsService_Factory(t) { return new (t || AnalysisDatasetsService)(ɵngcc0.ɵɵinject(GssApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(AnalysisDatasetsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GssApiConfiguration }, { type: HttpClient }]; }, { constructor: [], listAnalysisDatasetsResponse: [], listAnalysisDatasets: [] });
AnalysisDatasetsService.listAnalysisDatasetsPath = '/v1/sequencing/analysisDatasets';
/** @nocollapse */
AnalysisDatasetsService.ctorParameters = () => [
    { type: GssApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ AnalysisDatasetsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AnalysisDatasetsService_Factory() { return new AnalysisDatasetsService(ɵɵinject(GssApiConfiguration), ɵɵinject(HttpClient)); }, token: AnalysisDatasetsService, providedIn: "root" });
if (false) {
    /** @type {?} */
    AnalysisDatasetsService.listAnalysisDatasetsPath;
}
(function (AnalysisDatasetsService) {
    /**
     * Parameters for listAnalysisDatasets
     * @record
     */
    function ListAnalysisDatasetsParams() { }
    AnalysisDatasetsService.ListAnalysisDatasetsParams = ListAnalysisDatasetsParams;
    if (false) {
        /**
         * Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
         * @type {?|undefined}
         */
        ListAnalysisDatasetsParams.prototype.sort;
        /**
         * Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListAnalysisDatasetsParams.prototype.pageToken;
        /**
         * Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListAnalysisDatasetsParams.prototype.pageSize;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        ListAnalysisDatasetsParams.prototype.include;
        /**
         * Optional parameter. Set to filter the analysis datasets list and only include analysis datasets associated with the provided analysis runs.
         * @type {?|undefined}
         */
        ListAnalysisDatasetsParams.prototype.analysisRunId;
    }
})(AnalysisDatasetsService || (AnalysisDatasetsService = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/analysis-definitions.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AnalysisDefinitionsService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * For a given analysis definition ID, get the analysis definition details.
     * @param {?} params The `AnalysisDefinitionsService.GetAnalysisDefinitionParams` containing the following parameters:
     *
     * - `analysisDefinitionId`: ID of the analysis definition
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Analysis definition details returned successfully.
     */
    getAnalysisDefinitionResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/analysisdefinitions/${params.analysisDefinitionId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given analysis definition ID, get the analysis definition details.
     * @param {?} params The `AnalysisDefinitionsService.GetAnalysisDefinitionParams` containing the following parameters:
     *
     * - `analysisDefinitionId`: ID of the analysis definition
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Analysis definition details returned successfully.
     */
    getAnalysisDefinition(params) {
        return this.getAnalysisDefinitionResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given analysis definition ID, update the analysis definition details.
     * @param {?} params The `AnalysisDefinitionsService.UpdateAnalysisDefinitionParams` containing the following parameters:
     *
     * - `analysisDefinitionId`:
     *
     * - `body`:
     *
     * @return {?} Analysis definition details updated successfully.
     */
    updateAnalysisDefinitionResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v1/sequencing/analysisdefinitions/${params.analysisDefinitionId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given analysis definition ID, update the analysis definition details.
     * @param {?} params The `AnalysisDefinitionsService.UpdateAnalysisDefinitionParams` containing the following parameters:
     *
     * - `analysisDefinitionId`:
     *
     * - `body`:
     *
     * @return {?} Analysis definition details updated successfully.
     */
    updateAnalysisDefinition(params) {
        return this.updateAnalysisDefinitionResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Create an analysis definition, and return information about that analysis definition.
     * @param {?=} body undefined
     * @return {?} Analysis definition created successfully.
     */
    createAnalysisDefinitionResponse(body) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/analysisdefinitions`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Create an analysis definition, and return information about that analysis definition.
     * @param {?=} body undefined
     * @return {?} Analysis definition created successfully.
     */
    createAnalysisDefinition(body) {
        return this.createAnalysisDefinitionResponse(body).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get a list of analysis definitions accessible by the request token.
     * @param {?} params The `AnalysisDefinitionsService.ListAnalysisDefinitionsParams` containing the following parameters:
     *
     * - `tenantIds`: Optional parameter to limit the response to be with in provided tenant ids
     *   Comma separated to support multiple tenant ids
     *
     * - `subscriptions`: Filter on Analysis Version Definition required subscriptions, only valid when Illumina.GenomicSequencingService.Models.Domain.ListAnalysisDefinitionsIncludeFlags.AnalysisVersions is present
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `regulatoryMode`: Filter by regulatory modes using comma separated values, e.g <example>RUO,IVD,IUO</example>
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `instrumentType`: Instrument type
     *
     * - `instrumentPlatform`: Instrument platform
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * - `analysisLocation`: Filter parameter to only show Local/Cloud analysis version definitions
     *
     * @return {?} List of analysis definitions returned successfully.
     */
    listAnalysisDefinitionsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        (params.tenantIds || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('tenantIds', val.toString()); }));
        (params.subscriptions || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('subscriptions', val.toString()); }));
        if (params.sort != null)
            __params = __params.set('sort', params.sort.toString());
        (params.regulatoryMode || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('regulatoryMode', val.toString()); }));
        if (params.pageToken != null)
            __params = __params.set('pageToken', params.pageToken.toString());
        if (params.pageSize != null)
            __params = __params.set('pageSize', params.pageSize.toString());
        if (params.instrumentType != null)
            __params = __params.set('instrumentType', params.instrumentType.toString());
        if (params.instrumentPlatform != null)
            __params = __params.set('instrumentPlatform', params.instrumentPlatform.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        if (params.analysisLocation != null)
            __params = __params.set('analysisLocation', params.analysisLocation.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/analysisdefinitions`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get a list of analysis definitions accessible by the request token.
     * @param {?} params The `AnalysisDefinitionsService.ListAnalysisDefinitionsParams` containing the following parameters:
     *
     * - `tenantIds`: Optional parameter to limit the response to be with in provided tenant ids
     *   Comma separated to support multiple tenant ids
     *
     * - `subscriptions`: Filter on Analysis Version Definition required subscriptions, only valid when Illumina.GenomicSequencingService.Models.Domain.ListAnalysisDefinitionsIncludeFlags.AnalysisVersions is present
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `regulatoryMode`: Filter by regulatory modes using comma separated values, e.g <example>RUO,IVD,IUO</example>
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `instrumentType`: Instrument type
     *
     * - `instrumentPlatform`: Instrument platform
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * - `analysisLocation`: Filter parameter to only show Local/Cloud analysis version definitions
     *
     * @return {?} List of analysis definitions returned successfully.
     */
    listAnalysisDefinitions(params) {
        return this.listAnalysisDefinitionsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Replace the access control list of an analysis definition, and return information about that analysis definition.
     * @param {?} params The `AnalysisDefinitionsService.ReplaceAnalysisDefinitionAclParams` containing the following parameters:
     *
     * - `analysisDefinitionId`:
     *
     * - `body`:
     *
     * @return {?} Access control list updated successfully.
     */
    replaceAnalysisDefinitionAclResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PUT', this.rootUrl + `/v1/sequencing/analysisdefinitions/${params.analysisDefinitionId}/acl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Replace the access control list of an analysis definition, and return information about that analysis definition.
     * @param {?} params The `AnalysisDefinitionsService.ReplaceAnalysisDefinitionAclParams` containing the following parameters:
     *
     * - `analysisDefinitionId`:
     *
     * - `body`:
     *
     * @return {?} Access control list updated successfully.
     */
    replaceAnalysisDefinitionAcl(params) {
        return this.replaceAnalysisDefinitionAclResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Merge the access control list of an analysis definition with the input access control list, and return information about that analysis definition.
     * @param {?} params The `AnalysisDefinitionsService.MergeAnalysisDefinitionAclParams` containing the following parameters:
     *
     * - `analysisDefinitionId`:
     *
     * - `body`:
     *
     * @return {?} Access control list updated successfully.
     */
    mergeAnalysisDefinitionAclResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v1/sequencing/analysisdefinitions/${params.analysisDefinitionId}/acl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Merge the access control list of an analysis definition with the input access control list, and return information about that analysis definition.
     * @param {?} params The `AnalysisDefinitionsService.MergeAnalysisDefinitionAclParams` containing the following parameters:
     *
     * - `analysisDefinitionId`:
     *
     * - `body`:
     *
     * @return {?} Access control list updated successfully.
     */
    mergeAnalysisDefinitionAcl(params) {
        return this.mergeAnalysisDefinitionAclResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Remove the access control list of an analysis definition, and return information about that analysis definition.
     * @param {?} params The `AnalysisDefinitionsService.RemoveAnalysisDefinitionAclParams` containing the following parameters:
     *
     * - `analysisDefinitionId`:
     *
     * - `body`:
     *
     * @return {?} Input access control list of the analysis definition removed successfully.
     */
    removeAnalysisDefinitionAclResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/v1/sequencing/analysisdefinitions/${params.analysisDefinitionId}/acl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Remove the access control list of an analysis definition, and return information about that analysis definition.
     * @param {?} params The `AnalysisDefinitionsService.RemoveAnalysisDefinitionAclParams` containing the following parameters:
     *
     * - `analysisDefinitionId`:
     *
     * - `body`:
     *
     * @return {?} Input access control list of the analysis definition removed successfully.
     */
    removeAnalysisDefinitionAcl(params) {
        return this.removeAnalysisDefinitionAclResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
AnalysisDefinitionsService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: AnalysisDefinitionsService, factory: function AnalysisDefinitionsService_Factory(t) { return new (t || AnalysisDefinitionsService)(ɵngcc0.ɵɵinject(GssApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(AnalysisDefinitionsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GssApiConfiguration }, { type: HttpClient }]; }, { constructor: [], getAnalysisDefinitionResponse: [], getAnalysisDefinition: [], updateAnalysisDefinitionResponse: [], updateAnalysisDefinition: [], createAnalysisDefinitionResponse: [], createAnalysisDefinition: [], listAnalysisDefinitionsResponse: [], listAnalysisDefinitions: [], replaceAnalysisDefinitionAclResponse: [], replaceAnalysisDefinitionAcl: [], mergeAnalysisDefinitionAclResponse: [], mergeAnalysisDefinitionAcl: [], removeAnalysisDefinitionAclResponse: [], removeAnalysisDefinitionAcl: [] });
AnalysisDefinitionsService.getAnalysisDefinitionPath = '/v1/sequencing/analysisdefinitions/{analysisDefinitionId}';
AnalysisDefinitionsService.updateAnalysisDefinitionPath = '/v1/sequencing/analysisdefinitions/{analysisDefinitionId}';
AnalysisDefinitionsService.createAnalysisDefinitionPath = '/v1/sequencing/analysisdefinitions';
AnalysisDefinitionsService.listAnalysisDefinitionsPath = '/v1/sequencing/analysisdefinitions';
AnalysisDefinitionsService.replaceAnalysisDefinitionAclPath = '/v1/sequencing/analysisdefinitions/{analysisDefinitionId}/acl';
AnalysisDefinitionsService.mergeAnalysisDefinitionAclPath = '/v1/sequencing/analysisdefinitions/{analysisDefinitionId}/acl';
AnalysisDefinitionsService.removeAnalysisDefinitionAclPath = '/v1/sequencing/analysisdefinitions/{analysisDefinitionId}/acl';
/** @nocollapse */
AnalysisDefinitionsService.ctorParameters = () => [
    { type: GssApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ AnalysisDefinitionsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AnalysisDefinitionsService_Factory() { return new AnalysisDefinitionsService(ɵɵinject(GssApiConfiguration), ɵɵinject(HttpClient)); }, token: AnalysisDefinitionsService, providedIn: "root" });
if (false) {
    /** @type {?} */
    AnalysisDefinitionsService.getAnalysisDefinitionPath;
    /** @type {?} */
    AnalysisDefinitionsService.updateAnalysisDefinitionPath;
    /** @type {?} */
    AnalysisDefinitionsService.createAnalysisDefinitionPath;
    /** @type {?} */
    AnalysisDefinitionsService.listAnalysisDefinitionsPath;
    /** @type {?} */
    AnalysisDefinitionsService.replaceAnalysisDefinitionAclPath;
    /** @type {?} */
    AnalysisDefinitionsService.mergeAnalysisDefinitionAclPath;
    /** @type {?} */
    AnalysisDefinitionsService.removeAnalysisDefinitionAclPath;
}
(function (AnalysisDefinitionsService) {
    /**
     * Parameters for getAnalysisDefinition
     * @record
     */
    function GetAnalysisDefinitionParams() { }
    AnalysisDefinitionsService.GetAnalysisDefinitionParams = GetAnalysisDefinitionParams;
    if (false) {
        /**
         * ID of the analysis definition
         * @type {?}
         */
        GetAnalysisDefinitionParams.prototype.analysisDefinitionId;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        GetAnalysisDefinitionParams.prototype.include;
    }
    /**
     * Parameters for updateAnalysisDefinition
     * @record
     */
    function UpdateAnalysisDefinitionParams() { }
    AnalysisDefinitionsService.UpdateAnalysisDefinitionParams = UpdateAnalysisDefinitionParams;
    if (false) {
        /** @type {?} */
        UpdateAnalysisDefinitionParams.prototype.analysisDefinitionId;
        /** @type {?|undefined} */
        UpdateAnalysisDefinitionParams.prototype.body;
    }
    /**
     * Parameters for listAnalysisDefinitions
     * @record
     */
    function ListAnalysisDefinitionsParams() { }
    AnalysisDefinitionsService.ListAnalysisDefinitionsParams = ListAnalysisDefinitionsParams;
    if (false) {
        /**
         * Optional parameter to limit the response to be with in provided tenant ids
         * Comma separated to support multiple tenant ids
         * @type {?|undefined}
         */
        ListAnalysisDefinitionsParams.prototype.tenantIds;
        /**
         * Filter on Analysis Version Definition required subscriptions, only valid when Illumina.GenomicSequencingService.Models.Domain.ListAnalysisDefinitionsIncludeFlags.AnalysisVersions is present
         * @type {?|undefined}
         */
        ListAnalysisDefinitionsParams.prototype.subscriptions;
        /**
         * Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
         * @type {?|undefined}
         */
        ListAnalysisDefinitionsParams.prototype.sort;
        /**
         * Filter by regulatory modes using comma separated values, e.g <example>RUO,IVD,IUO</example>
         * @type {?|undefined}
         */
        ListAnalysisDefinitionsParams.prototype.regulatoryMode;
        /**
         * Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListAnalysisDefinitionsParams.prototype.pageToken;
        /**
         * Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListAnalysisDefinitionsParams.prototype.pageSize;
        /**
         * Instrument type
         * @type {?|undefined}
         */
        ListAnalysisDefinitionsParams.prototype.instrumentType;
        /**
         * Instrument platform
         * @type {?|undefined}
         */
        ListAnalysisDefinitionsParams.prototype.instrumentPlatform;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        ListAnalysisDefinitionsParams.prototype.include;
        /**
         * Filter parameter to only show Local/Cloud/DragenServer analysis version definitions
         * @type {?|undefined}
         */
        ListAnalysisDefinitionsParams.prototype.analysisLocation;
    }
    /**
     * Parameters for replaceAnalysisDefinitionAcl
     * @record
     */
    function ReplaceAnalysisDefinitionAclParams() { }
    AnalysisDefinitionsService.ReplaceAnalysisDefinitionAclParams = ReplaceAnalysisDefinitionAclParams;
    if (false) {
        /** @type {?} */
        ReplaceAnalysisDefinitionAclParams.prototype.analysisDefinitionId;
        /** @type {?|undefined} */
        ReplaceAnalysisDefinitionAclParams.prototype.body;
    }
    /**
     * Parameters for mergeAnalysisDefinitionAcl
     * @record
     */
    function MergeAnalysisDefinitionAclParams() { }
    AnalysisDefinitionsService.MergeAnalysisDefinitionAclParams = MergeAnalysisDefinitionAclParams;
    if (false) {
        /** @type {?} */
        MergeAnalysisDefinitionAclParams.prototype.analysisDefinitionId;
        /** @type {?|undefined} */
        MergeAnalysisDefinitionAclParams.prototype.body;
    }
    /**
     * Parameters for removeAnalysisDefinitionAcl
     * @record
     */
    function RemoveAnalysisDefinitionAclParams() { }
    AnalysisDefinitionsService.RemoveAnalysisDefinitionAclParams = RemoveAnalysisDefinitionAclParams;
    if (false) {
        /** @type {?} */
        RemoveAnalysisDefinitionAclParams.prototype.analysisDefinitionId;
        /** @type {?|undefined} */
        RemoveAnalysisDefinitionAclParams.prototype.body;
    }
})(AnalysisDefinitionsService || (AnalysisDefinitionsService = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/analysis-version-definitions.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AnalysisVersionDefinitionsService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * Create an analysis version definition, and return information about that analysis definition.
     * @param {?} params The `AnalysisVersionDefinitionsService.CreateAnalysisVersionDefinitionParams` containing the following parameters:
     *
     * - `analysisDefinitionId`:
     *
     * - `body`:
     *
     * @return {?} Analysis version definition created successfully.
     */
    createAnalysisVersionDefinitionResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/analysisdefinitions/${params.analysisDefinitionId}/versions`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Create an analysis version definition, and return information about that analysis definition.
     * @param {?} params The `AnalysisVersionDefinitionsService.CreateAnalysisVersionDefinitionParams` containing the following parameters:
     *
     * - `analysisDefinitionId`:
     *
     * - `body`:
     *
     * @return {?} Analysis version definition created successfully.
     */
    createAnalysisVersionDefinition(params) {
        return this.createAnalysisVersionDefinitionResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get a list of analysis definition versions accessible by the current request token.
     * @param {?} params The `AnalysisVersionDefinitionsService.ListAnalysisVersionDefinitionsParams` containing the following parameters:
     *
     * - `analysisDefinitionId`: ID of the analysis definition
     *
     * - `tenantIds`: Optional parameter to limit the response to be with in provided tenant ids
     *   Comma separated to support multiple tenant ids
     *
     * - `subscriptions`: Filter on required subscriptions based on available subscriptions
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `instrumentType`: Instrument type
     *
     * - `instrumentPlatform`: Instrument platform
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Analysis version definitions returned successfully.
     */
    listAnalysisVersionDefinitionsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        (params.tenantIds || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('tenantIds', val.toString()); }));
        (params.subscriptions || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('subscriptions', val.toString()); }));
        if (params.sort != null)
            __params = __params.set('sort', params.sort.toString());
        if (params.pageToken != null)
            __params = __params.set('pageToken', params.pageToken.toString());
        if (params.pageSize != null)
            __params = __params.set('pageSize', params.pageSize.toString());
        if (params.instrumentType != null)
            __params = __params.set('instrumentType', params.instrumentType.toString());
        if (params.instrumentPlatform != null)
            __params = __params.set('instrumentPlatform', params.instrumentPlatform.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/analysisdefinitions/${params.analysisDefinitionId}/versions`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get a list of analysis definition versions accessible by the current request token.
     * @param {?} params The `AnalysisVersionDefinitionsService.ListAnalysisVersionDefinitionsParams` containing the following parameters:
     *
     * - `analysisDefinitionId`: ID of the analysis definition
     *
     * - `tenantIds`: Optional parameter to limit the response to be with in provided tenant ids
     *   Comma separated to support multiple tenant ids
     *
     * - `subscriptions`: Filter on required subscriptions based on available subscriptions
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `instrumentType`: Instrument type
     *
     * - `instrumentPlatform`: Instrument platform
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Analysis version definitions returned successfully.
     */
    listAnalysisVersionDefinitions(params) {
        return this.listAnalysisVersionDefinitionsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Update an analysis version definition, and return information about that analysis definition.
     * @param {?} params The `AnalysisVersionDefinitionsService.UpdateAnalysisVersionDefinitionParams` containing the following parameters:
     *
     * - `versionName`:
     *
     * - `analysisDefinitionId`:
     *
     * - `body`:
     *
     * @return {?} Analysis version definition updated successfully.
     */
    updateAnalysisVersionDefinitionResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v1/sequencing/analysisdefinitions/${params.analysisDefinitionId}/versions/${params.versionName}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Update an analysis version definition, and return information about that analysis definition.
     * @param {?} params The `AnalysisVersionDefinitionsService.UpdateAnalysisVersionDefinitionParams` containing the following parameters:
     *
     * - `versionName`:
     *
     * - `analysisDefinitionId`:
     *
     * - `body`:
     *
     * @return {?} Analysis version definition updated successfully.
     */
    updateAnalysisVersionDefinition(params) {
        return this.updateAnalysisVersionDefinitionResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get a specific analysis definition version accessible by the current request token.
     * @param {?} params The `AnalysisVersionDefinitionsService.GetAnalysisVersionDefinitionParams` containing the following parameters:
     *
     * - `versionName`:
     *
     * - `analysisDefinitionId`:
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Analysis version definition returned successfully.
     */
    getAnalysisVersionDefinitionResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/analysisdefinitions/${params.analysisDefinitionId}/versions/${params.versionName}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get a specific analysis definition version accessible by the current request token.
     * @param {?} params The `AnalysisVersionDefinitionsService.GetAnalysisVersionDefinitionParams` containing the following parameters:
     *
     * - `versionName`:
     *
     * - `analysisDefinitionId`:
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Analysis version definition returned successfully.
     */
    getAnalysisVersionDefinition(params) {
        return this.getAnalysisVersionDefinitionResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given ID or URN, get details of an analysis definition version accessible by the current request token.
     * @param {?} params The `AnalysisVersionDefinitionsService.GetAnalysisVersionDefinitionByIdOrUrnParams` containing the following parameters:
     *
     * - `analysisVersionDefinitionId`:
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Analysis version definitions returned successfully.
     */
    getAnalysisVersionDefinitionByIdOrUrnResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/analysisdefinitions/versions/${params.analysisVersionDefinitionId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given ID or URN, get details of an analysis definition version accessible by the current request token.
     * @param {?} params The `AnalysisVersionDefinitionsService.GetAnalysisVersionDefinitionByIdOrUrnParams` containing the following parameters:
     *
     * - `analysisVersionDefinitionId`:
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Analysis version definitions returned successfully.
     */
    getAnalysisVersionDefinitionByIdOrUrn(params) {
        return this.getAnalysisVersionDefinitionByIdOrUrnResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given ID or URN, get details of an analysis definition version accessible by the current request token.
     * @param {?} params The `AnalysisVersionDefinitionsService.RenderAnalysisVersionDefinitionByIdOrUrnParams` containing the following parameters:
     *
     * - `analysisVersionDefinitionId`:
     *
     * - `body`:
     *
     * @return {?} Analysis version definitions is rendered successfully.
     */
    renderAnalysisVersionDefinitionByIdOrUrnResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/analysisdefinitions/versions/${params.analysisVersionDefinitionId}:render`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given ID or URN, get details of an analysis definition version accessible by the current request token.
     * @param {?} params The `AnalysisVersionDefinitionsService.RenderAnalysisVersionDefinitionByIdOrUrnParams` containing the following parameters:
     *
     * - `analysisVersionDefinitionId`:
     *
     * - `body`:
     *
     * @return {?} Analysis version definitions is rendered successfully.
     */
    renderAnalysisVersionDefinitionByIdOrUrn(params) {
        return this.renderAnalysisVersionDefinitionByIdOrUrnResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For the given Id, Status of Analysis Version Definition is set to archived.
     * @param {?} analysisVersionDefinitionId undefined
     * @return {?} Analysis version definition is archived successfully.
     */
    archiveAnalysisVersionDefinitionResponse(analysisVersionDefinitionId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/analysisdefinitions/versions/${analysisVersionDefinitionId}:archive`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For the given Id, Status of Analysis Version Definition is set to archived.
     * @param {?} analysisVersionDefinitionId undefined
     * @return {?} Analysis version definition is archived successfully.
     */
    archiveAnalysisVersionDefinition(analysisVersionDefinitionId) {
        return this.archiveAnalysisVersionDefinitionResponse(analysisVersionDefinitionId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For the given Id, Status of Analysis Version Definition is set to active.
     * @param {?} analysisVersionDefinitionId undefined
     * @return {?} Analysis version definition is unarchived successfully.
     */
    unarchiveAnalysisVersionDefinitionResponse(analysisVersionDefinitionId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/analysisdefinitions/versions/${analysisVersionDefinitionId}:unarchive`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For the given Id, Status of Analysis Version Definition is set to active.
     * @param {?} analysisVersionDefinitionId undefined
     * @return {?} Analysis version definition is unarchived successfully.
     */
    unarchiveAnalysisVersionDefinition(analysisVersionDefinitionId) {
        return this.unarchiveAnalysisVersionDefinitionResponse(analysisVersionDefinitionId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Replace the access control list of an analysis version definition with the input access control list, and return information about that analysis definition.
     * @param {?} params The `AnalysisVersionDefinitionsService.ReplaceAnalysisVersionDefinitionAclParams` containing the following parameters:
     *
     * - `analysisVersionDefinitionId`:
     *
     * - `body`:
     *
     * @return {?} Access control list updated successfully.
     */
    replaceAnalysisVersionDefinitionAclResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PUT', this.rootUrl + `/v1/sequencing/analysisdefinitions/versions/${params.analysisVersionDefinitionId}/acl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Replace the access control list of an analysis version definition with the input access control list, and return information about that analysis definition.
     * @param {?} params The `AnalysisVersionDefinitionsService.ReplaceAnalysisVersionDefinitionAclParams` containing the following parameters:
     *
     * - `analysisVersionDefinitionId`:
     *
     * - `body`:
     *
     * @return {?} Access control list updated successfully.
     */
    replaceAnalysisVersionDefinitionAcl(params) {
        return this.replaceAnalysisVersionDefinitionAclResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Merge the access control list of an analysis version definition with the input access control list, and return information about that analysis definition.
     * @param {?} params The `AnalysisVersionDefinitionsService.MergeAnalysisVersionDefinitionAclParams` containing the following parameters:
     *
     * - `analysisVersionDefinitionId`:
     *
     * - `body`:
     *
     * @return {?} Access control list updated successfully.
     */
    mergeAnalysisVersionDefinitionAclResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v1/sequencing/analysisdefinitions/versions/${params.analysisVersionDefinitionId}/acl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Merge the access control list of an analysis version definition with the input access control list, and return information about that analysis definition.
     * @param {?} params The `AnalysisVersionDefinitionsService.MergeAnalysisVersionDefinitionAclParams` containing the following parameters:
     *
     * - `analysisVersionDefinitionId`:
     *
     * - `body`:
     *
     * @return {?} Access control list updated successfully.
     */
    mergeAnalysisVersionDefinitionAcl(params) {
        return this.mergeAnalysisVersionDefinitionAclResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Remove the access control list of an analysis version definition, and return information about that analysis definition.
     * @param {?} params The `AnalysisVersionDefinitionsService.RemoveAnalysisVersionDefinitionAclParams` containing the following parameters:
     *
     * - `analysisVersionDefinitionId`:
     *
     * - `body`:
     *
     * @return {?} Input access control list of the analysis definition removed successfully.
     */
    removeAnalysisVersionDefinitionAclResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/v1/sequencing/analysisdefinitions/versions/${params.analysisVersionDefinitionId}/acl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Remove the access control list of an analysis version definition, and return information about that analysis definition.
     * @param {?} params The `AnalysisVersionDefinitionsService.RemoveAnalysisVersionDefinitionAclParams` containing the following parameters:
     *
     * - `analysisVersionDefinitionId`:
     *
     * - `body`:
     *
     * @return {?} Input access control list of the analysis definition removed successfully.
     */
    removeAnalysisVersionDefinitionAcl(params) {
        return this.removeAnalysisVersionDefinitionAclResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
AnalysisVersionDefinitionsService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: AnalysisVersionDefinitionsService, factory: function AnalysisVersionDefinitionsService_Factory(t) { return new (t || AnalysisVersionDefinitionsService)(ɵngcc0.ɵɵinject(GssApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(AnalysisVersionDefinitionsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GssApiConfiguration }, { type: HttpClient }]; }, { constructor: [], createAnalysisVersionDefinitionResponse: [], createAnalysisVersionDefinition: [], listAnalysisVersionDefinitionsResponse: [], listAnalysisVersionDefinitions: [], updateAnalysisVersionDefinitionResponse: [], updateAnalysisVersionDefinition: [], getAnalysisVersionDefinitionResponse: [], getAnalysisVersionDefinition: [], getAnalysisVersionDefinitionByIdOrUrnResponse: [], getAnalysisVersionDefinitionByIdOrUrn: [], renderAnalysisVersionDefinitionByIdOrUrnResponse: [], renderAnalysisVersionDefinitionByIdOrUrn: [], archiveAnalysisVersionDefinitionResponse: [], archiveAnalysisVersionDefinition: [], unarchiveAnalysisVersionDefinitionResponse: [], unarchiveAnalysisVersionDefinition: [], replaceAnalysisVersionDefinitionAclResponse: [], replaceAnalysisVersionDefinitionAcl: [], mergeAnalysisVersionDefinitionAclResponse: [], mergeAnalysisVersionDefinitionAcl: [], removeAnalysisVersionDefinitionAclResponse: [], removeAnalysisVersionDefinitionAcl: [] });
AnalysisVersionDefinitionsService.createAnalysisVersionDefinitionPath = '/v1/sequencing/analysisdefinitions/{analysisDefinitionId}/versions';
AnalysisVersionDefinitionsService.listAnalysisVersionDefinitionsPath = '/v1/sequencing/analysisdefinitions/{analysisDefinitionId}/versions';
AnalysisVersionDefinitionsService.updateAnalysisVersionDefinitionPath = '/v1/sequencing/analysisdefinitions/{analysisDefinitionId}/versions/{versionName}';
AnalysisVersionDefinitionsService.getAnalysisVersionDefinitionPath = '/v1/sequencing/analysisdefinitions/{analysisDefinitionId}/versions/{versionName}';
AnalysisVersionDefinitionsService.getAnalysisVersionDefinitionByIdOrUrnPath = '/v1/sequencing/analysisdefinitions/versions/{analysisVersionDefinitionId}';
AnalysisVersionDefinitionsService.renderAnalysisVersionDefinitionByIdOrUrnPath = '/v1/sequencing/analysisdefinitions/versions/{analysisVersionDefinitionId}:render';
AnalysisVersionDefinitionsService.archiveAnalysisVersionDefinitionPath = '/v1/sequencing/analysisdefinitions/versions/{analysisVersionDefinitionId}:archive';
AnalysisVersionDefinitionsService.unarchiveAnalysisVersionDefinitionPath = '/v1/sequencing/analysisdefinitions/versions/{analysisVersionDefinitionId}:unarchive';
AnalysisVersionDefinitionsService.replaceAnalysisVersionDefinitionAclPath = '/v1/sequencing/analysisdefinitions/versions/{analysisVersionDefinitionId}/acl';
AnalysisVersionDefinitionsService.mergeAnalysisVersionDefinitionAclPath = '/v1/sequencing/analysisdefinitions/versions/{analysisVersionDefinitionId}/acl';
AnalysisVersionDefinitionsService.removeAnalysisVersionDefinitionAclPath = '/v1/sequencing/analysisdefinitions/versions/{analysisVersionDefinitionId}/acl';
/** @nocollapse */
AnalysisVersionDefinitionsService.ctorParameters = () => [
    { type: GssApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ AnalysisVersionDefinitionsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AnalysisVersionDefinitionsService_Factory() { return new AnalysisVersionDefinitionsService(ɵɵinject(GssApiConfiguration), ɵɵinject(HttpClient)); }, token: AnalysisVersionDefinitionsService, providedIn: "root" });
if (false) {
    /** @type {?} */
    AnalysisVersionDefinitionsService.createAnalysisVersionDefinitionPath;
    /** @type {?} */
    AnalysisVersionDefinitionsService.listAnalysisVersionDefinitionsPath;
    /** @type {?} */
    AnalysisVersionDefinitionsService.updateAnalysisVersionDefinitionPath;
    /** @type {?} */
    AnalysisVersionDefinitionsService.getAnalysisVersionDefinitionPath;
    /** @type {?} */
    AnalysisVersionDefinitionsService.getAnalysisVersionDefinitionByIdOrUrnPath;
    /** @type {?} */
    AnalysisVersionDefinitionsService.renderAnalysisVersionDefinitionByIdOrUrnPath;
    /** @type {?} */
    AnalysisVersionDefinitionsService.archiveAnalysisVersionDefinitionPath;
    /** @type {?} */
    AnalysisVersionDefinitionsService.unarchiveAnalysisVersionDefinitionPath;
    /** @type {?} */
    AnalysisVersionDefinitionsService.replaceAnalysisVersionDefinitionAclPath;
    /** @type {?} */
    AnalysisVersionDefinitionsService.mergeAnalysisVersionDefinitionAclPath;
    /** @type {?} */
    AnalysisVersionDefinitionsService.removeAnalysisVersionDefinitionAclPath;
}
(function (AnalysisVersionDefinitionsService) {
    /**
     * Parameters for createAnalysisVersionDefinition
     * @record
     */
    function CreateAnalysisVersionDefinitionParams() { }
    AnalysisVersionDefinitionsService.CreateAnalysisVersionDefinitionParams = CreateAnalysisVersionDefinitionParams;
    if (false) {
        /** @type {?} */
        CreateAnalysisVersionDefinitionParams.prototype.analysisDefinitionId;
        /** @type {?|undefined} */
        CreateAnalysisVersionDefinitionParams.prototype.body;
    }
    /**
     * Parameters for listAnalysisVersionDefinitions
     * @record
     */
    function ListAnalysisVersionDefinitionsParams() { }
    AnalysisVersionDefinitionsService.ListAnalysisVersionDefinitionsParams = ListAnalysisVersionDefinitionsParams;
    if (false) {
        /**
         * ID of the analysis definition
         * @type {?}
         */
        ListAnalysisVersionDefinitionsParams.prototype.analysisDefinitionId;
        /**
         * Optional parameter to limit the response to be with in provided tenant ids
         * Comma separated to support multiple tenant ids
         * @type {?|undefined}
         */
        ListAnalysisVersionDefinitionsParams.prototype.tenantIds;
        /**
         * Filter on required subscriptions based on available subscriptions
         * @type {?|undefined}
         */
        ListAnalysisVersionDefinitionsParams.prototype.subscriptions;
        /**
         * Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
         * @type {?|undefined}
         */
        ListAnalysisVersionDefinitionsParams.prototype.sort;
        /**
         * Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListAnalysisVersionDefinitionsParams.prototype.pageToken;
        /**
         * Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListAnalysisVersionDefinitionsParams.prototype.pageSize;
        /**
         * Instrument type
         * @type {?|undefined}
         */
        ListAnalysisVersionDefinitionsParams.prototype.instrumentType;
        /**
         * Instrument platform
         * @type {?|undefined}
         */
        ListAnalysisVersionDefinitionsParams.prototype.instrumentPlatform;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        ListAnalysisVersionDefinitionsParams.prototype.include;
    }
    /**
     * Parameters for updateAnalysisVersionDefinition
     * @record
     */
    function UpdateAnalysisVersionDefinitionParams() { }
    AnalysisVersionDefinitionsService.UpdateAnalysisVersionDefinitionParams = UpdateAnalysisVersionDefinitionParams;
    if (false) {
        /** @type {?} */
        UpdateAnalysisVersionDefinitionParams.prototype.versionName;
        /** @type {?} */
        UpdateAnalysisVersionDefinitionParams.prototype.analysisDefinitionId;
        /** @type {?|undefined} */
        UpdateAnalysisVersionDefinitionParams.prototype.body;
    }
    /**
     * Parameters for getAnalysisVersionDefinition
     * @record
     */
    function GetAnalysisVersionDefinitionParams() { }
    AnalysisVersionDefinitionsService.GetAnalysisVersionDefinitionParams = GetAnalysisVersionDefinitionParams;
    if (false) {
        /** @type {?} */
        GetAnalysisVersionDefinitionParams.prototype.versionName;
        /** @type {?} */
        GetAnalysisVersionDefinitionParams.prototype.analysisDefinitionId;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        GetAnalysisVersionDefinitionParams.prototype.include;
    }
    /**
     * Parameters for getAnalysisVersionDefinitionByIdOrUrn
     * @record
     */
    function GetAnalysisVersionDefinitionByIdOrUrnParams() { }
    AnalysisVersionDefinitionsService.GetAnalysisVersionDefinitionByIdOrUrnParams = GetAnalysisVersionDefinitionByIdOrUrnParams;
    if (false) {
        /** @type {?} */
        GetAnalysisVersionDefinitionByIdOrUrnParams.prototype.analysisVersionDefinitionId;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        GetAnalysisVersionDefinitionByIdOrUrnParams.prototype.include;
    }
    /**
     * Parameters for renderAnalysisVersionDefinitionByIdOrUrn
     * @record
     */
    function RenderAnalysisVersionDefinitionByIdOrUrnParams() { }
    AnalysisVersionDefinitionsService.RenderAnalysisVersionDefinitionByIdOrUrnParams = RenderAnalysisVersionDefinitionByIdOrUrnParams;
    if (false) {
        /** @type {?} */
        RenderAnalysisVersionDefinitionByIdOrUrnParams.prototype.analysisVersionDefinitionId;
        /** @type {?|undefined} */
        RenderAnalysisVersionDefinitionByIdOrUrnParams.prototype.body;
    }
    /**
     * Parameters for replaceAnalysisVersionDefinitionAcl
     * @record
     */
    function ReplaceAnalysisVersionDefinitionAclParams() { }
    AnalysisVersionDefinitionsService.ReplaceAnalysisVersionDefinitionAclParams = ReplaceAnalysisVersionDefinitionAclParams;
    if (false) {
        /** @type {?} */
        ReplaceAnalysisVersionDefinitionAclParams.prototype.analysisVersionDefinitionId;
        /** @type {?|undefined} */
        ReplaceAnalysisVersionDefinitionAclParams.prototype.body;
    }
    /**
     * Parameters for mergeAnalysisVersionDefinitionAcl
     * @record
     */
    function MergeAnalysisVersionDefinitionAclParams() { }
    AnalysisVersionDefinitionsService.MergeAnalysisVersionDefinitionAclParams = MergeAnalysisVersionDefinitionAclParams;
    if (false) {
        /** @type {?} */
        MergeAnalysisVersionDefinitionAclParams.prototype.analysisVersionDefinitionId;
        /** @type {?|undefined} */
        MergeAnalysisVersionDefinitionAclParams.prototype.body;
    }
    /**
     * Parameters for removeAnalysisVersionDefinitionAcl
     * @record
     */
    function RemoveAnalysisVersionDefinitionAclParams() { }
    AnalysisVersionDefinitionsService.RemoveAnalysisVersionDefinitionAclParams = RemoveAnalysisVersionDefinitionAclParams;
    if (false) {
        /** @type {?} */
        RemoveAnalysisVersionDefinitionAclParams.prototype.analysisVersionDefinitionId;
        /** @type {?|undefined} */
        RemoveAnalysisVersionDefinitionAclParams.prototype.body;
    }
})(AnalysisVersionDefinitionsService || (AnalysisVersionDefinitionsService = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/genomes.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class GenomesService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * Get a list of genomes accessible by the current request token.
     * @param {?} params The `GenomesService.ListGenomesParams` containing the following parameters:
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `name`: Filter genomes by comma-separated Name values
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * - `hashTableVersion`: Filter genomes by HashTableVersion
     *
     * - `dragenVersion`: Filter genomes by DragenVersion
     *
     * - `analysisVersionDefinitionId`: Filter genomes by ID of AnalysisVersionDefinition
     *
     * @return {?} Genomes returned successfully.
     */
    listGenomesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sort != null)
            __params = __params.set('sort', params.sort.toString());
        if (params.pageToken != null)
            __params = __params.set('pageToken', params.pageToken.toString());
        if (params.pageSize != null)
            __params = __params.set('pageSize', params.pageSize.toString());
        (params.name || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('name', val.toString()); }));
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        if (params.hashTableVersion != null)
            __params = __params.set('hashTableVersion', params.hashTableVersion.toString());
        if (params.dragenVersion != null)
            __params = __params.set('dragenVersion', params.dragenVersion.toString());
        if (params.analysisVersionDefinitionId != null)
            __params = __params.set('analysisVersionDefinitionId', params.analysisVersionDefinitionId.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/genomes`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get a list of genomes accessible by the current request token.
     * @param {?} params The `GenomesService.ListGenomesParams` containing the following parameters:
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `name`: Filter genomes by comma-separated Name values
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * - `hashTableVersion`: Filter genomes by HashTableVersion
     *
     * - `dragenVersion`: Filter genomes by DragenVersion
     *
     * - `analysisVersionDefinitionId`: Filter genomes by ID of AnalysisVersionDefinition
     *
     * @return {?} Genomes returned successfully.
     */
    listGenomes(params) {
        return this.listGenomesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Create a reference genome, and return information about that reference genome.
     * @param {?=} body undefined
     * @return {?} Genome created successfully.
     */
    createGenomeResponse(body) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/genomes`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Create a reference genome, and return information about that reference genome.
     * @param {?=} body undefined
     * @return {?} Genome created successfully.
     */
    createGenome(body) {
        return this.createGenomeResponse(body).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given genome ID, return information about that genome.
     * @param {?} genomeId The ID of the requested genome.
     * @return {?} Genome details returned successfully.
     */
    getGenomeResponse(genomeId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/genomes/${genomeId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given genome ID, return information about that genome.
     * @param {?} genomeId The ID of the requested genome.
     * @return {?} Genome details returned successfully.
     */
    getGenome(genomeId) {
        return this.getGenomeResponse(genomeId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given genome ID, update the genome details.
     * @param {?} params The `GenomesService.UpdateGenomeParams` containing the following parameters:
     *
     * - `genomeId`:
     *
     * - `body`:
     *
     * @return {?} Genome details updated successfully.
     */
    updateGenomeResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v1/sequencing/genomes/${params.genomeId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given genome ID, update the genome details.
     * @param {?} params The `GenomesService.UpdateGenomeParams` containing the following parameters:
     *
     * - `genomeId`:
     *
     * - `body`:
     *
     * @return {?} Genome details updated successfully.
     */
    updateGenome(params) {
        return this.updateGenomeResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given genome ID, delete the genome.
     * @param {?} params The `GenomesService.DeleteGenomeParams` containing the following parameters:
     *
     * - `genomeId`: ID of the genome
     *
     * - `force`: Force delete the genome
     *
     * @return {?} Genome deleted successfully.
     */
    deleteGenomeResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.force != null)
            __params = __params.set('force', params.force.toString());
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/v1/sequencing/genomes/${params.genomeId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given genome ID, delete the genome.
     * @param {?} params The `GenomesService.DeleteGenomeParams` containing the following parameters:
     *
     * - `genomeId`: ID of the genome
     *
     * - `force`: Force delete the genome
     *
     * @return {?} Genome deleted successfully.
     */
    deleteGenome(params) {
        return this.deleteGenomeResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Replace the access control list of a genome with the input access control list, and return information about that genome.
     * @param {?} params The `GenomesService.ReplaceGenomeAclParams` containing the following parameters:
     *
     * - `genomeId`:
     *
     * - `body`:
     *
     * @return {?} Access control list of genome updated successfully.
     */
    replaceGenomeAclResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PUT', this.rootUrl + `/v1/sequencing/genomes/${params.genomeId}/acl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Replace the access control list of a genome with the input access control list, and return information about that genome.
     * @param {?} params The `GenomesService.ReplaceGenomeAclParams` containing the following parameters:
     *
     * - `genomeId`:
     *
     * - `body`:
     *
     * @return {?} Access control list of genome updated successfully.
     */
    replaceGenomeAcl(params) {
        return this.replaceGenomeAclResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Merge the access control list of a given genome with the input access control list, and return information about that genome.
     * @param {?} params The `GenomesService.MergeGenomeAclParams` containing the following parameters:
     *
     * - `genomeId`:
     *
     * - `body`:
     *
     * @return {?} Access control list updated successfully.
     */
    mergeGenomeAclResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v1/sequencing/genomes/${params.genomeId}/acl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Merge the access control list of a given genome with the input access control list, and return information about that genome.
     * @param {?} params The `GenomesService.MergeGenomeAclParams` containing the following parameters:
     *
     * - `genomeId`:
     *
     * - `body`:
     *
     * @return {?} Access control list updated successfully.
     */
    mergeGenomeAcl(params) {
        return this.mergeGenomeAclResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Remove the access control list of a given genome, and return information about that genome.
     * @param {?} params The `GenomesService.RemoveGenomeAclParams` containing the following parameters:
     *
     * - `genomeId`:
     *
     * - `body`:
     *
     * @return {?} Input access control list removed successfully.
     */
    removeGenomeAclResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/v1/sequencing/genomes/${params.genomeId}/acl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Remove the access control list of a given genome, and return information about that genome.
     * @param {?} params The `GenomesService.RemoveGenomeAclParams` containing the following parameters:
     *
     * - `genomeId`:
     *
     * - `body`:
     *
     * @return {?} Input access control list removed successfully.
     */
    removeGenomeAcl(params) {
        return this.removeGenomeAclResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
GenomesService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: GenomesService, factory: function GenomesService_Factory(t) { return new (t || GenomesService)(ɵngcc0.ɵɵinject(GssApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(GenomesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GssApiConfiguration }, { type: HttpClient }]; }, { constructor: [], listGenomesResponse: [], listGenomes: [], createGenomeResponse: [], createGenome: [], getGenomeResponse: [], getGenome: [], updateGenomeResponse: [], updateGenome: [], deleteGenomeResponse: [], deleteGenome: [], replaceGenomeAclResponse: [], replaceGenomeAcl: [], mergeGenomeAclResponse: [], mergeGenomeAcl: [], removeGenomeAclResponse: [], removeGenomeAcl: [] });
GenomesService.listGenomesPath = '/v1/sequencing/genomes';
GenomesService.createGenomePath = '/v1/sequencing/genomes';
GenomesService.getGenomePath = '/v1/sequencing/genomes/{genomeId}';
GenomesService.updateGenomePath = '/v1/sequencing/genomes/{genomeId}';
GenomesService.deleteGenomePath = '/v1/sequencing/genomes/{genomeId}';
GenomesService.replaceGenomeAclPath = '/v1/sequencing/genomes/{genomeId}/acl';
GenomesService.mergeGenomeAclPath = '/v1/sequencing/genomes/{genomeId}/acl';
GenomesService.removeGenomeAclPath = '/v1/sequencing/genomes/{genomeId}/acl';
/** @nocollapse */
GenomesService.ctorParameters = () => [
    { type: GssApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ GenomesService.ngInjectableDef = ɵɵdefineInjectable({ factory: function GenomesService_Factory() { return new GenomesService(ɵɵinject(GssApiConfiguration), ɵɵinject(HttpClient)); }, token: GenomesService, providedIn: "root" });
if (false) {
    /** @type {?} */
    GenomesService.listGenomesPath;
    /** @type {?} */
    GenomesService.createGenomePath;
    /** @type {?} */
    GenomesService.getGenomePath;
    /** @type {?} */
    GenomesService.updateGenomePath;
    /** @type {?} */
    GenomesService.deleteGenomePath;
    /** @type {?} */
    GenomesService.replaceGenomeAclPath;
    /** @type {?} */
    GenomesService.mergeGenomeAclPath;
    /** @type {?} */
    GenomesService.removeGenomeAclPath;
}
(function (GenomesService) {
    /**
     * Parameters for listGenomes
     * @record
     */
    function ListGenomesParams() { }
    GenomesService.ListGenomesParams = ListGenomesParams;
    if (false) {
        /**
         * Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
         * @type {?|undefined}
         */
        ListGenomesParams.prototype.sort;
        /**
         * Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListGenomesParams.prototype.pageToken;
        /**
         * Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListGenomesParams.prototype.pageSize;
        /**
         * Filter genomes by comma-separated Name values
         * @type {?|undefined}
         */
        ListGenomesParams.prototype.name;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        ListGenomesParams.prototype.include;
        /**
         * Filter genomes by HashTableVersion
         * @type {?|undefined}
         */
        ListGenomesParams.prototype.hashTableVersion;
        /**
         * Filter genomes by DragenVersion
         * @type {?|undefined}
         */
        ListGenomesParams.prototype.dragenVersion;
        /**
         * Filter genomes by ID of AnalysisVersionDefinition
         * @type {?|undefined}
         */
        ListGenomesParams.prototype.analysisVersionDefinitionId;
    }
    /**
     * Parameters for updateGenome
     * @record
     */
    function UpdateGenomeParams() { }
    GenomesService.UpdateGenomeParams = UpdateGenomeParams;
    if (false) {
        /** @type {?} */
        UpdateGenomeParams.prototype.genomeId;
        /** @type {?|undefined} */
        UpdateGenomeParams.prototype.body;
    }
    /**
     * Parameters for deleteGenome
     * @record
     */
    function DeleteGenomeParams() { }
    GenomesService.DeleteGenomeParams = DeleteGenomeParams;
    if (false) {
        /**
         * ID of the genome
         * @type {?}
         */
        DeleteGenomeParams.prototype.genomeId;
        /**
         * Force delete the genome
         * @type {?|undefined}
         */
        DeleteGenomeParams.prototype.force;
    }
    /**
     * Parameters for replaceGenomeAcl
     * @record
     */
    function ReplaceGenomeAclParams() { }
    GenomesService.ReplaceGenomeAclParams = ReplaceGenomeAclParams;
    if (false) {
        /** @type {?} */
        ReplaceGenomeAclParams.prototype.genomeId;
        /** @type {?|undefined} */
        ReplaceGenomeAclParams.prototype.body;
    }
    /**
     * Parameters for mergeGenomeAcl
     * @record
     */
    function MergeGenomeAclParams() { }
    GenomesService.MergeGenomeAclParams = MergeGenomeAclParams;
    if (false) {
        /** @type {?} */
        MergeGenomeAclParams.prototype.genomeId;
        /** @type {?|undefined} */
        MergeGenomeAclParams.prototype.body;
    }
    /**
     * Parameters for removeGenomeAcl
     * @record
     */
    function RemoveGenomeAclParams() { }
    GenomesService.RemoveGenomeAclParams = RemoveGenomeAclParams;
    if (false) {
        /** @type {?} */
        RemoveGenomeAclParams.prototype.genomeId;
        /** @type {?|undefined} */
        RemoveGenomeAclParams.prototype.body;
    }
})(GenomesService || (GenomesService = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/index-adapter-kits.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class IndexAdapterKitsService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * Get a list of index adapter kits accessible by the current request token.
     * @param {?} params The `IndexAdapterKitsService.ListIndexAdapterKitsParams` containing the following parameters:
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Index adapter kits returned successfully.
     */
    listIndexAdapterKitsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sort != null)
            __params = __params.set('sort', params.sort.toString());
        if (params.pageToken != null)
            __params = __params.set('pageToken', params.pageToken.toString());
        if (params.pageSize != null)
            __params = __params.set('pageSize', params.pageSize.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/indexadapterkits`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get a list of index adapter kits accessible by the current request token.
     * @param {?} params The `IndexAdapterKitsService.ListIndexAdapterKitsParams` containing the following parameters:
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Index adapter kits returned successfully.
     */
    listIndexAdapterKits(params) {
        return this.listIndexAdapterKitsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Create an index adapter kit, and return information about that index adapter kit.
     * @param {?=} body undefined
     * @return {?} Index adapter kit created successfully.
     */
    createIndexAdapterKitResponse(body) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/indexadapterkits`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Create an index adapter kit, and return information about that index adapter kit.
     * @param {?=} body undefined
     * @return {?} Index adapter kit created successfully.
     */
    createIndexAdapterKit(body) {
        return this.createIndexAdapterKitResponse(body).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Create an index adapter kit, and return information about that index adapter kit.
     * @param {?=} body undefined
     * @return {?} Index adapter kit created successfully.
     */
    createIndexAdapterKitByDefinitionResponse(body) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/indexadapterkits/definition`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Create an index adapter kit, and return information about that index adapter kit.
     * @param {?=} body undefined
     * @return {?} Index adapter kit created successfully.
     */
    createIndexAdapterKitByDefinition(body) {
        return this.createIndexAdapterKitByDefinitionResponse(body).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Update an index adapter kit, and return information about that index adapter kit.
     * @param {?} params The `IndexAdapterKitsService.UpdateIndexAdapterKitParams` containing the following parameters:
     *
     * - `indexAdapterKitId`:
     *
     * - `body`:
     *
     * @return {?} Index adapter kit updated successfully.
     */
    updateIndexAdapterKitResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v1/sequencing/indexadapterkits/${params.indexAdapterKitId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Update an index adapter kit, and return information about that index adapter kit.
     * @param {?} params The `IndexAdapterKitsService.UpdateIndexAdapterKitParams` containing the following parameters:
     *
     * - `indexAdapterKitId`:
     *
     * - `body`:
     *
     * @return {?} Index adapter kit updated successfully.
     */
    updateIndexAdapterKit(params) {
        return this.updateIndexAdapterKitResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given index adapter kit ID, get the index adapter kit details.
     * @param {?} params The `IndexAdapterKitsService.GetIndexAdapterKitParams` containing the following parameters:
     *
     * - `indexAdapterKitId`: ID of the index adapter kit
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Index adapter kit details returned successfully.
     */
    getIndexAdapterKitResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/indexadapterkits/${params.indexAdapterKitId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given index adapter kit ID, get the index adapter kit details.
     * @param {?} params The `IndexAdapterKitsService.GetIndexAdapterKitParams` containing the following parameters:
     *
     * - `indexAdapterKitId`: ID of the index adapter kit
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Index adapter kit details returned successfully.
     */
    getIndexAdapterKit(params) {
        return this.getIndexAdapterKitResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given index adapter kit ID, delete the index adapter kit.
     * @param {?} params The `IndexAdapterKitsService.DeleteIndexAdapterKitParams` containing the following parameters:
     *
     * - `indexAdapterKitId`: ID of the index adapter kit
     *
     * - `force`: Force delete the index adapter kit
     *
     * @return {?} Index adapter kit deleted successfully.
     */
    deleteIndexAdapterKitResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.force != null)
            __params = __params.set('force', params.force.toString());
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/v1/sequencing/indexadapterkits/${params.indexAdapterKitId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given index adapter kit ID, delete the index adapter kit.
     * @param {?} params The `IndexAdapterKitsService.DeleteIndexAdapterKitParams` containing the following parameters:
     *
     * - `indexAdapterKitId`: ID of the index adapter kit
     *
     * - `force`: Force delete the index adapter kit
     *
     * @return {?} Index adapter kit deleted successfully.
     */
    deleteIndexAdapterKit(params) {
        return this.deleteIndexAdapterKitResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Update an index adapter kit, and return information about that index adapter kit.
     * @param {?} params The `IndexAdapterKitsService.UpdateIndexAdapterKitByDefinitionParams` containing the following parameters:
     *
     * - `indexAdapterKitId`:
     *
     * - `body`:
     *
     * @return {?} Index adapter kit updated successfully.
     */
    updateIndexAdapterKitByDefinitionResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v1/sequencing/indexadapterkits/${params.indexAdapterKitId}/definition`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Update an index adapter kit, and return information about that index adapter kit.
     * @param {?} params The `IndexAdapterKitsService.UpdateIndexAdapterKitByDefinitionParams` containing the following parameters:
     *
     * - `indexAdapterKitId`:
     *
     * - `body`:
     *
     * @return {?} Index adapter kit updated successfully.
     */
    updateIndexAdapterKitByDefinition(params) {
        return this.updateIndexAdapterKitByDefinitionResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Replace the access control list of an index adapter kit with the input access control list, and return information about that index adapter kit.
     * @param {?} params The `IndexAdapterKitsService.ReplaceIndexAdapterKitAclParams` containing the following parameters:
     *
     * - `indexAdapterKitId`:
     *
     * - `body`:
     *
     * @return {?} Index adapter kit access control list updated successfully.
     */
    replaceIndexAdapterKitAclResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PUT', this.rootUrl + `/v1/sequencing/indexadapterkits/${params.indexAdapterKitId}/acl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Replace the access control list of an index adapter kit with the input access control list, and return information about that index adapter kit.
     * @param {?} params The `IndexAdapterKitsService.ReplaceIndexAdapterKitAclParams` containing the following parameters:
     *
     * - `indexAdapterKitId`:
     *
     * - `body`:
     *
     * @return {?} Index adapter kit access control list updated successfully.
     */
    replaceIndexAdapterKitAcl(params) {
        return this.replaceIndexAdapterKitAclResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Merge the access control list of an index adapter kit with the input access control list, and return information about that index adapter kit.
     * @param {?} params The `IndexAdapterKitsService.MergeIndexAdapterKitAclParams` containing the following parameters:
     *
     * - `indexAdapterKitId`:
     *
     * - `body`:
     *
     * @return {?} Access control list updated successfully.
     */
    mergeIndexAdapterKitAclResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v1/sequencing/indexadapterkits/${params.indexAdapterKitId}/acl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Merge the access control list of an index adapter kit with the input access control list, and return information about that index adapter kit.
     * @param {?} params The `IndexAdapterKitsService.MergeIndexAdapterKitAclParams` containing the following parameters:
     *
     * - `indexAdapterKitId`:
     *
     * - `body`:
     *
     * @return {?} Access control list updated successfully.
     */
    mergeIndexAdapterKitAcl(params) {
        return this.mergeIndexAdapterKitAclResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Remove the access control list of a given index adapter kit, and return information about that index adapter kit.
     * @param {?} params The `IndexAdapterKitsService.RemoveIndexAdapterKitAclParams` containing the following parameters:
     *
     * - `indexAdapterKitId`:
     *
     * - `body`:
     *
     * @return {?} Input access control list removed successfully.
     */
    removeIndexAdapterKitAclResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/v1/sequencing/indexadapterkits/${params.indexAdapterKitId}/acl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Remove the access control list of a given index adapter kit, and return information about that index adapter kit.
     * @param {?} params The `IndexAdapterKitsService.RemoveIndexAdapterKitAclParams` containing the following parameters:
     *
     * - `indexAdapterKitId`:
     *
     * - `body`:
     *
     * @return {?} Input access control list removed successfully.
     */
    removeIndexAdapterKitAcl(params) {
        return this.removeIndexAdapterKitAclResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
IndexAdapterKitsService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: IndexAdapterKitsService, factory: function IndexAdapterKitsService_Factory(t) { return new (t || IndexAdapterKitsService)(ɵngcc0.ɵɵinject(GssApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(IndexAdapterKitsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GssApiConfiguration }, { type: HttpClient }]; }, { constructor: [], listIndexAdapterKitsResponse: [], listIndexAdapterKits: [], createIndexAdapterKitResponse: [], createIndexAdapterKit: [], createIndexAdapterKitByDefinitionResponse: [], createIndexAdapterKitByDefinition: [], updateIndexAdapterKitResponse: [], updateIndexAdapterKit: [], getIndexAdapterKitResponse: [], getIndexAdapterKit: [], deleteIndexAdapterKitResponse: [], deleteIndexAdapterKit: [], updateIndexAdapterKitByDefinitionResponse: [], updateIndexAdapterKitByDefinition: [], replaceIndexAdapterKitAclResponse: [], replaceIndexAdapterKitAcl: [], mergeIndexAdapterKitAclResponse: [], mergeIndexAdapterKitAcl: [], removeIndexAdapterKitAclResponse: [], removeIndexAdapterKitAcl: [] });
IndexAdapterKitsService.listIndexAdapterKitsPath = '/v1/sequencing/indexadapterkits';
IndexAdapterKitsService.createIndexAdapterKitPath = '/v1/sequencing/indexadapterkits';
IndexAdapterKitsService.createIndexAdapterKitByDefinitionPath = '/v1/sequencing/indexadapterkits/definition';
IndexAdapterKitsService.updateIndexAdapterKitPath = '/v1/sequencing/indexadapterkits/{indexAdapterKitId}';
IndexAdapterKitsService.getIndexAdapterKitPath = '/v1/sequencing/indexadapterkits/{indexAdapterKitId}';
IndexAdapterKitsService.deleteIndexAdapterKitPath = '/v1/sequencing/indexadapterkits/{indexAdapterKitId}';
IndexAdapterKitsService.updateIndexAdapterKitByDefinitionPath = '/v1/sequencing/indexadapterkits/{indexAdapterKitId}/definition';
IndexAdapterKitsService.replaceIndexAdapterKitAclPath = '/v1/sequencing/indexadapterkits/{indexAdapterKitId}/acl';
IndexAdapterKitsService.mergeIndexAdapterKitAclPath = '/v1/sequencing/indexadapterkits/{indexAdapterKitId}/acl';
IndexAdapterKitsService.removeIndexAdapterKitAclPath = '/v1/sequencing/indexadapterkits/{indexAdapterKitId}/acl';
/** @nocollapse */
IndexAdapterKitsService.ctorParameters = () => [
    { type: GssApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ IndexAdapterKitsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function IndexAdapterKitsService_Factory() { return new IndexAdapterKitsService(ɵɵinject(GssApiConfiguration), ɵɵinject(HttpClient)); }, token: IndexAdapterKitsService, providedIn: "root" });
if (false) {
    /** @type {?} */
    IndexAdapterKitsService.listIndexAdapterKitsPath;
    /** @type {?} */
    IndexAdapterKitsService.createIndexAdapterKitPath;
    /** @type {?} */
    IndexAdapterKitsService.createIndexAdapterKitByDefinitionPath;
    /** @type {?} */
    IndexAdapterKitsService.updateIndexAdapterKitPath;
    /** @type {?} */
    IndexAdapterKitsService.getIndexAdapterKitPath;
    /** @type {?} */
    IndexAdapterKitsService.deleteIndexAdapterKitPath;
    /** @type {?} */
    IndexAdapterKitsService.updateIndexAdapterKitByDefinitionPath;
    /** @type {?} */
    IndexAdapterKitsService.replaceIndexAdapterKitAclPath;
    /** @type {?} */
    IndexAdapterKitsService.mergeIndexAdapterKitAclPath;
    /** @type {?} */
    IndexAdapterKitsService.removeIndexAdapterKitAclPath;
}
(function (IndexAdapterKitsService) {
    /**
     * Parameters for listIndexAdapterKits
     * @record
     */
    function ListIndexAdapterKitsParams() { }
    IndexAdapterKitsService.ListIndexAdapterKitsParams = ListIndexAdapterKitsParams;
    if (false) {
        /**
         * Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
         * @type {?|undefined}
         */
        ListIndexAdapterKitsParams.prototype.sort;
        /**
         * Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListIndexAdapterKitsParams.prototype.pageToken;
        /**
         * Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListIndexAdapterKitsParams.prototype.pageSize;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        ListIndexAdapterKitsParams.prototype.include;
    }
    /**
     * Parameters for updateIndexAdapterKit
     * @record
     */
    function UpdateIndexAdapterKitParams() { }
    IndexAdapterKitsService.UpdateIndexAdapterKitParams = UpdateIndexAdapterKitParams;
    if (false) {
        /** @type {?} */
        UpdateIndexAdapterKitParams.prototype.indexAdapterKitId;
        /** @type {?|undefined} */
        UpdateIndexAdapterKitParams.prototype.body;
    }
    /**
     * Parameters for getIndexAdapterKit
     * @record
     */
    function GetIndexAdapterKitParams() { }
    IndexAdapterKitsService.GetIndexAdapterKitParams = GetIndexAdapterKitParams;
    if (false) {
        /**
         * ID of the index adapter kit
         * @type {?}
         */
        GetIndexAdapterKitParams.prototype.indexAdapterKitId;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        GetIndexAdapterKitParams.prototype.include;
    }
    /**
     * Parameters for deleteIndexAdapterKit
     * @record
     */
    function DeleteIndexAdapterKitParams() { }
    IndexAdapterKitsService.DeleteIndexAdapterKitParams = DeleteIndexAdapterKitParams;
    if (false) {
        /**
         * ID of the index adapter kit
         * @type {?}
         */
        DeleteIndexAdapterKitParams.prototype.indexAdapterKitId;
        /**
         * Force delete the index adapter kit
         * @type {?|undefined}
         */
        DeleteIndexAdapterKitParams.prototype.force;
    }
    /**
     * Parameters for updateIndexAdapterKitByDefinition
     * @record
     */
    function UpdateIndexAdapterKitByDefinitionParams() { }
    IndexAdapterKitsService.UpdateIndexAdapterKitByDefinitionParams = UpdateIndexAdapterKitByDefinitionParams;
    if (false) {
        /** @type {?} */
        UpdateIndexAdapterKitByDefinitionParams.prototype.indexAdapterKitId;
        /** @type {?|undefined} */
        UpdateIndexAdapterKitByDefinitionParams.prototype.body;
    }
    /**
     * Parameters for replaceIndexAdapterKitAcl
     * @record
     */
    function ReplaceIndexAdapterKitAclParams() { }
    IndexAdapterKitsService.ReplaceIndexAdapterKitAclParams = ReplaceIndexAdapterKitAclParams;
    if (false) {
        /** @type {?} */
        ReplaceIndexAdapterKitAclParams.prototype.indexAdapterKitId;
        /** @type {?|undefined} */
        ReplaceIndexAdapterKitAclParams.prototype.body;
    }
    /**
     * Parameters for mergeIndexAdapterKitAcl
     * @record
     */
    function MergeIndexAdapterKitAclParams() { }
    IndexAdapterKitsService.MergeIndexAdapterKitAclParams = MergeIndexAdapterKitAclParams;
    if (false) {
        /** @type {?} */
        MergeIndexAdapterKitAclParams.prototype.indexAdapterKitId;
        /** @type {?|undefined} */
        MergeIndexAdapterKitAclParams.prototype.body;
    }
    /**
     * Parameters for removeIndexAdapterKitAcl
     * @record
     */
    function RemoveIndexAdapterKitAclParams() { }
    IndexAdapterKitsService.RemoveIndexAdapterKitAclParams = RemoveIndexAdapterKitAclParams;
    if (false) {
        /** @type {?} */
        RemoveIndexAdapterKitAclParams.prototype.indexAdapterKitId;
        /** @type {?|undefined} */
        RemoveIndexAdapterKitAclParams.prototype.body;
    }
})(IndexAdapterKitsService || (IndexAdapterKitsService = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/libraries.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LibrariesService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * Create a library, and return information about that library.
     * @param {?} params The `LibrariesService.CreateLibraryParams` containing the following parameters:
     *
     * - `sampleId`:
     *
     * - `body`:
     *
     * @return {?} Library created successfully.
     */
    createLibraryResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/samples/${params.sampleId}/libraries`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Create a library, and return information about that library.
     * @param {?} params The `LibrariesService.CreateLibraryParams` containing the following parameters:
     *
     * - `sampleId`:
     *
     * - `body`:
     *
     * @return {?} Library created successfully.
     */
    createLibrary(params) {
        return this.createLibraryResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given library ID, update the library.
     * @param {?} params The `LibrariesService.UpdateLibraryParams` containing the following parameters:
     *
     * - `libraryId`: The id of the requested library.
     *
     * - `body`: The update request for the library
     *
     * @return {?} Library updated successfully.
     */
    updateLibraryResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v1/sequencing/libraries/${params.libraryId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given library ID, update the library.
     * @param {?} params The `LibrariesService.UpdateLibraryParams` containing the following parameters:
     *
     * - `libraryId`: The id of the requested library.
     *
     * - `body`: The update request for the library
     *
     * @return {?} Library updated successfully.
     */
    updateLibrary(params) {
        return this.updateLibraryResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given library ID, get the details of the library.
     * @param {?} libraryId undefined
     * @return {?} Library returned successfully.
     */
    listLibrariesResponse(libraryId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/libraries/${libraryId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given library ID, get the details of the library.
     * @param {?} libraryId undefined
     * @return {?} Library returned successfully.
     */
    listLibraries(libraryId) {
        return this.listLibrariesResponse(libraryId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get a list of libraries accessible by the request token.
     * @param {?} params The `LibrariesService.ListLibraries_1Params` containing the following parameters:
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Libraries returned successfully.
     */
    listLibraries_1Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sort != null)
            __params = __params.set('sort', params.sort.toString());
        if (params.pageToken != null)
            __params = __params.set('pageToken', params.pageToken.toString());
        if (params.pageSize != null)
            __params = __params.set('pageSize', params.pageSize.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/libraries`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get a list of libraries accessible by the request token.
     * @param {?} params The `LibrariesService.ListLibraries_1Params` containing the following parameters:
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Libraries returned successfully.
     */
    listLibraries_1(params) {
        return this.listLibraries_1Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given library ID, disassociate the library prep kit and index adapter kit.
     * @param {?} libraryId undefined
     * @return {?} Disassociation completed successfully.
     */
    disassociateLibraryPrepKitResponse(libraryId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/libraries/${libraryId}:disassociateLibraryPrepKit`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given library ID, disassociate the library prep kit and index adapter kit.
     * @param {?} libraryId undefined
     * @return {?} Disassociation completed successfully.
     */
    disassociateLibraryPrepKit(libraryId) {
        return this.disassociateLibraryPrepKitResponse(libraryId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Replace the access control list of a library, and return information about that library.
     * @param {?} params The `LibrariesService.ReplaceLibraryAclParams` containing the following parameters:
     *
     * - `libraryId`:
     *
     * - `body`:
     *
     * @return {?} Access control list updated successfully.
     */
    replaceLibraryAclResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PUT', this.rootUrl + `/v1/sequencing/libraries/${params.libraryId}/acl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Replace the access control list of a library, and return information about that library.
     * @param {?} params The `LibrariesService.ReplaceLibraryAclParams` containing the following parameters:
     *
     * - `libraryId`:
     *
     * - `body`:
     *
     * @return {?} Access control list updated successfully.
     */
    replaceLibraryAcl(params) {
        return this.replaceLibraryAclResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Merge the access control list of a library, and return information about that library.
     * @param {?} params The `LibrariesService.MergeLibraryAclParams` containing the following parameters:
     *
     * - `libraryId`:
     *
     * - `body`:
     *
     * @return {?} Access control list updated successfully.
     */
    mergeLibraryAclResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v1/sequencing/libraries/${params.libraryId}/acl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Merge the access control list of a library, and return information about that library.
     * @param {?} params The `LibrariesService.MergeLibraryAclParams` containing the following parameters:
     *
     * - `libraryId`:
     *
     * - `body`:
     *
     * @return {?} Access control list updated successfully.
     */
    mergeLibraryAcl(params) {
        return this.mergeLibraryAclResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Remove the access control list of a library, and return information about that library.
     * @param {?} params The `LibrariesService.RemoveLibraryAclParams` containing the following parameters:
     *
     * - `libraryId`:
     *
     * - `body`:
     *
     * @return {?} Input access control list of the library removed successfully.
     */
    removeLibraryAclResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/v1/sequencing/libraries/${params.libraryId}/acl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Remove the access control list of a library, and return information about that library.
     * @param {?} params The `LibrariesService.RemoveLibraryAclParams` containing the following parameters:
     *
     * - `libraryId`:
     *
     * - `body`:
     *
     * @return {?} Input access control list of the library removed successfully.
     */
    removeLibraryAcl(params) {
        return this.removeLibraryAclResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
LibrariesService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: LibrariesService, factory: function LibrariesService_Factory(t) { return new (t || LibrariesService)(ɵngcc0.ɵɵinject(GssApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(LibrariesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GssApiConfiguration }, { type: HttpClient }]; }, { constructor: [], createLibraryResponse: [], createLibrary: [], updateLibraryResponse: [], updateLibrary: [], listLibrariesResponse: [], listLibraries: [], listLibraries_1Response: [], listLibraries_1: [], disassociateLibraryPrepKitResponse: [], disassociateLibraryPrepKit: [], replaceLibraryAclResponse: [], replaceLibraryAcl: [], mergeLibraryAclResponse: [], mergeLibraryAcl: [], removeLibraryAclResponse: [], removeLibraryAcl: [] });
LibrariesService.createLibraryPath = '/v1/sequencing/samples/{sampleId}/libraries';
LibrariesService.updateLibraryPath = '/v1/sequencing/libraries/{libraryId}';
LibrariesService.listLibrariesPath = '/v1/sequencing/libraries/{libraryId}';
LibrariesService.listLibraries_1Path = '/v1/sequencing/libraries';
LibrariesService.disassociateLibraryPrepKitPath = '/v1/sequencing/libraries/{libraryId}:disassociateLibraryPrepKit';
LibrariesService.replaceLibraryAclPath = '/v1/sequencing/libraries/{libraryId}/acl';
LibrariesService.mergeLibraryAclPath = '/v1/sequencing/libraries/{libraryId}/acl';
LibrariesService.removeLibraryAclPath = '/v1/sequencing/libraries/{libraryId}/acl';
/** @nocollapse */
LibrariesService.ctorParameters = () => [
    { type: GssApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ LibrariesService.ngInjectableDef = ɵɵdefineInjectable({ factory: function LibrariesService_Factory() { return new LibrariesService(ɵɵinject(GssApiConfiguration), ɵɵinject(HttpClient)); }, token: LibrariesService, providedIn: "root" });
if (false) {
    /** @type {?} */
    LibrariesService.createLibraryPath;
    /** @type {?} */
    LibrariesService.updateLibraryPath;
    /** @type {?} */
    LibrariesService.listLibrariesPath;
    /** @type {?} */
    LibrariesService.listLibraries_1Path;
    /** @type {?} */
    LibrariesService.disassociateLibraryPrepKitPath;
    /** @type {?} */
    LibrariesService.replaceLibraryAclPath;
    /** @type {?} */
    LibrariesService.mergeLibraryAclPath;
    /** @type {?} */
    LibrariesService.removeLibraryAclPath;
}
(function (LibrariesService) {
    /**
     * Parameters for createLibrary
     * @record
     */
    function CreateLibraryParams() { }
    LibrariesService.CreateLibraryParams = CreateLibraryParams;
    if (false) {
        /** @type {?} */
        CreateLibraryParams.prototype.sampleId;
        /** @type {?|undefined} */
        CreateLibraryParams.prototype.body;
    }
    /**
     * Parameters for updateLibrary
     * @record
     */
    function UpdateLibraryParams() { }
    LibrariesService.UpdateLibraryParams = UpdateLibraryParams;
    if (false) {
        /**
         * The id of the requested library.
         * @type {?}
         */
        UpdateLibraryParams.prototype.libraryId;
        /**
         * The update request for the library
         * @type {?|undefined}
         */
        UpdateLibraryParams.prototype.body;
    }
    /**
     * Parameters for listLibraries_1
     * @record
     */
    function ListLibraries_1Params() { }
    LibrariesService.ListLibraries_1Params = ListLibraries_1Params;
    if (false) {
        /**
         * Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
         * @type {?|undefined}
         */
        ListLibraries_1Params.prototype.sort;
        /**
         * Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListLibraries_1Params.prototype.pageToken;
        /**
         * Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListLibraries_1Params.prototype.pageSize;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        ListLibraries_1Params.prototype.include;
    }
    /**
     * Parameters for replaceLibraryAcl
     * @record
     */
    function ReplaceLibraryAclParams() { }
    LibrariesService.ReplaceLibraryAclParams = ReplaceLibraryAclParams;
    if (false) {
        /** @type {?} */
        ReplaceLibraryAclParams.prototype.libraryId;
        /** @type {?|undefined} */
        ReplaceLibraryAclParams.prototype.body;
    }
    /**
     * Parameters for mergeLibraryAcl
     * @record
     */
    function MergeLibraryAclParams() { }
    LibrariesService.MergeLibraryAclParams = MergeLibraryAclParams;
    if (false) {
        /** @type {?} */
        MergeLibraryAclParams.prototype.libraryId;
        /** @type {?|undefined} */
        MergeLibraryAclParams.prototype.body;
    }
    /**
     * Parameters for removeLibraryAcl
     * @record
     */
    function RemoveLibraryAclParams() { }
    LibrariesService.RemoveLibraryAclParams = RemoveLibraryAclParams;
    if (false) {
        /** @type {?} */
        RemoveLibraryAclParams.prototype.libraryId;
        /** @type {?|undefined} */
        RemoveLibraryAclParams.prototype.body;
    }
})(LibrariesService || (LibrariesService = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/library-pools.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LibraryPoolsService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * For a given library pool ID, get the library pool details accessible by the request token.
     * @param {?} libraryPoolId undefined
     * @return {?} Library pool details returned successfully.
     */
    getLibraryPoolResponse(libraryPoolId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/librarypools/${libraryPoolId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given library pool ID, get the library pool details accessible by the request token.
     * @param {?} libraryPoolId undefined
     * @return {?} Library pool details returned successfully.
     */
    getLibraryPool(libraryPoolId) {
        return this.getLibraryPoolResponse(libraryPoolId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Update a library pool, and return information about that library pool.
     * @param {?} params The `LibraryPoolsService.UpdateLibraryPoolParams` containing the following parameters:
     *
     * - `libraryPoolId`:
     *
     * - `body`:
     *
     * @return {?} Library pool updated successfully.
     */
    updateLibraryPoolResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v1/sequencing/librarypools/${params.libraryPoolId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Update a library pool, and return information about that library pool.
     * @param {?} params The `LibraryPoolsService.UpdateLibraryPoolParams` containing the following parameters:
     *
     * - `libraryPoolId`:
     *
     * - `body`:
     *
     * @return {?} Library pool updated successfully.
     */
    updateLibraryPool(params) {
        return this.updateLibraryPoolResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get a list of library pools accessible by the request token.
     * @param {?} params The `LibraryPoolsService.ListLibraryPoolsParams` containing the following parameters:
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Library pools list returned successfully.
     */
    listLibraryPoolsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sort != null)
            __params = __params.set('sort', params.sort.toString());
        if (params.pageToken != null)
            __params = __params.set('pageToken', params.pageToken.toString());
        if (params.pageSize != null)
            __params = __params.set('pageSize', params.pageSize.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/librarypools`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get a list of library pools accessible by the request token.
     * @param {?} params The `LibraryPoolsService.ListLibraryPoolsParams` containing the following parameters:
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Library pools list returned successfully.
     */
    listLibraryPools(params) {
        return this.listLibraryPoolsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Create a library pool, and return information about that library pool.
     * @param {?=} body undefined
     * @return {?} Library pool created successfully.
     */
    createLibraryPoolResponse(body) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/librarypools`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Create a library pool, and return information about that library pool.
     * @param {?=} body undefined
     * @return {?} Library pool created successfully.
     */
    createLibraryPool(body) {
        return this.createLibraryPoolResponse(body).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Replace the access control list of a library pool with the input access control list, and return information about that library pool.
     * @param {?} params The `LibraryPoolsService.ReplaceLibraryPoolAclParams` containing the following parameters:
     *
     * - `libraryPoolId`:
     *
     * - `body`:
     *
     * @return {?} Access control list updated successfully.
     */
    replaceLibraryPoolAclResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PUT', this.rootUrl + `/v1/sequencing/librarypools/${params.libraryPoolId}/acl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Replace the access control list of a library pool with the input access control list, and return information about that library pool.
     * @param {?} params The `LibraryPoolsService.ReplaceLibraryPoolAclParams` containing the following parameters:
     *
     * - `libraryPoolId`:
     *
     * - `body`:
     *
     * @return {?} Access control list updated successfully.
     */
    replaceLibraryPoolAcl(params) {
        return this.replaceLibraryPoolAclResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Merge the access control list of a library pool with the input access control list, and return information about the library pool.
     * @param {?} params The `LibraryPoolsService.MergeLibraryPoolAclParams` containing the following parameters:
     *
     * - `libraryPoolId`:
     *
     * - `body`:
     *
     * @return {?} Access control list updated successfully.
     */
    mergeLibraryPoolAclResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v1/sequencing/librarypools/${params.libraryPoolId}/acl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Merge the access control list of a library pool with the input access control list, and return information about the library pool.
     * @param {?} params The `LibraryPoolsService.MergeLibraryPoolAclParams` containing the following parameters:
     *
     * - `libraryPoolId`:
     *
     * - `body`:
     *
     * @return {?} Access control list updated successfully.
     */
    mergeLibraryPoolAcl(params) {
        return this.mergeLibraryPoolAclResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Remove the input access control list from a library pool, and return information about the library pool.
     * @param {?} params The `LibraryPoolsService.RemoveLibraryPoolAclParams` containing the following parameters:
     *
     * - `libraryPoolId`:
     *
     * - `body`:
     *
     * @return {?} Input access control list removed successfully.
     */
    removeLibraryPoolAclResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/v1/sequencing/librarypools/${params.libraryPoolId}/acl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Remove the input access control list from a library pool, and return information about the library pool.
     * @param {?} params The `LibraryPoolsService.RemoveLibraryPoolAclParams` containing the following parameters:
     *
     * - `libraryPoolId`:
     *
     * - `body`:
     *
     * @return {?} Input access control list removed successfully.
     */
    removeLibraryPoolAcl(params) {
        return this.removeLibraryPoolAclResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
LibraryPoolsService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: LibraryPoolsService, factory: function LibraryPoolsService_Factory(t) { return new (t || LibraryPoolsService)(ɵngcc0.ɵɵinject(GssApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(LibraryPoolsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GssApiConfiguration }, { type: HttpClient }]; }, { constructor: [], getLibraryPoolResponse: [], getLibraryPool: [], updateLibraryPoolResponse: [], updateLibraryPool: [], listLibraryPoolsResponse: [], listLibraryPools: [], createLibraryPoolResponse: [], createLibraryPool: [], replaceLibraryPoolAclResponse: [], replaceLibraryPoolAcl: [], mergeLibraryPoolAclResponse: [], mergeLibraryPoolAcl: [], removeLibraryPoolAclResponse: [], removeLibraryPoolAcl: [] });
LibraryPoolsService.getLibraryPoolPath = '/v1/sequencing/librarypools/{libraryPoolId}';
LibraryPoolsService.updateLibraryPoolPath = '/v1/sequencing/librarypools/{libraryPoolId}';
LibraryPoolsService.listLibraryPoolsPath = '/v1/sequencing/librarypools';
LibraryPoolsService.createLibraryPoolPath = '/v1/sequencing/librarypools';
LibraryPoolsService.replaceLibraryPoolAclPath = '/v1/sequencing/librarypools/{libraryPoolId}/acl';
LibraryPoolsService.mergeLibraryPoolAclPath = '/v1/sequencing/librarypools/{libraryPoolId}/acl';
LibraryPoolsService.removeLibraryPoolAclPath = '/v1/sequencing/librarypools/{libraryPoolId}/acl';
/** @nocollapse */
LibraryPoolsService.ctorParameters = () => [
    { type: GssApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ LibraryPoolsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function LibraryPoolsService_Factory() { return new LibraryPoolsService(ɵɵinject(GssApiConfiguration), ɵɵinject(HttpClient)); }, token: LibraryPoolsService, providedIn: "root" });
if (false) {
    /** @type {?} */
    LibraryPoolsService.getLibraryPoolPath;
    /** @type {?} */
    LibraryPoolsService.updateLibraryPoolPath;
    /** @type {?} */
    LibraryPoolsService.listLibraryPoolsPath;
    /** @type {?} */
    LibraryPoolsService.createLibraryPoolPath;
    /** @type {?} */
    LibraryPoolsService.replaceLibraryPoolAclPath;
    /** @type {?} */
    LibraryPoolsService.mergeLibraryPoolAclPath;
    /** @type {?} */
    LibraryPoolsService.removeLibraryPoolAclPath;
}
(function (LibraryPoolsService) {
    /**
     * Parameters for updateLibraryPool
     * @record
     */
    function UpdateLibraryPoolParams() { }
    LibraryPoolsService.UpdateLibraryPoolParams = UpdateLibraryPoolParams;
    if (false) {
        /** @type {?} */
        UpdateLibraryPoolParams.prototype.libraryPoolId;
        /** @type {?|undefined} */
        UpdateLibraryPoolParams.prototype.body;
    }
    /**
     * Parameters for listLibraryPools
     * @record
     */
    function ListLibraryPoolsParams() { }
    LibraryPoolsService.ListLibraryPoolsParams = ListLibraryPoolsParams;
    if (false) {
        /**
         * Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
         * @type {?|undefined}
         */
        ListLibraryPoolsParams.prototype.sort;
        /**
         * Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListLibraryPoolsParams.prototype.pageToken;
        /**
         * Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListLibraryPoolsParams.prototype.pageSize;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        ListLibraryPoolsParams.prototype.include;
    }
    /**
     * Parameters for replaceLibraryPoolAcl
     * @record
     */
    function ReplaceLibraryPoolAclParams() { }
    LibraryPoolsService.ReplaceLibraryPoolAclParams = ReplaceLibraryPoolAclParams;
    if (false) {
        /** @type {?} */
        ReplaceLibraryPoolAclParams.prototype.libraryPoolId;
        /** @type {?|undefined} */
        ReplaceLibraryPoolAclParams.prototype.body;
    }
    /**
     * Parameters for mergeLibraryPoolAcl
     * @record
     */
    function MergeLibraryPoolAclParams() { }
    LibraryPoolsService.MergeLibraryPoolAclParams = MergeLibraryPoolAclParams;
    if (false) {
        /** @type {?} */
        MergeLibraryPoolAclParams.prototype.libraryPoolId;
        /** @type {?|undefined} */
        MergeLibraryPoolAclParams.prototype.body;
    }
    /**
     * Parameters for removeLibraryPoolAcl
     * @record
     */
    function RemoveLibraryPoolAclParams() { }
    LibraryPoolsService.RemoveLibraryPoolAclParams = RemoveLibraryPoolAclParams;
    if (false) {
        /** @type {?} */
        RemoveLibraryPoolAclParams.prototype.libraryPoolId;
        /** @type {?|undefined} */
        RemoveLibraryPoolAclParams.prototype.body;
    }
})(LibraryPoolsService || (LibraryPoolsService = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/library-prep-kits.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LibraryPrepKitsService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * Create a library prep kit, and return information about that library prep kit.
     * @param {?=} body undefined
     * @return {?} Library prep kit created successfully.
     */
    createLibraryPrepKitResponse(body) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/libraryPrepKits`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Create a library prep kit, and return information about that library prep kit.
     * @param {?=} body undefined
     * @return {?} Library prep kit created successfully.
     */
    createLibraryPrepKit(body) {
        return this.createLibraryPrepKitResponse(body).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get a list of library prep kits accessible by the current request token.
     * @param {?} params The `LibraryPrepKitsService.ListLibraryPrepKitsParams` containing the following parameters:
     *
     * - `tenantIds`: Optional parameter to limit the response to be with in provided tenant ids
     *   Comma separated to support multiple tenant ids
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Library prep kits found and returned successfully.
     */
    listLibraryPrepKitsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        (params.tenantIds || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('tenantIds', val.toString()); }));
        if (params.sort != null)
            __params = __params.set('sort', params.sort.toString());
        if (params.pageToken != null)
            __params = __params.set('pageToken', params.pageToken.toString());
        if (params.pageSize != null)
            __params = __params.set('pageSize', params.pageSize.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/libraryPrepKits`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get a list of library prep kits accessible by the current request token.
     * @param {?} params The `LibraryPrepKitsService.ListLibraryPrepKitsParams` containing the following parameters:
     *
     * - `tenantIds`: Optional parameter to limit the response to be with in provided tenant ids
     *   Comma separated to support multiple tenant ids
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Library prep kits found and returned successfully.
     */
    listLibraryPrepKits(params) {
        return this.listLibraryPrepKitsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given library prep kit ID, update the associated library prep kit.
     * @param {?} params The `LibraryPrepKitsService.UpdateLibraryPrepKitParams` containing the following parameters:
     *
     * - `libraryPrepKitId`: The id of the requested library prep kit.
     *
     * - `body`: The update request for the library prep kit
     *
     * @return {?} Library prep kit updated successfully.
     */
    updateLibraryPrepKitResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v1/sequencing/libraryPrepKits/${params.libraryPrepKitId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given library prep kit ID, update the associated library prep kit.
     * @param {?} params The `LibraryPrepKitsService.UpdateLibraryPrepKitParams` containing the following parameters:
     *
     * - `libraryPrepKitId`: The id of the requested library prep kit.
     *
     * - `body`: The update request for the library prep kit
     *
     * @return {?} Library prep kit updated successfully.
     */
    updateLibraryPrepKit(params) {
        return this.updateLibraryPrepKitResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given library prep kit ID, return information about that library prep kit.
     * @param {?} params The `LibraryPrepKitsService.GetLibraryPrepKitParams` containing the following parameters:
     *
     * - `libraryPrepKitId`: ID of the library prep kit
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Library prep kit found and details returned successfully.
     */
    getLibraryPrepKitResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/libraryPrepKits/${params.libraryPrepKitId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given library prep kit ID, return information about that library prep kit.
     * @param {?} params The `LibraryPrepKitsService.GetLibraryPrepKitParams` containing the following parameters:
     *
     * - `libraryPrepKitId`: ID of the library prep kit
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Library prep kit found and details returned successfully.
     */
    getLibraryPrepKit(params) {
        return this.getLibraryPrepKitResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given library prep kit ID, delete the library prep kit.
     * @param {?} params The `LibraryPrepKitsService.DeleteLibraryPrepKitParams` containing the following parameters:
     *
     * - `libraryPrepKitId`: ID of the library prep kit
     *
     * - `force`: Force delete the library prep kit
     *
     * @return {?} Library prep kit deleted successfully.
     */
    deleteLibraryPrepKitResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.force != null)
            __params = __params.set('force', params.force.toString());
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/v1/sequencing/libraryPrepKits/${params.libraryPrepKitId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given library prep kit ID, delete the library prep kit.
     * @param {?} params The `LibraryPrepKitsService.DeleteLibraryPrepKitParams` containing the following parameters:
     *
     * - `libraryPrepKitId`: ID of the library prep kit
     *
     * - `force`: Force delete the library prep kit
     *
     * @return {?} Library prep kit deleted successfully.
     */
    deleteLibraryPrepKit(params) {
        return this.deleteLibraryPrepKitResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given library prep kit ID, replace the access control list with the input access control list, and return information about the library prep kit.
     * @param {?} params The `LibraryPrepKitsService.ReplaceLibraryPrepKitAclParams` containing the following parameters:
     *
     * - `libraryPrepKitId`:
     *
     * - `body`:
     *
     * @return {?} Library prep kit access control list updated successfully.
     */
    replaceLibraryPrepKitAclResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PUT', this.rootUrl + `/v1/sequencing/libraryPrepKits/${params.libraryPrepKitId}/acl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given library prep kit ID, replace the access control list with the input access control list, and return information about the library prep kit.
     * @param {?} params The `LibraryPrepKitsService.ReplaceLibraryPrepKitAclParams` containing the following parameters:
     *
     * - `libraryPrepKitId`:
     *
     * - `body`:
     *
     * @return {?} Library prep kit access control list updated successfully.
     */
    replaceLibraryPrepKitAcl(params) {
        return this.replaceLibraryPrepKitAclResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given library prep kit ID, merge the access control list with the input access control list, and return information about the library prep kit
     * @param {?} params The `LibraryPrepKitsService.MergeLibraryPrepKitAclParams` containing the following parameters:
     *
     * - `libraryPrepKitId`:
     *
     * - `body`:
     *
     * @return {?} Library prep kit access control list updated successfully.
     */
    mergeLibraryPrepKitAclResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v1/sequencing/libraryPrepKits/${params.libraryPrepKitId}/acl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given library prep kit ID, merge the access control list with the input access control list, and return information about the library prep kit
     * @param {?} params The `LibraryPrepKitsService.MergeLibraryPrepKitAclParams` containing the following parameters:
     *
     * - `libraryPrepKitId`:
     *
     * - `body`:
     *
     * @return {?} Library prep kit access control list updated successfully.
     */
    mergeLibraryPrepKitAcl(params) {
        return this.mergeLibraryPrepKitAclResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Remove the access control list of a given library prep kit, and return information about that library prep kit.
     * @param {?} params The `LibraryPrepKitsService.RemoveLibraryPrepKitAclParams` containing the following parameters:
     *
     * - `libraryPrepKitId`:
     *
     * - `body`:
     *
     * @return {?} Library prep kit access control list removed successfully.
     */
    removeLibraryPrepKitAclResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/v1/sequencing/libraryPrepKits/${params.libraryPrepKitId}/acl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Remove the access control list of a given library prep kit, and return information about that library prep kit.
     * @param {?} params The `LibraryPrepKitsService.RemoveLibraryPrepKitAclParams` containing the following parameters:
     *
     * - `libraryPrepKitId`:
     *
     * - `body`:
     *
     * @return {?} Library prep kit access control list removed successfully.
     */
    removeLibraryPrepKitAcl(params) {
        return this.removeLibraryPrepKitAclResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
LibraryPrepKitsService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: LibraryPrepKitsService, factory: function LibraryPrepKitsService_Factory(t) { return new (t || LibraryPrepKitsService)(ɵngcc0.ɵɵinject(GssApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(LibraryPrepKitsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GssApiConfiguration }, { type: HttpClient }]; }, { constructor: [], createLibraryPrepKitResponse: [], createLibraryPrepKit: [], listLibraryPrepKitsResponse: [], listLibraryPrepKits: [], updateLibraryPrepKitResponse: [], updateLibraryPrepKit: [], getLibraryPrepKitResponse: [], getLibraryPrepKit: [], deleteLibraryPrepKitResponse: [], deleteLibraryPrepKit: [], replaceLibraryPrepKitAclResponse: [], replaceLibraryPrepKitAcl: [], mergeLibraryPrepKitAclResponse: [], mergeLibraryPrepKitAcl: [], removeLibraryPrepKitAclResponse: [], removeLibraryPrepKitAcl: [] });
LibraryPrepKitsService.createLibraryPrepKitPath = '/v1/sequencing/libraryPrepKits';
LibraryPrepKitsService.listLibraryPrepKitsPath = '/v1/sequencing/libraryPrepKits';
LibraryPrepKitsService.updateLibraryPrepKitPath = '/v1/sequencing/libraryPrepKits/{libraryPrepKitId}';
LibraryPrepKitsService.getLibraryPrepKitPath = '/v1/sequencing/libraryPrepKits/{libraryPrepKitId}';
LibraryPrepKitsService.deleteLibraryPrepKitPath = '/v1/sequencing/libraryPrepKits/{libraryPrepKitId}';
LibraryPrepKitsService.replaceLibraryPrepKitAclPath = '/v1/sequencing/libraryPrepKits/{libraryPrepKitId}/acl';
LibraryPrepKitsService.mergeLibraryPrepKitAclPath = '/v1/sequencing/libraryPrepKits/{libraryPrepKitId}/acl';
LibraryPrepKitsService.removeLibraryPrepKitAclPath = '/v1/sequencing/libraryPrepKits/{libraryPrepKitId}/acl';
/** @nocollapse */
LibraryPrepKitsService.ctorParameters = () => [
    { type: GssApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ LibraryPrepKitsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function LibraryPrepKitsService_Factory() { return new LibraryPrepKitsService(ɵɵinject(GssApiConfiguration), ɵɵinject(HttpClient)); }, token: LibraryPrepKitsService, providedIn: "root" });
if (false) {
    /** @type {?} */
    LibraryPrepKitsService.createLibraryPrepKitPath;
    /** @type {?} */
    LibraryPrepKitsService.listLibraryPrepKitsPath;
    /** @type {?} */
    LibraryPrepKitsService.updateLibraryPrepKitPath;
    /** @type {?} */
    LibraryPrepKitsService.getLibraryPrepKitPath;
    /** @type {?} */
    LibraryPrepKitsService.deleteLibraryPrepKitPath;
    /** @type {?} */
    LibraryPrepKitsService.replaceLibraryPrepKitAclPath;
    /** @type {?} */
    LibraryPrepKitsService.mergeLibraryPrepKitAclPath;
    /** @type {?} */
    LibraryPrepKitsService.removeLibraryPrepKitAclPath;
}
(function (LibraryPrepKitsService) {
    /**
     * Parameters for listLibraryPrepKits
     * @record
     */
    function ListLibraryPrepKitsParams() { }
    LibraryPrepKitsService.ListLibraryPrepKitsParams = ListLibraryPrepKitsParams;
    if (false) {
        /**
         * Optional parameter to limit the response to be with in provided tenant ids
         * Comma separated to support multiple tenant ids
         * @type {?|undefined}
         */
        ListLibraryPrepKitsParams.prototype.tenantIds;
        /**
         * Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
         * @type {?|undefined}
         */
        ListLibraryPrepKitsParams.prototype.sort;
        /**
         * Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListLibraryPrepKitsParams.prototype.pageToken;
        /**
         * Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListLibraryPrepKitsParams.prototype.pageSize;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        ListLibraryPrepKitsParams.prototype.include;
    }
    /**
     * Parameters for updateLibraryPrepKit
     * @record
     */
    function UpdateLibraryPrepKitParams() { }
    LibraryPrepKitsService.UpdateLibraryPrepKitParams = UpdateLibraryPrepKitParams;
    if (false) {
        /**
         * The id of the requested library prep kit.
         * @type {?}
         */
        UpdateLibraryPrepKitParams.prototype.libraryPrepKitId;
        /**
         * The update request for the library prep kit
         * @type {?|undefined}
         */
        UpdateLibraryPrepKitParams.prototype.body;
    }
    /**
     * Parameters for getLibraryPrepKit
     * @record
     */
    function GetLibraryPrepKitParams() { }
    LibraryPrepKitsService.GetLibraryPrepKitParams = GetLibraryPrepKitParams;
    if (false) {
        /**
         * ID of the library prep kit
         * @type {?}
         */
        GetLibraryPrepKitParams.prototype.libraryPrepKitId;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        GetLibraryPrepKitParams.prototype.include;
    }
    /**
     * Parameters for deleteLibraryPrepKit
     * @record
     */
    function DeleteLibraryPrepKitParams() { }
    LibraryPrepKitsService.DeleteLibraryPrepKitParams = DeleteLibraryPrepKitParams;
    if (false) {
        /**
         * ID of the library prep kit
         * @type {?}
         */
        DeleteLibraryPrepKitParams.prototype.libraryPrepKitId;
        /**
         * Force delete the library prep kit
         * @type {?|undefined}
         */
        DeleteLibraryPrepKitParams.prototype.force;
    }
    /**
     * Parameters for replaceLibraryPrepKitAcl
     * @record
     */
    function ReplaceLibraryPrepKitAclParams() { }
    LibraryPrepKitsService.ReplaceLibraryPrepKitAclParams = ReplaceLibraryPrepKitAclParams;
    if (false) {
        /** @type {?} */
        ReplaceLibraryPrepKitAclParams.prototype.libraryPrepKitId;
        /** @type {?|undefined} */
        ReplaceLibraryPrepKitAclParams.prototype.body;
    }
    /**
     * Parameters for mergeLibraryPrepKitAcl
     * @record
     */
    function MergeLibraryPrepKitAclParams() { }
    LibraryPrepKitsService.MergeLibraryPrepKitAclParams = MergeLibraryPrepKitAclParams;
    if (false) {
        /** @type {?} */
        MergeLibraryPrepKitAclParams.prototype.libraryPrepKitId;
        /** @type {?|undefined} */
        MergeLibraryPrepKitAclParams.prototype.body;
    }
    /**
     * Parameters for removeLibraryPrepKitAcl
     * @record
     */
    function RemoveLibraryPrepKitAclParams() { }
    LibraryPrepKitsService.RemoveLibraryPrepKitAclParams = RemoveLibraryPrepKitAclParams;
    if (false) {
        /** @type {?} */
        RemoveLibraryPrepKitAclParams.prototype.libraryPrepKitId;
        /** @type {?|undefined} */
        RemoveLibraryPrepKitAclParams.prototype.body;
    }
})(LibraryPrepKitsService || (LibraryPrepKitsService = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/reference-files.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ReferenceFilesService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * Get a list of reference files.
     *
     * Get a list of reference files accessible by the current request token.
     * @param {?} params The `ReferenceFilesService.ListReferenceFilesParams` containing the following parameters:
     *
     * - `type`: Filter by type of the ReferenceFile
     *
     * - `tenantIds`: Optional parameter to limit the response to be with in provided tenant ids
     *   Comma separated to support multiple tenant ids
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `name`: Filter by Name of the reference file
     *
     * - `isIllumina`: Optional parameter. Set to true to filter only Illumina specific reference files
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * - `genomeId`: Filter reference files by ID of supported Genome
     *
     * @return {?} ReferenceFiles returned successfully.
     */
    listReferenceFilesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.type != null)
            __params = __params.set('type', params.type.toString());
        (params.tenantIds || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('tenantIds', val.toString()); }));
        if (params.sort != null)
            __params = __params.set('sort', params.sort.toString());
        if (params.pageToken != null)
            __params = __params.set('pageToken', params.pageToken.toString());
        if (params.pageSize != null)
            __params = __params.set('pageSize', params.pageSize.toString());
        if (params.name != null)
            __params = __params.set('name', params.name.toString());
        if (params.isIllumina != null)
            __params = __params.set('isIllumina', params.isIllumina.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        if (params.genomeId != null)
            __params = __params.set('genomeId', params.genomeId.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/referencefiles`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get a list of reference files.
     *
     * Get a list of reference files accessible by the current request token.
     * @param {?} params The `ReferenceFilesService.ListReferenceFilesParams` containing the following parameters:
     *
     * - `type`: Filter by type of the ReferenceFile
     *
     * - `tenantIds`: Optional parameter to limit the response to be with in provided tenant ids
     *   Comma separated to support multiple tenant ids
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `name`: Filter by Name of the reference file
     *
     * - `isIllumina`: Optional parameter. Set to true to filter only Illumina specific reference files
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * - `genomeId`: Filter reference files by ID of supported Genome
     *
     * @return {?} ReferenceFiles returned successfully.
     */
    listReferenceFiles(params) {
        return this.listReferenceFilesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Create a reference file.
     *
     * Create a reference file, and return information about that reference file.
     * @param {?=} body undefined
     * @return {?} ReferenceFile created successfully.
     */
    createReferenceFileResponse(body) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/referencefiles`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Create a reference file.
     *
     * Create a reference file, and return information about that reference file.
     * @param {?=} body undefined
     * @return {?} ReferenceFile created successfully.
     */
    createReferenceFile(body) {
        return this.createReferenceFileResponse(body).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Delete reference file.
     *
     * For a given reference file ID, delete the reference file.
     * @param {?} params The `ReferenceFilesService.DeleteReferenceFileParams` containing the following parameters:
     *
     * - `referenceFileId`: ID of the reference file
     *
     * - `force`: Force delete the reference file
     *
     * @return {?} Reference file deleted successfully.
     */
    deleteReferenceFileResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.force != null)
            __params = __params.set('force', params.force.toString());
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/v1/sequencing/referencefiles/${encodeURIComponent(String(params.referenceFileId))}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Delete reference file.
     *
     * For a given reference file ID, delete the reference file.
     * @param {?} params The `ReferenceFilesService.DeleteReferenceFileParams` containing the following parameters:
     *
     * - `referenceFileId`: ID of the reference file
     *
     * - `force`: Force delete the reference file
     *
     * @return {?} Reference file deleted successfully.
     */
    deleteReferenceFile(params) {
        return this.deleteReferenceFileResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Update a reference file.
     *
     * Update a reference file, and return information about that reference file.
     * @param {?} params The `ReferenceFilesService.UpdateReferenceFileParams` containing the following parameters:
     *
     * - `referenceFileId`:
     *
     * - `body`:
     *
     * @return {?} ReferenceFile is updated successfully.
     */
    updateReferenceFileResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v1/sequencing/referencefiles/${encodeURIComponent(String(params.referenceFileId))}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Update a reference file.
     *
     * Update a reference file, and return information about that reference file.
     * @param {?} params The `ReferenceFilesService.UpdateReferenceFileParams` containing the following parameters:
     *
     * - `referenceFileId`:
     *
     * - `body`:
     *
     * @return {?} ReferenceFile is updated successfully.
     */
    updateReferenceFile(params) {
        return this.updateReferenceFileResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get a reference file.
     *
     * Get a reference file, and return information about that reference file.
     * @param {?} params The `ReferenceFilesService.GetReferenceFileParams` containing the following parameters:
     *
     * - `referenceFileId`: ID of the reference file
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} ReferenceFile is retrieved successfully.
     */
    getReferenceFileResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/referencefiles/${encodeURIComponent(String(params.referenceFileId))}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get a reference file.
     *
     * Get a reference file, and return information about that reference file.
     * @param {?} params The `ReferenceFilesService.GetReferenceFileParams` containing the following parameters:
     *
     * - `referenceFileId`: ID of the reference file
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} ReferenceFile is retrieved successfully.
     */
    getReferenceFile(params) {
        return this.getReferenceFileResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get a list of reference file types.
     *
     * Get a list of reference file types accessible by the current user.
     * @return {?} ReferenceFileTypes are returned successfully.
     */
    listReferenceFileTypesResponse() {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/referencefiles/fileTypes`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get a list of reference file types.
     *
     * Get a list of reference file types accessible by the current user.
     * @return {?} ReferenceFileTypes are returned successfully.
     */
    listReferenceFileTypes() {
        return this.listReferenceFileTypesResponse().pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
ReferenceFilesService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: ReferenceFilesService, factory: function ReferenceFilesService_Factory(t) { return new (t || ReferenceFilesService)(ɵngcc0.ɵɵinject(GssApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(ReferenceFilesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GssApiConfiguration }, { type: HttpClient }]; }, { constructor: [], listReferenceFilesResponse: [], listReferenceFiles: [], createReferenceFileResponse: [], createReferenceFile: [], deleteReferenceFileResponse: [], deleteReferenceFile: [], updateReferenceFileResponse: [], updateReferenceFile: [], getReferenceFileResponse: [], getReferenceFile: [], listReferenceFileTypesResponse: [], listReferenceFileTypes: [] });
ReferenceFilesService.listReferenceFilesPath = '/v1/sequencing/referencefiles';
ReferenceFilesService.createReferenceFilePath = '/v1/sequencing/referencefiles';
ReferenceFilesService.deleteReferenceFilePath = '/v1/sequencing/referencefiles/{referenceFileId}';
ReferenceFilesService.updateReferenceFilePath = '/v1/sequencing/referencefiles/{referenceFileId}';
ReferenceFilesService.getReferenceFilePath = '/v1/sequencing/referencefiles/{referenceFileId}';
ReferenceFilesService.listReferenceFileTypesPath = '/v1/sequencing/referencefiles/fileTypes';
/** @nocollapse */
ReferenceFilesService.ctorParameters = () => [
    { type: GssApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ ReferenceFilesService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ReferenceFilesService_Factory() { return new ReferenceFilesService(ɵɵinject(GssApiConfiguration), ɵɵinject(HttpClient)); }, token: ReferenceFilesService, providedIn: "root" });
if (false) {
    /** @type {?} */
    ReferenceFilesService.listReferenceFilesPath;
    /** @type {?} */
    ReferenceFilesService.createReferenceFilePath;
    /** @type {?} */
    ReferenceFilesService.deleteReferenceFilePath;
    /** @type {?} */
    ReferenceFilesService.updateReferenceFilePath;
    /** @type {?} */
    ReferenceFilesService.getReferenceFilePath;
    /** @type {?} */
    ReferenceFilesService.listReferenceFileTypesPath;
}
(function (ReferenceFilesService) {
    /**
     * Parameters for listReferenceFiles
     * @record
     */
    function ListReferenceFilesParams() { }
    ReferenceFilesService.ListReferenceFilesParams = ListReferenceFilesParams;
    if (false) {
        /**
         * Filter by type of the ReferenceFile
         * @type {?|undefined}
         */
        ListReferenceFilesParams.prototype.type;
        /**
         * Optional parameter to limit the response to be with in provided tenant ids
         * Comma separated to support multiple tenant ids
         * @type {?|undefined}
         */
        ListReferenceFilesParams.prototype.tenantIds;
        /**
         * Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
         * @type {?|undefined}
         */
        ListReferenceFilesParams.prototype.sort;
        /**
         * Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListReferenceFilesParams.prototype.pageToken;
        /**
         * Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListReferenceFilesParams.prototype.pageSize;
        /**
         * Filter by Name of the reference file
         * @type {?|undefined}
         */
        ListReferenceFilesParams.prototype.name;
        /**
         * Optional parameter. Set to true to filter only Illumina specific reference files
         * @type {?|undefined}
         */
        ListReferenceFilesParams.prototype.isIllumina;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        ListReferenceFilesParams.prototype.include;
        /**
         * Filter reference files by ID of supported Genome
         * @type {?|undefined}
         */
        ListReferenceFilesParams.prototype.genomeId;
    }
    /**
     * Parameters for deleteReferenceFile
     * @record
     */
    function DeleteReferenceFileParams() { }
    ReferenceFilesService.DeleteReferenceFileParams = DeleteReferenceFileParams;
    if (false) {
        /**
         * ID of the reference file
         * @type {?}
         */
        DeleteReferenceFileParams.prototype.referenceFileId;
        /**
         * Force delete the reference file
         * @type {?|undefined}
         */
        DeleteReferenceFileParams.prototype.force;
    }
    /**
     * Parameters for updateReferenceFile
     * @record
     */
    function UpdateReferenceFileParams() { }
    ReferenceFilesService.UpdateReferenceFileParams = UpdateReferenceFileParams;
    if (false) {
        /** @type {?} */
        UpdateReferenceFileParams.prototype.referenceFileId;
        /** @type {?|undefined} */
        UpdateReferenceFileParams.prototype.body;
    }
    /**
     * Parameters for getReferenceFile
     * @record
     */
    function GetReferenceFileParams() { }
    ReferenceFilesService.GetReferenceFileParams = GetReferenceFileParams;
    if (false) {
        /**
         * ID of the reference file
         * @type {?}
         */
        GetReferenceFileParams.prototype.referenceFileId;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        GetReferenceFileParams.prototype.include;
    }
})(ReferenceFilesService || (ReferenceFilesService = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/samples.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SamplesService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * Create a sample, and return information about that sample.
     * @param {?=} body undefined
     * @return {?} Sample created successfully.
     */
    createSampleResponse(body) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/samples`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Create a sample, and return information about that sample.
     * @param {?=} body undefined
     * @return {?} Sample created successfully.
     */
    createSample(body) {
        return this.createSampleResponse(body).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get a list of samples accessible by the request token.
     * @param {?} params The `SamplesService.ListSamplesParams` containing the following parameters:
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `projectName`: Optional parameter. Set to filter the sample list and only include samples with the specified ProjectName.
     *   Note: This field is an alias of DataAggregationGroup field until DataAggregationGroups is deprecated.
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `name`: Optional parameter. Set to filter the sample list and only include samples with the specified name.
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * - `dataAggregationGroup`: Optional parameter. Set to filter the sample list and only include samples with the specified dataAggregationGroup.
     *
     * @return {?} Sample list returned successfully.
     */
    listSamplesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sort != null)
            __params = __params.set('sort', params.sort.toString());
        if (params.projectName != null)
            __params = __params.set('projectName', params.projectName.toString());
        if (params.pageToken != null)
            __params = __params.set('pageToken', params.pageToken.toString());
        if (params.pageSize != null)
            __params = __params.set('pageSize', params.pageSize.toString());
        if (params.name != null)
            __params = __params.set('name', params.name.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        if (params.dataAggregationGroup != null)
            __params = __params.set('dataAggregationGroup', params.dataAggregationGroup.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/samples`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get a list of samples accessible by the request token.
     * @param {?} params The `SamplesService.ListSamplesParams` containing the following parameters:
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `projectName`: Optional parameter. Set to filter the sample list and only include samples with the specified ProjectName.
     *   Note: This field is an alias of DataAggregationGroup field until DataAggregationGroups is deprecated.
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `name`: Optional parameter. Set to filter the sample list and only include samples with the specified name.
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * - `dataAggregationGroup`: Optional parameter. Set to filter the sample list and only include samples with the specified dataAggregationGroup.
     *
     * @return {?} Sample list returned successfully.
     */
    listSamples(params) {
        return this.listSamplesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given sample ID, update sample information.
     * @param {?} params The `SamplesService.UpdateSampleParams` containing the following parameters:
     *
     * - `sampleId`:
     *
     * - `body`:
     *
     * @return {?} Sample updated successfully.
     */
    updateSampleResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v1/sequencing/samples/${params.sampleId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given sample ID, update sample information.
     * @param {?} params The `SamplesService.UpdateSampleParams` containing the following parameters:
     *
     * - `sampleId`:
     *
     * - `body`:
     *
     * @return {?} Sample updated successfully.
     */
    updateSample(params) {
        return this.updateSampleResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given sample ID, return information about that sample.
     * @param {?} sampleId The ID of the requested sample.
     * @return {?} Sample details returned successfully.
     */
    getSampleResponse(sampleId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/samples/${sampleId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given sample ID, return information about that sample.
     * @param {?} sampleId The ID of the requested sample.
     * @return {?} Sample details returned successfully.
     */
    getSample(sampleId) {
        return this.getSampleResponse(sampleId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given sample ID, return a list of associated analysis datasets.
     * @param {?} params The `SamplesService.ListSampleAnalysisDatasetsParams` containing the following parameters:
     *
     * - `sampleId`:
     *
     * - `type`: The analysis dataset types requested.
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `include`: Available include flags for list of analysisDatasets associated with a sample
     *
     * @return {?} Analysis datasets returned successfully.
     */
    listSampleAnalysisDatasetsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        (params.type || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('type', val.toString()); }));
        if (params.sort != null)
            __params = __params.set('sort', params.sort.toString());
        if (params.pageToken != null)
            __params = __params.set('pageToken', params.pageToken.toString());
        if (params.pageSize != null)
            __params = __params.set('pageSize', params.pageSize.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/samples/${params.sampleId}/analysisDatasets`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given sample ID, return a list of associated analysis datasets.
     * @param {?} params The `SamplesService.ListSampleAnalysisDatasetsParams` containing the following parameters:
     *
     * - `sampleId`:
     *
     * - `type`: The analysis dataset types requested.
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `include`: Available include flags for list of analysisDatasets associated with a sample
     *
     * @return {?} Analysis datasets returned successfully.
     */
    listSampleAnalysisDatasets(params) {
        return this.listSampleAnalysisDatasetsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Deliver samples to allow subscription in ENS.
     * @param {?=} body undefined
     * @return {?} Sample delivered successfully.
     */
    deliverSamplesResponse(body) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/samples:delivery`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Deliver samples to allow subscription in ENS.
     * @param {?=} body undefined
     * @return {?} Sample delivered successfully.
     */
    deliverSamples(body) {
        return this.deliverSamplesResponse(body).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Register data for a sample that may or may not exist yet.
     * @param {?=} body undefined
     * @return {?} Sample data added successfully.
     */
    registerSampleDataResponse(body) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/samples:registerData`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Register data for a sample that may or may not exist yet.
     * @param {?=} body undefined
     * @return {?} Sample data added successfully.
     */
    registerSampleData(body) {
        return this.registerSampleDataResponse(body).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Replace the access control list of a sample with the input access control list, and return information about that sample.
     * @param {?} params The `SamplesService.ReplaceSampleAclParams` containing the following parameters:
     *
     * - `sampleId`:
     *
     * - `body`:
     *
     * @return {?} Access control list of sample updated successfully.
     */
    replaceSampleAclResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PUT', this.rootUrl + `/v1/sequencing/samples/${params.sampleId}/acl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Replace the access control list of a sample with the input access control list, and return information about that sample.
     * @param {?} params The `SamplesService.ReplaceSampleAclParams` containing the following parameters:
     *
     * - `sampleId`:
     *
     * - `body`:
     *
     * @return {?} Access control list of sample updated successfully.
     */
    replaceSampleAcl(params) {
        return this.replaceSampleAclResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Merge the access control list of a given sample with the input access control list, and return information about that sample.
     * @param {?} params The `SamplesService.MergeSampleAclParams` containing the following parameters:
     *
     * - `sampleId`:
     *
     * - `body`:
     *
     * @return {?} Access control list updated successfully.
     */
    mergeSampleAclResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v1/sequencing/samples/${params.sampleId}/acl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Merge the access control list of a given sample with the input access control list, and return information about that sample.
     * @param {?} params The `SamplesService.MergeSampleAclParams` containing the following parameters:
     *
     * - `sampleId`:
     *
     * - `body`:
     *
     * @return {?} Access control list updated successfully.
     */
    mergeSampleAcl(params) {
        return this.mergeSampleAclResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Remove the access control list of a given sample, and return information about that sample.
     * @param {?} params The `SamplesService.RemoveSampleAclParams` containing the following parameters:
     *
     * - `sampleId`:
     *
     * - `body`:
     *
     * @return {?} Input access control list removed successfully.
     */
    removeSampleAclResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/v1/sequencing/samples/${params.sampleId}/acl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Remove the access control list of a given sample, and return information about that sample.
     * @param {?} params The `SamplesService.RemoveSampleAclParams` containing the following parameters:
     *
     * - `sampleId`:
     *
     * - `body`:
     *
     * @return {?} Input access control list removed successfully.
     */
    removeSampleAcl(params) {
        return this.removeSampleAclResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
SamplesService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: SamplesService, factory: function SamplesService_Factory(t) { return new (t || SamplesService)(ɵngcc0.ɵɵinject(GssApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(SamplesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GssApiConfiguration }, { type: HttpClient }]; }, { constructor: [], createSampleResponse: [], createSample: [], listSamplesResponse: [], listSamples: [], updateSampleResponse: [], updateSample: [], getSampleResponse: [], getSample: [], listSampleAnalysisDatasetsResponse: [], listSampleAnalysisDatasets: [], deliverSamplesResponse: [], deliverSamples: [], registerSampleDataResponse: [], registerSampleData: [], replaceSampleAclResponse: [], replaceSampleAcl: [], mergeSampleAclResponse: [], mergeSampleAcl: [], removeSampleAclResponse: [], removeSampleAcl: [] });
SamplesService.createSamplePath = '/v1/sequencing/samples';
SamplesService.listSamplesPath = '/v1/sequencing/samples';
SamplesService.updateSamplePath = '/v1/sequencing/samples/{sampleId}';
SamplesService.getSamplePath = '/v1/sequencing/samples/{sampleId}';
SamplesService.listSampleAnalysisDatasetsPath = '/v1/sequencing/samples/{sampleId}/analysisDatasets';
SamplesService.deliverSamplesPath = '/v1/sequencing/samples:delivery';
SamplesService.registerSampleDataPath = '/v1/sequencing/samples:registerData';
SamplesService.replaceSampleAclPath = '/v1/sequencing/samples/{sampleId}/acl';
SamplesService.mergeSampleAclPath = '/v1/sequencing/samples/{sampleId}/acl';
SamplesService.removeSampleAclPath = '/v1/sequencing/samples/{sampleId}/acl';
/** @nocollapse */
SamplesService.ctorParameters = () => [
    { type: GssApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ SamplesService.ngInjectableDef = ɵɵdefineInjectable({ factory: function SamplesService_Factory() { return new SamplesService(ɵɵinject(GssApiConfiguration), ɵɵinject(HttpClient)); }, token: SamplesService, providedIn: "root" });
if (false) {
    /** @type {?} */
    SamplesService.createSamplePath;
    /** @type {?} */
    SamplesService.listSamplesPath;
    /** @type {?} */
    SamplesService.updateSamplePath;
    /** @type {?} */
    SamplesService.getSamplePath;
    /** @type {?} */
    SamplesService.listSampleAnalysisDatasetsPath;
    /** @type {?} */
    SamplesService.deliverSamplesPath;
    /** @type {?} */
    SamplesService.registerSampleDataPath;
    /** @type {?} */
    SamplesService.replaceSampleAclPath;
    /** @type {?} */
    SamplesService.mergeSampleAclPath;
    /** @type {?} */
    SamplesService.removeSampleAclPath;
}
(function (SamplesService) {
    /**
     * Parameters for listSamples
     * @record
     */
    function ListSamplesParams() { }
    SamplesService.ListSamplesParams = ListSamplesParams;
    if (false) {
        /**
         * Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
         * @type {?|undefined}
         */
        ListSamplesParams.prototype.sort;
        /**
         * Optional parameter. Set to filter the sample list and only include samples with the specified ProjectName.
         * Note: This field is an alias of DataAggregationGroup field until DataAggregationGroups is deprecated.
         * @type {?|undefined}
         */
        ListSamplesParams.prototype.projectName;
        /**
         * Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListSamplesParams.prototype.pageToken;
        /**
         * Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListSamplesParams.prototype.pageSize;
        /**
         * Optional parameter. Set to filter the sample list and only include samples with the specified name.
         * @type {?|undefined}
         */
        ListSamplesParams.prototype.name;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        ListSamplesParams.prototype.include;
        /**
         * Optional parameter. Set to filter the sample list and only include samples with the specified dataAggregationGroup.
         * @type {?|undefined}
         */
        ListSamplesParams.prototype.dataAggregationGroup;
    }
    /**
     * Parameters for updateSample
     * @record
     */
    function UpdateSampleParams() { }
    SamplesService.UpdateSampleParams = UpdateSampleParams;
    if (false) {
        /** @type {?} */
        UpdateSampleParams.prototype.sampleId;
        /** @type {?|undefined} */
        UpdateSampleParams.prototype.body;
    }
    /**
     * Parameters for listSampleAnalysisDatasets
     * @record
     */
    function ListSampleAnalysisDatasetsParams() { }
    SamplesService.ListSampleAnalysisDatasetsParams = ListSampleAnalysisDatasetsParams;
    if (false) {
        /** @type {?} */
        ListSampleAnalysisDatasetsParams.prototype.sampleId;
        /**
         * The analysis dataset types requested.
         * @type {?|undefined}
         */
        ListSampleAnalysisDatasetsParams.prototype.type;
        /**
         * Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
         * @type {?|undefined}
         */
        ListSampleAnalysisDatasetsParams.prototype.sort;
        /**
         * Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListSampleAnalysisDatasetsParams.prototype.pageToken;
        /**
         * Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListSampleAnalysisDatasetsParams.prototype.pageSize;
        /**
         * Available include flags for list of analysisDatasets associated with a sample
         * @type {?|undefined}
         */
        ListSampleAnalysisDatasetsParams.prototype.include;
    }
    /**
     * Parameters for replaceSampleAcl
     * @record
     */
    function ReplaceSampleAclParams() { }
    SamplesService.ReplaceSampleAclParams = ReplaceSampleAclParams;
    if (false) {
        /** @type {?} */
        ReplaceSampleAclParams.prototype.sampleId;
        /** @type {?|undefined} */
        ReplaceSampleAclParams.prototype.body;
    }
    /**
     * Parameters for mergeSampleAcl
     * @record
     */
    function MergeSampleAclParams() { }
    SamplesService.MergeSampleAclParams = MergeSampleAclParams;
    if (false) {
        /** @type {?} */
        MergeSampleAclParams.prototype.sampleId;
        /** @type {?|undefined} */
        MergeSampleAclParams.prototype.body;
    }
    /**
     * Parameters for removeSampleAcl
     * @record
     */
    function RemoveSampleAclParams() { }
    SamplesService.RemoveSampleAclParams = RemoveSampleAclParams;
    if (false) {
        /** @type {?} */
        RemoveSampleAclParams.prototype.sampleId;
        /** @type {?|undefined} */
        RemoveSampleAclParams.prototype.body;
    }
})(SamplesService || (SamplesService = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/sample-sheets.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SampleSheetsService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * Generate a sample sheet, and return information about that sample sheet.
     * @param {?=} body undefined
     * @return {?} Sample sheet generated successfully.
     */
    generateSampleSheetResponse(body) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing:generateSampleSheet`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Generate a sample sheet, and return information about that sample sheet.
     * @param {?=} body undefined
     * @return {?} Sample sheet generated successfully.
     */
    generateSampleSheet(body) {
        return this.generateSampleSheetResponse(body).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Parse a sample sheet, and return information about that run.
     * @param {?=} body undefined
     * @return {?} Sample sheet parsed successfully.
     */
    parseSampleSheetResponse(body) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing:parseSampleSheet`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Parse a sample sheet, and return information about that run.
     * @param {?=} body undefined
     * @return {?} Sample sheet parsed successfully.
     */
    parseSampleSheet(body) {
        return this.parseSampleSheetResponse(body).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Transform a sample sheet, and return a sequencing run model.
     * @param {?=} body undefined
     * @return {?} Sample sheet is transformed successfully.
     */
    transformSampleSheetResponse(body) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing:transformSampleSheet`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Transform a sample sheet, and return a sequencing run model.
     * @param {?=} body undefined
     * @return {?} Sample sheet is transformed successfully.
     */
    transformSampleSheet(body) {
        return this.transformSampleSheetResponse(body).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
SampleSheetsService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: SampleSheetsService, factory: function SampleSheetsService_Factory(t) { return new (t || SampleSheetsService)(ɵngcc0.ɵɵinject(GssApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(SampleSheetsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GssApiConfiguration }, { type: HttpClient }]; }, { constructor: [], generateSampleSheetResponse: [], generateSampleSheet: [], parseSampleSheetResponse: [], parseSampleSheet: [], transformSampleSheetResponse: [], transformSampleSheet: [] });
SampleSheetsService.generateSampleSheetPath = '/v1/sequencing:generateSampleSheet';
SampleSheetsService.parseSampleSheetPath = '/v1/sequencing:parseSampleSheet';
SampleSheetsService.transformSampleSheetPath = '/v1/sequencing:transformSampleSheet';
/** @nocollapse */
SampleSheetsService.ctorParameters = () => [
    { type: GssApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ SampleSheetsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function SampleSheetsService_Factory() { return new SampleSheetsService(ɵɵinject(GssApiConfiguration), ɵɵinject(HttpClient)); }, token: SampleSheetsService, providedIn: "root" });
if (false) {
    /** @type {?} */
    SampleSheetsService.generateSampleSheetPath;
    /** @type {?} */
    SampleSheetsService.parseSampleSheetPath;
    /** @type {?} */
    SampleSheetsService.transformSampleSheetPath;
}

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/sequencing-runs.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SequencingRunsService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * For a given run ID, create an analysis configuration and return information about that analysis configuration.
     * @param {?} params The `SequencingRunsService.CreateAnalysisConfigurationParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Analysis configuration created successfully.
     */
    createAnalysisConfigurationResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/runs/${params.runId}/analyses`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given run ID, create an analysis configuration and return information about that analysis configuration.
     * @param {?} params The `SequencingRunsService.CreateAnalysisConfigurationParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Analysis configuration created successfully.
     */
    createAnalysisConfiguration(params) {
        return this.createAnalysisConfigurationResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * List analysis configurations for a given run ID.
     * @param {?} params The `SequencingRunsService.ListAnalysisConfigurationsParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `include`: Include flags to specify what is included in the request
     *
     * @return {?} Analysis configurations returned successfully.
     */
    listAnalysisConfigurationsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sort != null)
            __params = __params.set('sort', params.sort.toString());
        if (params.pageToken != null)
            __params = __params.set('pageToken', params.pageToken.toString());
        if (params.pageSize != null)
            __params = __params.set('pageSize', params.pageSize.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/runs/${params.runId}/analyses`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * List analysis configurations for a given run ID.
     * @param {?} params The `SequencingRunsService.ListAnalysisConfigurationsParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `include`: Include flags to specify what is included in the request
     *
     * @return {?} Analysis configurations returned successfully.
     */
    listAnalysisConfigurations(params) {
        return this.listAnalysisConfigurationsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given run ID, delete an analysis configuration and return information about that analysis configuration.
     * @param {?} id undefined
     * @return {?}
     */
    deleteAnalysisConfigurationResponse(id) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/v1/sequencing/runs/analyses/${id}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given run ID, delete an analysis configuration and return information about that analysis configuration.
     * @param {?} id undefined
     * @return {?}
     */
    deleteAnalysisConfiguration(id) {
        return this.deleteAnalysisConfigurationResponse(id).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Update an analysis configuration, and return information about that analysis configuration.
     * @param {?} params The `SequencingRunsService.UpdateAnalysisConfigurationParams` containing the following parameters:
     *
     * - `id`:
     *
     * - `body`:
     *
     * @return {?} Analysis configuration updated successfully.
     */
    updateAnalysisConfigurationResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v1/sequencing/runs/analyses/${params.id}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Update an analysis configuration, and return information about that analysis configuration.
     * @param {?} params The `SequencingRunsService.UpdateAnalysisConfigurationParams` containing the following parameters:
     *
     * - `id`:
     *
     * - `body`:
     *
     * @return {?} Analysis configuration updated successfully.
     */
    updateAnalysisConfiguration(params) {
        return this.updateAnalysisConfigurationResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given a run ID, get the content of the sequencing run.
     * @param {?} params The `SequencingRunsService.GetSequencingRunContentsParams` containing the following parameters:
     *
     * - `runId`: ID of the sequencing run
     *
     * - `useFlatRunContent`: Use LaneLibraries instead of LaneContents field as run content input
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Sequencing run content returned successfully.
     */
    getSequencingRunContentsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.useFlatRunContent != null)
            __params = __params.set('useFlatRunContent', params.useFlatRunContent.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/runs/${params.runId}/contents`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given a run ID, get the content of the sequencing run.
     * @param {?} params The `SequencingRunsService.GetSequencingRunContentsParams` containing the following parameters:
     *
     * - `runId`: ID of the sequencing run
     *
     * - `useFlatRunContent`: Use LaneLibraries instead of LaneContents field as run content input
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Sequencing run content returned successfully.
     */
    getSequencingRunContents(params) {
        return this.getSequencingRunContentsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given a run ID, update the sequencing run content with the current token’s tenant ID.
     * @param {?} params The `SequencingRunsService.UpdateSequencingRunContentsParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} SequencingRun content for the given runId is updated successfully.
     */
    updateSequencingRunContentsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PUT', this.rootUrl + `/v1/sequencing/runs/${params.runId}/contents`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given a run ID, update the sequencing run content with the current token’s tenant ID.
     * @param {?} params The `SequencingRunsService.UpdateSequencingRunContentsParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} SequencingRun content for the given runId is updated successfully.
     */
    updateSequencingRunContents(params) {
        return this.updateSequencingRunContentsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get a list of sequencing runs accessible by the request token.
     * @param {?} params The `SequencingRunsService.ListSequencingRunsParams` containing the following parameters:
     *
     * - `tenantIds`: Optional parameter to limit the response to be with in provided tenant ids
     *   Comma separated to support multiple tenant ids
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `search`: Optional parameter. Used to search for keyword in sequencing run fields
     *   such as (RunName, FlowCellBarcode, InputContainerIdentifier)
     *
     * - `runOrigin`: Optional field. Used to filter the sequencing runs list by comma-separated RunOrigins values, e.g.  <example>Instrument,Simulator</example>
     *
     * - `runName`: Filter by name of the sequencing run
     *
     * - `requeuedFromRunId`: Filter By Requeued Run Id
     *
     * - `regulatoryMode`: Filter by regulatory modes using comma separated values, e.g <example>RUO,IVD,IUO</example>
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `isPlanned`: Optional parameter. Set to true to filter the run list and only include planned runs.
     *
     * - `isLocked`: Optional parameter. Set to true to filter the run list and only include locked runs.
     *
     * - `isFavorite`: Optional parameter. Set to true to filter the run list and only include favorite runs.
     *
     * - `isDraft`: Optional parameter. Set to true to filter the run list and only include draft runs.
     *
     * - `isCompleted`: Optional parameter. Set to true to filter the run list and only include completed (failed, aborted, successfully completed) runs.
     *
     * - `instrumentType`: Optional parameter. Set to true to filter the run list and only include runs performed by the specified instrument type.
     *
     * - `inputContainerIdentifier`: Filter by Input container identifier
     *
     * - `includeCompletedBeforeDate`: Optional parameter. Show runs that were completed before the provided Date as well as runs that are not completed
     *
     * - `includeCompletedAfterDate`: Optional parameter. Show runs that were completed after the provided Date as well as runs that are not completed
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * - `flowCellBarcode`: Filter by flowcell barcode
     *
     * - `aggregateRunStatus`: Optional field. Used to filter the sequencing runs list by comma-separated AggregateRunStatus values, e.g <example>Aborted,Deleted,Running</example>
     *
     * @return {?} List of sequencing runs returned successfully.
     */
    listSequencingRunsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        (params.tenantIds || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('tenantIds', val.toString()); }));
        if (params.sort != null)
            __params = __params.set('sort', params.sort.toString());
        if (params.search != null)
            __params = __params.set('search', params.search.toString());
        (params.runOrigin || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('runOrigin', val.toString()); }));
        (params.runName || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('runName', val.toString()); }));
        if (params.requeuedFromRunId != null)
            __params = __params.set('requeuedFromRunId', params.requeuedFromRunId.toString());
        (params.regulatoryMode || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('regulatoryMode', val.toString()); }));
        if (params.pageToken != null)
            __params = __params.set('pageToken', params.pageToken.toString());
        if (params.pageSize != null)
            __params = __params.set('pageSize', params.pageSize.toString());
        if (params.isPlanned != null)
            __params = __params.set('isPlanned', params.isPlanned.toString());
        if (params.isLocked != null)
            __params = __params.set('isLocked', params.isLocked.toString());
        if (params.isFavorite != null)
            __params = __params.set('isFavorite', params.isFavorite.toString());
        if (params.isDraft != null)
            __params = __params.set('isDraft', params.isDraft.toString());
        if (params.isCompleted != null)
            __params = __params.set('isCompleted', params.isCompleted.toString());
        if (params.instrumentType != null)
            __params = __params.set('instrumentType', params.instrumentType.toString());
        if (params.inputContainerIdentifier != null)
            __params = __params.set('inputContainerIdentifier', params.inputContainerIdentifier.toString());
        if (params.includeCompletedBeforeDate != null)
            __params = __params.set('includeCompletedBeforeDate', params.includeCompletedBeforeDate.toString());
        if (params.includeCompletedAfterDate != null)
            __params = __params.set('includeCompletedAfterDate', params.includeCompletedAfterDate.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        if (params.flowCellBarcode != null)
            __params = __params.set('flowCellBarcode', params.flowCellBarcode.toString());
        (params.aggregateRunStatus || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('aggregateRunStatus', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/runs`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get a list of sequencing runs accessible by the request token.
     * @param {?} params The `SequencingRunsService.ListSequencingRunsParams` containing the following parameters:
     *
     * - `tenantIds`: Optional parameter to limit the response to be with in provided tenant ids
     *   Comma separated to support multiple tenant ids
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `search`: Optional parameter. Used to search for keyword in sequencing run fields
     *   such as (RunName, FlowCellBarcode, InputContainerIdentifier)
     *
     * - `runOrigin`: Optional field. Used to filter the sequencing runs list by comma-separated RunOrigins values, e.g.  <example>Instrument,Simulator</example>
     *
     * - `runName`: Filter by name of the sequencing run
     *
     * - `requeuedFromRunId`: Filter By Requeued Run Id
     *
     * - `regulatoryMode`: Filter by regulatory modes using comma separated values, e.g <example>RUO,IVD,IUO</example>
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `isPlanned`: Optional parameter. Set to true to filter the run list and only include planned runs.
     *
     * - `isLocked`: Optional parameter. Set to true to filter the run list and only include locked runs.
     *
     * - `isFavorite`: Optional parameter. Set to true to filter the run list and only include favorite runs.
     *
     * - `isDraft`: Optional parameter. Set to true to filter the run list and only include draft runs.
     *
     * - `isCompleted`: Optional parameter. Set to true to filter the run list and only include completed (failed, aborted, successfully completed) runs.
     *
     * - `instrumentType`: Optional parameter. Set to true to filter the run list and only include runs performed by the specified instrument type.
     *
     * - `inputContainerIdentifier`: Filter by Input container identifier
     *
     * - `includeCompletedBeforeDate`: Optional parameter. Show runs that were completed before the provided Date as well as runs that are not completed
     *
     * - `includeCompletedAfterDate`: Optional parameter. Show runs that were completed after the provided Date as well as runs that are not completed
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * - `flowCellBarcode`: Filter by flowcell barcode
     *
     * - `aggregateRunStatus`: Optional field. Used to filter the sequencing runs list by comma-separated AggregateRunStatus values, e.g <example>Aborted,Deleted,Running</example>
     *
     * @return {?} List of sequencing runs returned successfully.
     */
    listSequencingRuns(params) {
        return this.listSequencingRunsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Create a sequencing run, and return information about that run. Must provide instrumentRunId, runOrigin, runName and runMode.
     * @param {?=} body undefined
     * @return {?} Sequencing run created successfully.
     */
    createSequencingRunResponse(body) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/runs`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Create a sequencing run, and return information about that run. Must provide instrumentRunId, runOrigin, runName and runMode.
     * @param {?=} body undefined
     * @return {?} Sequencing run created successfully.
     */
    createSequencingRun(body) {
        return this.createSequencingRunResponse(body).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given sequencing run ID, get the associated run information.
     * @param {?} params The `SequencingRunsService.GetSequencingRunParams` containing the following parameters:
     *
     * - `runId`: ID of the sequencing run
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Sequencing run details returned successfully.
     */
    getSequencingRunResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/runs/${params.runId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given sequencing run ID, get the associated run information.
     * @param {?} params The `SequencingRunsService.GetSequencingRunParams` containing the following parameters:
     *
     * - `runId`: ID of the sequencing run
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Sequencing run details returned successfully.
     */
    getSequencingRun(params) {
        return this.getSequencingRunResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Update information for an existing sequencing run. This may include metadata, status, progress (started/completed/failed), and flags.
     * @param {?} params The `SequencingRunsService.UpdateSequencingRunParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Sequencing run updated successfully.
     */
    updateSequencingRunResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v1/sequencing/runs/${params.runId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Update information for an existing sequencing run. This may include metadata, status, progress (started/completed/failed), and flags.
     * @param {?} params The `SequencingRunsService.UpdateSequencingRunParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Sequencing run updated successfully.
     */
    updateSequencingRun(params) {
        return this.updateSequencingRunResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given sequencing run ID, delete the sequencing run.
     * @param {?} runId ID of the sequencing run
     * @return {?} Sequencing run deleted successfully.
     */
    deleteSequencingRunResponse(runId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/v1/sequencing/runs/${runId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given sequencing run ID, delete the sequencing run.
     * @param {?} runId ID of the sequencing run
     * @return {?} Sequencing run deleted successfully.
     */
    deleteSequencingRun(runId) {
        return this.deleteSequencingRunResponse(runId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Update status information for an existing sequencing run. This may include status, progress (started/completed/failed), and flags.
     * @param {?} params The `SequencingRunsService.UpdateSequencingRunStatusParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Sequencing run status updated successfully.
     */
    updateSequencingRunStatusResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/runs/${params.runId}:updateStatus`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Update status information for an existing sequencing run. This may include status, progress (started/completed/failed), and flags.
     * @param {?} params The `SequencingRunsService.UpdateSequencingRunStatusParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Sequencing run status updated successfully.
     */
    updateSequencingRunStatus(params) {
        return this.updateSequencingRunStatusResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Check the status of the run and returns whether the run is ready to be uploaded.
     * @param {?} runId undefined
     * @return {?} Sequencing run is ready to upload.
     */
    canUploadResponse(runId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/runs/${runId}:canUpload`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Check the status of the run and returns whether the run is ready to be uploaded.
     * @param {?} runId undefined
     * @return {?} Sequencing run is ready to upload.
     */
    canUpload(runId) {
        return this.canUploadResponse(runId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given sequencing run ID, close an upload session.
     * @param {?} params The `SequencingRunsService.CloseUploadSessionParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Upload session is closed successfully
     */
    closeUploadSessionResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/runs/${params.runId}:closeUploadSession`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given sequencing run ID, close an upload session.
     * @param {?} params The `SequencingRunsService.CloseUploadSessionParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Upload session is closed successfully
     */
    closeUploadSession(params) {
        return this.closeUploadSessionResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given sequencing run ID, provide information about an uploaded file or set of files.
     * @param {?} params The `SequencingRunsService.RunDirectUploadInfoParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Upload information captured successfully.
     */
    runDirectUploadInfoResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/runs/${params.runId}/directUploadInfo`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given sequencing run ID, provide information about an uploaded file or set of files.
     * @param {?} params The `SequencingRunsService.RunDirectUploadInfoParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Upload information captured successfully.
     */
    runDirectUploadInfo(params) {
        return this.runDirectUploadInfoResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given sequencing run ID, complete the upload stage and close the upload session if provided.
     * @param {?} params The `SequencingRunsService.CompleteUploadParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Sequencing run upload completed successfully.
     */
    completeUploadResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/runs/${params.runId}:completeUpload`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given sequencing run ID, complete the upload stage and close the upload session if provided.
     * @param {?} params The `SequencingRunsService.CompleteUploadParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Sequencing run upload completed successfully.
     */
    completeUpload(params) {
        return this.completeUploadResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given sequencing run ID, abort the run.
     * @param {?} params The `SequencingRunsService.AbortSequencingRunParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Sequencing run aborted successfully."
     */
    abortSequencingRunResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/runs/${params.runId}:abort`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given sequencing run ID, abort the run.
     * @param {?} params The `SequencingRunsService.AbortSequencingRunParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Sequencing run aborted successfully."
     */
    abortSequencingRun(params) {
        return this.abortSequencingRunResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Generate sample sheet from a sequencing run, and return the CSV string of sample sheet.
     * @param {?} params The `SequencingRunsService.GenerateSampleSheetForSequencingRunParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Sample sheet generated successfully.
     */
    generateSampleSheetForSequencingRunResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/runs/${params.runId}:generateSampleSheet`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Generate sample sheet from a sequencing run, and return the CSV string of sample sheet.
     * @param {?} params The `SequencingRunsService.GenerateSampleSheetForSequencingRunParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Sample sheet generated successfully.
     */
    generateSampleSheetForSequencingRun(params) {
        return this.generateSampleSheetForSequencingRunResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Replace the sequencing stats of a sequencing run. Any existing sequencing stats will be deleted and replaced with the new contents of this request.
     * @param {?} params The `SequencingRunsService.ReplaceSequencingStatsParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Sequencing stats replaced successfully.
     */
    replaceSequencingStatsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PUT', this.rootUrl + `/v1/sequencing/runs/${params.runId}:replaceSequencingStats`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Replace the sequencing stats of a sequencing run. Any existing sequencing stats will be deleted and replaced with the new contents of this request.
     * @param {?} params The `SequencingRunsService.ReplaceSequencingStatsParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Sequencing stats replaced successfully.
     */
    replaceSequencingStats(params) {
        return this.replaceSequencingStatsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given a run ID, get the sequencing stats of a sequencing run.
     * @param {?} params The `SequencingRunsService.GetSequencingStatsParams` containing the following parameters:
     *
     * - `runId`: ID of the sequencing run
     *
     * - `useFlatRunContent`: Use LaneLibraries instead of LaneContents field as run content input
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Sequencing run stats returned successfully.
     */
    getSequencingStatsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.useFlatRunContent != null)
            __params = __params.set('useFlatRunContent', params.useFlatRunContent.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/runs/${params.runId}/sequencingStats`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given a run ID, get the sequencing stats of a sequencing run.
     * @param {?} params The `SequencingRunsService.GetSequencingStatsParams` containing the following parameters:
     *
     * - `runId`: ID of the sequencing run
     *
     * - `useFlatRunContent`: Use LaneLibraries instead of LaneContents field as run content input
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Sequencing run stats returned successfully.
     */
    getSequencingStats(params) {
        return this.getSequencingStatsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Prepare requeue analysis of the same or different sequencing run with potentially different run content/analysis.
     * @param {?} params The `SequencingRunsService.PrepareRequeueParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Prepared run requeue successfully.
     */
    prepareRequeueResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/runs/${params.runId}:prepareRequeue`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Prepare requeue analysis of the same or different sequencing run with potentially different run content/analysis.
     * @param {?} params The `SequencingRunsService.PrepareRequeueParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Prepared run requeue successfully.
     */
    prepareRequeue(params) {
        return this.prepareRequeueResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Starts previously prepared requeue run for analysis.
     * @param {?} runId undefined
     * @return {?} Starts requeue run successfully.
     */
    startRequeueResponse(runId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/runs/${runId}:startRequeue`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Starts previously prepared requeue run for analysis.
     * @param {?} runId undefined
     * @return {?} Starts requeue run successfully.
     */
    startRequeue(runId) {
        return this.startRequeueResponse(runId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Start run verification
     * @param {?} params The `SequencingRunsService.StartRunVerificationParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Verification is started successfully
     */
    startRunVerificationResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/runs/${params.runId}:startVerification`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Start run verification
     * @param {?} params The `SequencingRunsService.StartRunVerificationParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Verification is started successfully
     */
    startRunVerification(params) {
        return this.startRunVerificationResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given sequencing run, replace the access control list with the input access control list, and return information about the run.
     * @param {?} params The `SequencingRunsService.ReplaceSequencingRunAclParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Access control list updated successfully.
     */
    replaceSequencingRunAclResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PUT', this.rootUrl + `/v1/sequencing/runs/${params.runId}/acl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given sequencing run, replace the access control list with the input access control list, and return information about the run.
     * @param {?} params The `SequencingRunsService.ReplaceSequencingRunAclParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Access control list updated successfully.
     */
    replaceSequencingRunAcl(params) {
        return this.replaceSequencingRunAclResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given sequencing run, merge the access control list with the input access control list, and return information about the run.
     * @param {?} params The `SequencingRunsService.MergeSequencingRunAclParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Access control list updated successfully.
     */
    mergeSequencingRunAclResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v1/sequencing/runs/${params.runId}/acl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given sequencing run, merge the access control list with the input access control list, and return information about the run.
     * @param {?} params The `SequencingRunsService.MergeSequencingRunAclParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Access control list updated successfully.
     */
    mergeSequencingRunAcl(params) {
        return this.mergeSequencingRunAclResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Remove the access control list of a given sequencing run, and return information about the run.
     * @param {?} params The `SequencingRunsService.RemoveSequencingRunAclParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Input access control list removed successfully.
     */
    removeSequencingRunAclResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/v1/sequencing/runs/${params.runId}/acl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Remove the access control list of a given sequencing run, and return information about the run.
     * @param {?} params The `SequencingRunsService.RemoveSequencingRunAclParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Input access control list removed successfully.
     */
    removeSequencingRunAcl(params) {
        return this.removeSequencingRunAclResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
SequencingRunsService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: SequencingRunsService, factory: function SequencingRunsService_Factory(t) { return new (t || SequencingRunsService)(ɵngcc0.ɵɵinject(GssApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(SequencingRunsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GssApiConfiguration }, { type: HttpClient }]; }, { constructor: [], createAnalysisConfigurationResponse: [], createAnalysisConfiguration: [], listAnalysisConfigurationsResponse: [], listAnalysisConfigurations: [], deleteAnalysisConfigurationResponse: [], deleteAnalysisConfiguration: [], updateAnalysisConfigurationResponse: [], updateAnalysisConfiguration: [], getSequencingRunContentsResponse: [], getSequencingRunContents: [], updateSequencingRunContentsResponse: [], updateSequencingRunContents: [], listSequencingRunsResponse: [], listSequencingRuns: [], createSequencingRunResponse: [], createSequencingRun: [], getSequencingRunResponse: [], getSequencingRun: [], updateSequencingRunResponse: [], updateSequencingRun: [], deleteSequencingRunResponse: [], deleteSequencingRun: [], updateSequencingRunStatusResponse: [], updateSequencingRunStatus: [], canUploadResponse: [], canUpload: [], closeUploadSessionResponse: [], closeUploadSession: [], runDirectUploadInfoResponse: [], runDirectUploadInfo: [], completeUploadResponse: [], completeUpload: [], abortSequencingRunResponse: [], abortSequencingRun: [], generateSampleSheetForSequencingRunResponse: [], generateSampleSheetForSequencingRun: [], replaceSequencingStatsResponse: [], replaceSequencingStats: [], getSequencingStatsResponse: [], getSequencingStats: [], prepareRequeueResponse: [], prepareRequeue: [], startRequeueResponse: [], startRequeue: [], startRunVerificationResponse: [], startRunVerification: [], replaceSequencingRunAclResponse: [], replaceSequencingRunAcl: [], mergeSequencingRunAclResponse: [], mergeSequencingRunAcl: [], removeSequencingRunAclResponse: [], removeSequencingRunAcl: [] });
SequencingRunsService.createAnalysisConfigurationPath = '/v1/sequencing/runs/{runId}/analyses';
SequencingRunsService.listAnalysisConfigurationsPath = '/v1/sequencing/runs/{runId}/analyses';
SequencingRunsService.createSequencingRunPath = '/v1/sequencing/runs';
SequencingRunsService.deleteAnalysisConfigurationPath = '/v1/sequencing/runs/analyses/{id}';
SequencingRunsService.updateAnalysisConfigurationPath = '/v1/sequencing/runs/analyses/{id}';
SequencingRunsService.getSequencingRunContentsPath = '/v1/sequencing/runs/{runId}/contents';
SequencingRunsService.updateSequencingRunContentsPath = '/v1/sequencing/runs/{runId}/contents';
SequencingRunsService.listSequencingRunsPath = '/v1/sequencing/runs';
SequencingRunsService.getSequencingRunPath = '/v1/sequencing/runs/{runId}';
SequencingRunsService.updateSequencingRunPath = '/v1/sequencing/runs/{runId}';
SequencingRunsService.deleteSequencingRunPath = '/v1/sequencing/runs/{runId}';
SequencingRunsService.updateSequencingRunStatusPath = '/v1/sequencing/runs/{runId}:updateStatus';
SequencingRunsService.canUploadPath = '/v1/sequencing/runs/{runId}:canUpload';
SequencingRunsService.closeUploadSessionPath = '/v1/sequencing/runs/{runId}:closeUploadSession';
SequencingRunsService.runDirectUploadInfoPath = '/v1/sequencing/runs/{runId}/directUploadInfo';
SequencingRunsService.completeUploadPath = '/v1/sequencing/runs/{runId}:completeUpload';
SequencingRunsService.abortSequencingRunPath = '/v1/sequencing/runs/{runId}:abort';
SequencingRunsService.generateSampleSheetForSequencingRunPath = '/v1/sequencing/runs/{runId}:generateSampleSheet';
SequencingRunsService.replaceSequencingStatsPath = '/v1/sequencing/runs/{runId}:replaceSequencingStats';
SequencingRunsService.getSequencingStatsPath = '/v1/sequencing/runs/{runId}/sequencingStats';
SequencingRunsService.prepareRequeuePath = '/v1/sequencing/runs/{runId}:prepareRequeue';
SequencingRunsService.startRequeuePath = '/v1/sequencing/runs/{runId}:startRequeue';
SequencingRunsService.startRunVerificationPath = '/v1/sequencing/runs/{runId}:startVerification';
SequencingRunsService.replaceSequencingRunAclPath = '/v1/sequencing/runs/{runId}/acl';
SequencingRunsService.mergeSequencingRunAclPath = '/v1/sequencing/runs/{runId}/acl';
SequencingRunsService.removeSequencingRunAclPath = '/v1/sequencing/runs/{runId}/acl';
/** @nocollapse */
SequencingRunsService.ctorParameters = () => [
    { type: GssApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ SequencingRunsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function SequencingRunsService_Factory() { return new SequencingRunsService(ɵɵinject(GssApiConfiguration), ɵɵinject(HttpClient)); }, token: SequencingRunsService, providedIn: "root" });
if (false) {
    /** @type {?} */
    SequencingRunsService.createAnalysisConfigurationPath;
    /** @type {?} */
    SequencingRunsService.listAnalysisConfigurationsPath;
    /** @type {?} */
    SequencingRunsService.createSequencingRunPath;
    /** @type {?} */
    SequencingRunsService.deleteAnalysisConfigurationPath;
    /** @type {?} */
    SequencingRunsService.updateAnalysisConfigurationPath;
    /** @type {?} */
    SequencingRunsService.getSequencingRunContentsPath;
    /** @type {?} */
    SequencingRunsService.updateSequencingRunContentsPath;
    /** @type {?} */
    SequencingRunsService.listSequencingRunsPath;
    /** @type {?} */
    SequencingRunsService.getSequencingRunPath;
    /** @type {?} */
    SequencingRunsService.updateSequencingRunPath;
    /** @type {?} */
    SequencingRunsService.deleteSequencingRunPath;
    /** @type {?} */
    SequencingRunsService.updateSequencingRunStatusPath;
    /** @type {?} */
    SequencingRunsService.canUploadPath;
    /** @type {?} */
    SequencingRunsService.closeUploadSessionPath;
    /** @type {?} */
    SequencingRunsService.runDirectUploadInfoPath;
    /** @type {?} */
    SequencingRunsService.completeUploadPath;
    /** @type {?} */
    SequencingRunsService.abortSequencingRunPath;
    /** @type {?} */
    SequencingRunsService.generateSampleSheetForSequencingRunPath;
    /** @type {?} */
    SequencingRunsService.replaceSequencingStatsPath;
    /** @type {?} */
    SequencingRunsService.getSequencingStatsPath;
    /** @type {?} */
    SequencingRunsService.prepareRequeuePath;
    /** @type {?} */
    SequencingRunsService.startRequeuePath;
    /** @type {?} */
    SequencingRunsService.startRunVerificationPath;
    /** @type {?} */
    SequencingRunsService.replaceSequencingRunAclPath;
    /** @type {?} */
    SequencingRunsService.mergeSequencingRunAclPath;
    /** @type {?} */
    SequencingRunsService.removeSequencingRunAclPath;
}
(function (SequencingRunsService) {
    /**
     * Parameters for createAnalysisConfiguration
     * @record
     */
    function CreateAnalysisConfigurationParams() { }
    SequencingRunsService.CreateAnalysisConfigurationParams = CreateAnalysisConfigurationParams;
    if (false) {
        /** @type {?} */
        CreateAnalysisConfigurationParams.prototype.runId;
        /** @type {?|undefined} */
        CreateAnalysisConfigurationParams.prototype.body;
    }
    /**
     * Parameters for listAnalysisConfigurations
     * @record
     */
    function ListAnalysisConfigurationsParams() { }
    SequencingRunsService.ListAnalysisConfigurationsParams = ListAnalysisConfigurationsParams;
    if (false) {
        /** @type {?} */
        ListAnalysisConfigurationsParams.prototype.runId;
        /**
         * Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
         * @type {?|undefined}
         */
        ListAnalysisConfigurationsParams.prototype.sort;
        /**
         * Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListAnalysisConfigurationsParams.prototype.pageToken;
        /**
         * Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListAnalysisConfigurationsParams.prototype.pageSize;
        /**
         * Include flags to specify what is included in the request
         * @type {?|undefined}
         */
        ListAnalysisConfigurationsParams.prototype.include;
    }
    /**
     * Parameters for updateAnalysisConfiguration
     * @record
     */
    function UpdateAnalysisConfigurationParams() { }
    SequencingRunsService.UpdateAnalysisConfigurationParams = UpdateAnalysisConfigurationParams;
    if (false) {
        /** @type {?} */
        UpdateAnalysisConfigurationParams.prototype.id;
        /** @type {?|undefined} */
        UpdateAnalysisConfigurationParams.prototype.body;
    }
    /**
     * Parameters for getSequencingRunContents
     * @record
     */
    function GetSequencingRunContentsParams() { }
    SequencingRunsService.GetSequencingRunContentsParams = GetSequencingRunContentsParams;
    if (false) {
        /**
         * ID of the sequencing run
         * @type {?}
         */
        GetSequencingRunContentsParams.prototype.runId;
        /**
         * Use LaneLibraries instead of LaneContents field as run content input
         * @type {?|undefined}
         */
        GetSequencingRunContentsParams.prototype.useFlatRunContent;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        GetSequencingRunContentsParams.prototype.include;
    }
    /**
     * Parameters for updateSequencingRunContents
     * @record
     */
    function UpdateSequencingRunContentsParams() { }
    SequencingRunsService.UpdateSequencingRunContentsParams = UpdateSequencingRunContentsParams;
    if (false) {
        /** @type {?} */
        UpdateSequencingRunContentsParams.prototype.runId;
        /** @type {?|undefined} */
        UpdateSequencingRunContentsParams.prototype.body;
    }
    /**
     * Parameters for listSequencingRuns
     * @record
     */
    function ListSequencingRunsParams() { }
    SequencingRunsService.ListSequencingRunsParams = ListSequencingRunsParams;
    if (false) {
        /**
         * Optional parameter to limit the response to be with in provided tenant ids
         * Comma separated to support multiple tenant ids
         * @type {?|undefined}
         */
        ListSequencingRunsParams.prototype.tenantIds;
        /**
         * Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
         * @type {?|undefined}
         */
        ListSequencingRunsParams.prototype.sort;
        /**
         * Optional parameter. Used to search for keyword in sequencing run fields
         * such as (RunName, FlowCellBarcode, InputContainerIdentifier)
         * @type {?|undefined}
         */
        ListSequencingRunsParams.prototype.search;
        /**
         * Optional field. Used to filter the sequencing runs list by comma-separated RunOrigins values, e.g.  <example>Instrument,Simulator</example>
         * @type {?|undefined}
         */
        ListSequencingRunsParams.prototype.runOrigin;
        /**
         * Filter by name of the sequencing run
         * @type {?|undefined}
         */
        ListSequencingRunsParams.prototype.runName;
        /**
         * Filter By Requeued Run Id
         * @type {?|undefined}
         */
        ListSequencingRunsParams.prototype.requeuedFromRunId;
        /**
         * Filter by regulatory modes using comma separated values, e.g <example>RUO,IVD,IUO</example>
         * @type {?|undefined}
         */
        ListSequencingRunsParams.prototype.regulatoryMode;
        /**
         * Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListSequencingRunsParams.prototype.pageToken;
        /**
         * Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListSequencingRunsParams.prototype.pageSize;
        /**
         * Optional parameter. Set to true to filter the run list and only include planned runs.
         * @type {?|undefined}
         */
        ListSequencingRunsParams.prototype.isPlanned;
        /**
         * Optional parameter. Set to true to filter the run list and only include locked runs.
         * @type {?|undefined}
         */
        ListSequencingRunsParams.prototype.isLocked;
        /**
         * Optional parameter. Set to true to filter the run list and only include favorite runs.
         * @type {?|undefined}
         */
        ListSequencingRunsParams.prototype.isFavorite;
        /**
         * Optional parameter. Set to true to filter the run list and only include draft runs.
         * @type {?|undefined}
         */
        ListSequencingRunsParams.prototype.isDraft;
        /**
         * Optional parameter. Set to true to filter the run list and only include completed (failed, aborted, successfully completed) runs.
         * @type {?|undefined}
         */
        ListSequencingRunsParams.prototype.isCompleted;
        /**
         * Optional parameter. Set to true to filter the run list and only include runs performed by the specified instrument type.
         * @type {?|undefined}
         */
        ListSequencingRunsParams.prototype.instrumentType;
        /**
         * Filter by Input container identifier
         * @type {?|undefined}
         */
        ListSequencingRunsParams.prototype.inputContainerIdentifier;
        /**
         * Optional parameter. Show runs that were completed before the provided Date as well as runs that are not completed
         * @type {?|undefined}
         */
        ListSequencingRunsParams.prototype.includeCompletedBeforeDate;
        /**
         * Optional parameter. Show runs that were completed after the provided Date as well as runs that are not completed
         * @type {?|undefined}
         */
        ListSequencingRunsParams.prototype.includeCompletedAfterDate;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        ListSequencingRunsParams.prototype.include;
        /**
         * Filter by flowcell barcode
         * @type {?|undefined}
         */
        ListSequencingRunsParams.prototype.flowCellBarcode;
        /**
         * Optional field. Used to filter the sequencing runs list by comma-separated AggregateRunStatus values, e.g <example>Aborted,Deleted,Running</example>
         * @type {?|undefined}
         */
        ListSequencingRunsParams.prototype.aggregateRunStatus;
    }
    /**
     * Parameters for getSequencingRun
     * @record
     */
    function GetSequencingRunParams() { }
    SequencingRunsService.GetSequencingRunParams = GetSequencingRunParams;
    if (false) {
        /**
         * ID of the sequencing run
         * @type {?}
         */
        GetSequencingRunParams.prototype.runId;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        GetSequencingRunParams.prototype.include;
    }
    /**
     * Parameters for updateSequencingRun
     * @record
     */
    function UpdateSequencingRunParams() { }
    SequencingRunsService.UpdateSequencingRunParams = UpdateSequencingRunParams;
    if (false) {
        /** @type {?} */
        UpdateSequencingRunParams.prototype.runId;
        /** @type {?|undefined} */
        UpdateSequencingRunParams.prototype.body;
    }
    /**
     * Parameters for updateSequencingRunStatus
     * @record
     */
    function UpdateSequencingRunStatusParams() { }
    SequencingRunsService.UpdateSequencingRunStatusParams = UpdateSequencingRunStatusParams;
    if (false) {
        /** @type {?} */
        UpdateSequencingRunStatusParams.prototype.runId;
        /** @type {?|undefined} */
        UpdateSequencingRunStatusParams.prototype.body;
    }
    /**
     * Parameters for closeUploadSession
     * @record
     */
    function CloseUploadSessionParams() { }
    SequencingRunsService.CloseUploadSessionParams = CloseUploadSessionParams;
    if (false) {
        /** @type {?} */
        CloseUploadSessionParams.prototype.runId;
        /** @type {?|undefined} */
        CloseUploadSessionParams.prototype.body;
    }
    /**
     * Parameters for runDirectUploadInfo
     * @record
     */
    function RunDirectUploadInfoParams() { }
    SequencingRunsService.RunDirectUploadInfoParams = RunDirectUploadInfoParams;
    if (false) {
        /** @type {?} */
        RunDirectUploadInfoParams.prototype.runId;
        /** @type {?|undefined} */
        RunDirectUploadInfoParams.prototype.body;
    }
    /**
     * Parameters for completeUpload
     * @record
     */
    function CompleteUploadParams() { }
    SequencingRunsService.CompleteUploadParams = CompleteUploadParams;
    if (false) {
        /** @type {?} */
        CompleteUploadParams.prototype.runId;
        /** @type {?|undefined} */
        CompleteUploadParams.prototype.body;
    }
    /**
     * Parameters for abortSequencingRun
     * @record
     */
    function AbortSequencingRunParams() { }
    SequencingRunsService.AbortSequencingRunParams = AbortSequencingRunParams;
    if (false) {
        /** @type {?} */
        AbortSequencingRunParams.prototype.runId;
        /** @type {?|undefined} */
        AbortSequencingRunParams.prototype.body;
    }
    /**
     * Parameters for generateSampleSheetForSequencingRun
     * @record
     */
    function GenerateSampleSheetForSequencingRunParams() { }
    SequencingRunsService.GenerateSampleSheetForSequencingRunParams = GenerateSampleSheetForSequencingRunParams;
    if (false) {
        /** @type {?} */
        GenerateSampleSheetForSequencingRunParams.prototype.runId;
        /** @type {?|undefined} */
        GenerateSampleSheetForSequencingRunParams.prototype.body;
    }
    /**
     * Parameters for replaceSequencingStats
     * @record
     */
    function ReplaceSequencingStatsParams() { }
    SequencingRunsService.ReplaceSequencingStatsParams = ReplaceSequencingStatsParams;
    if (false) {
        /** @type {?} */
        ReplaceSequencingStatsParams.prototype.runId;
        /** @type {?|undefined} */
        ReplaceSequencingStatsParams.prototype.body;
    }
    /**
     * Parameters for getSequencingStats
     * @record
     */
    function GetSequencingStatsParams() { }
    SequencingRunsService.GetSequencingStatsParams = GetSequencingStatsParams;
    if (false) {
        /**
         * ID of the sequencing run
         * @type {?}
         */
        GetSequencingStatsParams.prototype.runId;
        /**
         * Use LaneLibraries instead of LaneContents field as run content input
         * @type {?|undefined}
         */
        GetSequencingStatsParams.prototype.useFlatRunContent;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        GetSequencingStatsParams.prototype.include;
    }
    /**
     * Parameters for prepareRequeue
     * @record
     */
    function PrepareRequeueParams() { }
    SequencingRunsService.PrepareRequeueParams = PrepareRequeueParams;
    if (false) {
        /** @type {?} */
        PrepareRequeueParams.prototype.runId;
        /** @type {?|undefined} */
        PrepareRequeueParams.prototype.body;
    }
    /**
     * Parameters for startRunVerification
     * @record
     */
    function StartRunVerificationParams() { }
    SequencingRunsService.StartRunVerificationParams = StartRunVerificationParams;
    if (false) {
        /** @type {?} */
        StartRunVerificationParams.prototype.runId;
        /** @type {?|undefined} */
        StartRunVerificationParams.prototype.body;
    }
    /**
     * Parameters for replaceSequencingRunAcl
     * @record
     */
    function ReplaceSequencingRunAclParams() { }
    SequencingRunsService.ReplaceSequencingRunAclParams = ReplaceSequencingRunAclParams;
    if (false) {
        /** @type {?} */
        ReplaceSequencingRunAclParams.prototype.runId;
        /** @type {?|undefined} */
        ReplaceSequencingRunAclParams.prototype.body;
    }
    /**
     * Parameters for mergeSequencingRunAcl
     * @record
     */
    function MergeSequencingRunAclParams() { }
    SequencingRunsService.MergeSequencingRunAclParams = MergeSequencingRunAclParams;
    if (false) {
        /** @type {?} */
        MergeSequencingRunAclParams.prototype.runId;
        /** @type {?|undefined} */
        MergeSequencingRunAclParams.prototype.body;
    }
    /**
     * Parameters for removeSequencingRunAcl
     * @record
     */
    function RemoveSequencingRunAclParams() { }
    SequencingRunsService.RemoveSequencingRunAclParams = RemoveSequencingRunAclParams;
    if (false) {
        /** @type {?} */
        RemoveSequencingRunAclParams.prototype.runId;
        /** @type {?|undefined} */
        RemoveSequencingRunAclParams.prototype.body;
    }
})(SequencingRunsService || (SequencingRunsService = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/planned-runs.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PlannedRunsService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * Create sequencing run plan, with configuration required for an instrument to start the run.
     * @param {?=} body undefined
     * @return {?} Planned run created successfully.
     */
    createPlannedRunResponse(body) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/runs:plan`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Create sequencing run plan, with configuration required for an instrument to start the run.
     * @param {?=} body undefined
     * @return {?} Planned run created successfully.
     */
    createPlannedRun(body) {
        return this.createPlannedRunResponse(body).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Import a planned run based on sample sheet, return information of the import result.
     * @param {?=} body undefined
     * @return {?} Planned run imported successfully.
     */
    importPlannedRunResponse(body) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/runs:import`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Import a planned run based on sample sheet, return information of the import result.
     * @param {?=} body undefined
     * @return {?} Planned run imported successfully.
     */
    importPlannedRun(body) {
        return this.importPlannedRunResponse(body).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given sequencing run ID, update the planned run configuration. Only applicable to runs in planning stage.
     * @param {?} params The `PlannedRunsService.UpdatePlannedRunConfigParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Planned run updated successfully.
     */
    updatePlannedRunConfigResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v1/sequencing/runs/${params.runId}/config`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given sequencing run ID, update the planned run configuration. Only applicable to runs in planning stage.
     * @param {?} params The `PlannedRunsService.UpdatePlannedRunConfigParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Planned run updated successfully.
     */
    updatePlannedRunConfig(params) {
        return this.updatePlannedRunConfigResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given sequencing run ID, replace the existing planned run with user input. This may include run configuration, run contents, and analysis configurations. Only applicable to runs in planning stage.
     * @param {?} params The `PlannedRunsService.ReplacePlannedRunParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Planned run updated successfully.
     */
    replacePlannedRunResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PUT', this.rootUrl + `/v1/sequencing/runs/${params.runId}/plan`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given sequencing run ID, replace the existing planned run with user input. This may include run configuration, run contents, and analysis configurations. Only applicable to runs in planning stage.
     * @param {?} params The `PlannedRunsService.ReplacePlannedRunParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Planned run updated successfully.
     */
    replacePlannedRun(params) {
        return this.replacePlannedRunResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given sequencing run ID, unlock the planned run for the current request token.
     * @param {?} runId undefined
     * @return {?} Sequencing run unlocked successfully.
     */
    unlockPlannedRunResponse(runId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/runs/${runId}:unlock`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given sequencing run ID, unlock the planned run for the current request token.
     * @param {?} runId undefined
     * @return {?} Sequencing run unlocked successfully.
     */
    unlockPlannedRun(runId) {
        return this.unlockPlannedRunResponse(runId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Lock the planned run associated with a given sequencing run ID.
     * @param {?} runId undefined
     * @return {?} Planned run locked successfully."
     */
    lockPlannedRunResponse(runId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/runs/${runId}:lock`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Lock the planned run associated with a given sequencing run ID.
     * @param {?} runId undefined
     * @return {?} Planned run locked successfully."
     */
    lockPlannedRun(runId) {
        return this.lockPlannedRunResponse(runId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Start a planned sequencing run, and return information about that run. Only applicable to planned runs.
     * @param {?} params The `PlannedRunsService.StartPlannedRunParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Planned sequencing run started successfully.
     */
    startPlannedRunResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/runs/${params.runId}:start`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Start a planned sequencing run, and return information about that run. Only applicable to planned runs.
     * @param {?} params The `PlannedRunsService.StartPlannedRunParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Planned sequencing run started successfully.
     */
    startPlannedRun(params) {
        return this.startPlannedRunResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Validate the planned run associated with a given sequencing run ID.
     * @param {?} params The `PlannedRunsService.ValidatePlannedRunParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Planned run validated successfully."
     */
    validatePlannedRunResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/runs/${params.runId}:validate`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Validate the planned run associated with a given sequencing run ID.
     * @param {?} params The `PlannedRunsService.ValidatePlannedRunParams` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Planned run validated successfully."
     */
    validatePlannedRun(params) {
        return this.validatePlannedRunResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get index info including default OverrideCycles and whether need to configure Index1 and Index2 fields for libraries based on selected kits and run config.
     * @param {?=} body undefined
     * @return {?} Index info returned successfully.
     */
    getIndexInfoResponse(body) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/sequencing/runs:getIndexInfo`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get index info including default OverrideCycles and whether need to configure Index1 and Index2 fields for libraries based on selected kits and run config.
     * @param {?=} body undefined
     * @return {?} Index info returned successfully.
     */
    getIndexInfo(body) {
        return this.getIndexInfoResponse(body).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
PlannedRunsService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: PlannedRunsService, factory: function PlannedRunsService_Factory(t) { return new (t || PlannedRunsService)(ɵngcc0.ɵɵinject(GssApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(PlannedRunsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GssApiConfiguration }, { type: HttpClient }]; }, { constructor: [], createPlannedRunResponse: [], createPlannedRun: [], importPlannedRunResponse: [], importPlannedRun: [], updatePlannedRunConfigResponse: [], updatePlannedRunConfig: [], replacePlannedRunResponse: [], replacePlannedRun: [], unlockPlannedRunResponse: [], unlockPlannedRun: [], lockPlannedRunResponse: [], lockPlannedRun: [], startPlannedRunResponse: [], startPlannedRun: [], validatePlannedRunResponse: [], validatePlannedRun: [], getIndexInfoResponse: [], getIndexInfo: [] });
PlannedRunsService.createPlannedRunPath = '/v1/sequencing/runs:plan';
PlannedRunsService.importPlannedRunPath = '/v1/sequencing/runs:import';
PlannedRunsService.updatePlannedRunConfigPath = '/v1/sequencing/runs/{runId}/config';
PlannedRunsService.replacePlannedRunPath = '/v1/sequencing/runs/{runId}/plan';
PlannedRunsService.unlockPlannedRunPath = '/v1/sequencing/runs/{runId}:unlock';
PlannedRunsService.lockPlannedRunPath = '/v1/sequencing/runs/{runId}:lock';
PlannedRunsService.startPlannedRunPath = '/v1/sequencing/runs/{runId}:start';
PlannedRunsService.validatePlannedRunPath = '/v1/sequencing/runs/{runId}:validate';
PlannedRunsService.getIndexInfoPath = '/v1/sequencing/runs:getIndexInfo';
/** @nocollapse */
PlannedRunsService.ctorParameters = () => [
    { type: GssApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ PlannedRunsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function PlannedRunsService_Factory() { return new PlannedRunsService(ɵɵinject(GssApiConfiguration), ɵɵinject(HttpClient)); }, token: PlannedRunsService, providedIn: "root" });
if (false) {
    /** @type {?} */
    PlannedRunsService.createPlannedRunPath;
    /** @type {?} */
    PlannedRunsService.importPlannedRunPath;
    /** @type {?} */
    PlannedRunsService.updatePlannedRunConfigPath;
    /** @type {?} */
    PlannedRunsService.replacePlannedRunPath;
    /** @type {?} */
    PlannedRunsService.unlockPlannedRunPath;
    /** @type {?} */
    PlannedRunsService.lockPlannedRunPath;
    /** @type {?} */
    PlannedRunsService.startPlannedRunPath;
    /** @type {?} */
    PlannedRunsService.validatePlannedRunPath;
    /** @type {?} */
    PlannedRunsService.getIndexInfoPath;
}
(function (PlannedRunsService) {
    /**
     * Parameters for updatePlannedRunConfig
     * @record
     */
    function UpdatePlannedRunConfigParams() { }
    PlannedRunsService.UpdatePlannedRunConfigParams = UpdatePlannedRunConfigParams;
    if (false) {
        /** @type {?} */
        UpdatePlannedRunConfigParams.prototype.runId;
        /** @type {?|undefined} */
        UpdatePlannedRunConfigParams.prototype.body;
    }
    /**
     * Parameters for replacePlannedRun
     * @record
     */
    function ReplacePlannedRunParams() { }
    PlannedRunsService.ReplacePlannedRunParams = ReplacePlannedRunParams;
    if (false) {
        /** @type {?} */
        ReplacePlannedRunParams.prototype.runId;
        /** @type {?|undefined} */
        ReplacePlannedRunParams.prototype.body;
    }
    /**
     * Parameters for startPlannedRun
     * @record
     */
    function StartPlannedRunParams() { }
    PlannedRunsService.StartPlannedRunParams = StartPlannedRunParams;
    if (false) {
        /** @type {?} */
        StartPlannedRunParams.prototype.runId;
        /** @type {?|undefined} */
        StartPlannedRunParams.prototype.body;
    }
    /**
     * Parameters for validatePlannedRun
     * @record
     */
    function ValidatePlannedRunParams() { }
    PlannedRunsService.ValidatePlannedRunParams = ValidatePlannedRunParams;
    if (false) {
        /** @type {?} */
        ValidatePlannedRunParams.prototype.runId;
        /** @type {?|undefined} */
        ValidatePlannedRunParams.prototype.body;
    }
})(PlannedRunsService || (PlannedRunsService = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/instrument-types.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InstrumentTypesService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * Get a list of supported instrument types and platforms.
     * @return {?} Supported instrument types and platforms returned successfully.
     */
    getInstrumentTypesResponse() {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/sequencing/instrumentTypes`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get a list of supported instrument types and platforms.
     * @return {?} Supported instrument types and platforms returned successfully.
     */
    getInstrumentTypes() {
        return this.getInstrumentTypesResponse().pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
InstrumentTypesService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: InstrumentTypesService, factory: function InstrumentTypesService_Factory(t) { return new (t || InstrumentTypesService)(ɵngcc0.ɵɵinject(GssApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(InstrumentTypesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GssApiConfiguration }, { type: HttpClient }]; }, { constructor: [], getInstrumentTypesResponse: [], getInstrumentTypes: [] });
InstrumentTypesService.getInstrumentTypesPath = '/v1/sequencing/instrumentTypes';
/** @nocollapse */
InstrumentTypesService.ctorParameters = () => [
    { type: GssApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ InstrumentTypesService.ngInjectableDef = ɵɵdefineInjectable({ factory: function InstrumentTypesService_Factory() { return new InstrumentTypesService(ɵɵinject(GssApiConfiguration), ɵɵinject(HttpClient)); }, token: InstrumentTypesService, providedIn: "root" });
if (false) {
    /** @type {?} */
    InstrumentTypesService.getInstrumentTypesPath;
}

/**
 * @fileoverview added by tsickle
 * Generated from: api/services.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: api/gss-api.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Provider for all GssApi services, plus GssApiConfiguration
 */
class GssApiModule {
    /**
     * @param {?} customParams
     * @return {?}
     */
    static forRoot(customParams) {
        return {
            ngModule: GssApiModule,
            providers: [
                {
                    provide: GssApiConfiguration,
                    useValue: { rootUrl: customParams.rootUrl }
                }
            ]
        };
    }
}
GssApiModule.ngModuleDef = ɵngcc0.ɵɵdefineNgModule({ type: GssApiModule });
/*@__PURE__*/ ɵngcc0.ɵɵsetNgModuleScope(GssApiModule, { imports: function () { return [HttpClientModule]; }, exports: function () { return [HttpClientModule]; } });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(GssApiModule, [{
        type: NgModule,
        args: [{
                imports: [
                    HttpClientModule
                ],
                exports: [
                    HttpClientModule
                ],
                declarations: [],
                providers: [
                    GssApiConfiguration,
                    AnalysisConfigurationTemplatesService,
                    AnalysisDatasetsService,
                    AnalysisDefinitionsService,
                    AnalysisVersionDefinitionsService,
                    GenomesService,
                    IndexAdapterKitsService,
                    LibrariesService,
                    LibraryPoolsService,
                    LibraryPrepKitsService,
                    ReferenceFilesService,
                    SamplesService,
                    SampleSheetsService,
                    SequencingRunsService,
                    PlannedRunsService,
                    InstrumentTypesService
                ]
            }]
    }], null, null);
GssApiModule.ngInjectorDef = ɵngcc0.ɵɵdefineInjector({ factory: function GssApiModule_Factory(t) { return new (t || GssApiModule)(); }, providers: [
        GssApiConfiguration,
        AnalysisConfigurationTemplatesService,
        AnalysisDatasetsService,
        AnalysisDefinitionsService,
        AnalysisVersionDefinitionsService,
        GenomesService,
        IndexAdapterKitsService,
        LibrariesService,
        LibraryPoolsService,
        LibraryPrepKitsService,
        ReferenceFilesService,
        SamplesService,
        SampleSheetsService,
        SequencingRunsService,
        PlannedRunsService,
        InstrumentTypesService
    ], imports: [[
            HttpClientModule
        ],
        HttpClientModule] });

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: stratus-gss-ng-sdk.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AggregateRunStatus, AnalysisConfigurationTemplatesService, AnalysisDatasetSortFields, AnalysisDatasetsService, AnalysisDefinitionSortFields, AnalysisDefinitionStatus, AnalysisDefinitionsService, AnalysisType, AnalysisVersionDefinitionSortFields, AnalysisVersionDefinitionStatus, AnalysisVersionDefinitionsService, BaseService, GenerateSampleSheetIncludeFlags, GenomeFormat, GenomeSortFields, GenomeStatus, GenomesService, GetAnalysisDefinitionIncludeFlags, GetAnalysisVersionDefinitionIncludeFlags, GetIndexAdapterKitIncludeFlags, GetLibraryPrepKitIncludeFlags, GetSequencingRunContentsIncludeFlags, GssApiModule, IlluminaKitSupportMode, IndexAdapterKitSortField, IndexAdapterKitsService, IndexStrategy, InstrumentTypesService, KitDefinitionFormat, LibrariesService, LibraryPoolSortFields, LibraryPoolStatus, LibraryPoolsService, LibraryPrepKitSortFields, LibraryPrepKitsService, LibrarySortFields, LibraryStatus, ListAnalysisDatasetsIncludeFlags, ListAnalysisDefinitionsIncludeFlags, ListAnalysisVersionDefinitionsIncludeFlags, ListGenomesIncludeFlags, ListIndexAdapterKitsIncludeFlags, ListLibrariesIncludeFlags, ListLibraryPoolsIncludeFlags, ListLibraryPrepKitsIncludeFlags, ListSampleAssociatedAnalysisDatasetsIncludeFlags, ListSamplesIncludeFlags, ListSequencingRunAnalysisConfigurationFlags, ListSequencingRunsIncludeFlags, ParseSampleSheetIncludeFlags, PlannedRunsService, ReadType, ReferenceFilesService, RenderContext, RunMode, RunOrigin, RunStageProgress, SampleSheetsService, SampleSortFields, SampleStatus, SamplesService, SequencingRunAnalysisConfigurationSortFields, SequencingRunSortFields, SequencingRunsService, SortDirection, GssApiConfiguration as ɵa };

//# sourceMappingURL=stratus-gss-ng-sdk.js.map